import React, { useEffect, useState } from "react";
import styles from "./TyreChange.module.css";
import Select from "react-select";
import { post } from "../../components/api";
import DatePicker from "react-datepicker";
import { Button, Modal } from "react-bootstrap";
import { SweetAlert } from "../../helpers/helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const TyreChange = () => {
  const navigate = useNavigate();
  const [selectedTyre, setSelectedTyre] = useState([]);
  const [selectedNewTyre, setSelectedNewTyre] = useState([]);
  const [addedTyre, setAddedTyre] = useState([]);
  const [newAddedTyre, setNewAddedTyre] = useState([]);
  const [currentVehicle, setCurrentVehicle] = useState([]);
  const [newVehicle, setNewVehicle] = useState([]);
  const [date, setDate] = useState(new Date());
  const [show, setShow] = useState(false);
  const [currentSvg, setCurrentSvg] = useState(null);
  const [CurrentNewSvg, setCurrentNewSvg] = useState(null);
  const [vehicleList, setVehicleList] = useState([]);

  const fetchVehicleList = async () => {
    try {
      const result = await post("admin/Vehicle-tyres");
      if (result.status == 200) {
        const filteredArray = result.data.map((data) => {
          return {
            value: data._id,
            label: data.vehicleNo,
            tyreModel: data?.tyreModel,
          };
        });
        setVehicleList(filteredArray);
      } else {
        SweetAlert(result.message, true);
        setVehicleList([]);
      }
    } catch (error) {
      console.log(error.message || "Internal error while fetching vehicles.");
    }
  };
  useEffect(() => {
    fetchVehicleList();
  }, []);

  const handleSelection = (i, keyword) => {
    if (keyword === "current") {
      if (currentVehicle?.value) {
        if (addedTyre.includes(i) && !selectedTyre.includes(i)) {
          setSelectedTyre([i]);
        } else if (selectedTyre.includes(i)) {
          setSelectedTyre(selectedTyre.filter((data) => data !== i));
          setSelectedNewTyre([]);
        }
      } else {
        toast.error("please select vehicle first");
      }
    } else if (keyword === "new" && selectedTyre.length > 0) {
      if (newVehicle?.value) {
        if (!newAddedTyre.includes(i) && !selectedNewTyre.includes(i)) {
          setSelectedNewTyre([i]);
          setShow(true);
        } else if (selectedNewTyre.includes(i)) {
          setSelectedNewTyre(selectedNewTyre.filter((data) => data !== i));
        }
      } else {
        toast.error("please select vehicle first");
      }
    }
  };
  const fetchVehicle = async (vehicle, keyWord) => {
    const data = await post("admin/Tyre-positions-vehicle", {
      vehicleId: vehicle,
    });

    if (keyWord == "current") {
      setAddedTyre(data.data);
    } else {
      setNewAddedTyre(data.data);
    }
  };
  useEffect(() => {
    fetchVehicle(currentVehicle, "current");
  }, [currentVehicle]);
  useEffect(() => {
    fetchVehicle(newVehicle, "new");
  }, [newVehicle]);

  const handleSubmit = async () => {
    const data = await post("admin/tyre-assign-vehicle-new", {
      currentVehicle,
      selectedTyre,
      selectedNewTyre,
      newVehicle,
      date,
    });

    if (data.status == 200) {
      SweetAlert("tyre assign to new position", false);
      setTimeout(() => {
        navigate("/tyre-management");
      }, 1000);
    } else {
      SweetAlert(data.message || "error", true);
      setShow(false);
      setDate(new Date());
    }
  };

  const truck6 = ({ selectedTyre, addedTyre, handleSelection }) => {
    return (
      <svg
        width="272"
        height="256"
        viewBox="0 0 472 656"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M414.826 623.393C414.826 640.295 401.084 654.038 384.181 654.038H87.8185C70.9163 654.038 57.174 640.295 57.174 623.393V316.937H55.9009V623.393C55.9009 641 70.2229 655.322 87.8299 655.322H384.181C401.788 655.322 416.11 641 416.11 623.393V316.937H414.837V623.393H414.826ZM337.248 12.1624H134.763C91.2854 12.1624 55.9009 47.5354 55.9009 91.0242V192.324H57.174V91.0242C57.174 48.2401 91.9787 13.4354 134.763 13.4354H337.248C380.033 13.4354 414.837 48.2288 414.837 91.0242V192.324H416.11V91.0242C416.11 47.5354 380.737 12.1624 337.248 12.1624Z"
          fill="#231F20"
        />
        <path
          d="M404.437 621.688C404.437 634.157 394.286 644.296 381.817 644.296H90.1828C77.7136 644.296 67.5632 634.157 67.5632 621.688V316.937H66.2901V621.688C66.2901 634.862 77.0089 645.569 90.1828 645.569H381.817C395.002 645.569 405.71 634.862 405.71 621.688V316.937H404.437V621.688ZM334.896 21.8922H137.116C98.0599 21.8922 66.2901 53.6734 66.2901 92.7178V192.313H67.5632V92.7178C67.5632 54.3781 98.7646 23.1653 137.116 23.1653H334.896C373.235 23.1653 404.437 54.3781 404.437 92.7178V192.313H405.71V92.7178C405.71 53.6734 373.94 21.8922 334.896 21.8922Z"
          fill="#231F20"
        />
        <path
          opacity="0.6"
          d="M382.317 59.1521H85.386C98.0371 41.7838 118.531 30.4854 141.674 30.4854H325.245C348.615 30.4854 369.348 41.7611 382.317 59.1521Z"
          fill="#999999"
        />
        <path
          opacity="0.6"
          d="M175.615 12.7989H125.431C127.556 5.0468 131.023 0 134.933 0H165.964C169.92 0 173.421 5.03543 175.615 12.7989Z"
          fill="#999999"
        />
        <path
          opacity="0.6"
          d="M341.602 12.7989H291.418C293.555 5.0468 297.022 0 300.932 0H331.963C335.919 0 339.42 5.03543 341.613 12.7989H341.602Z"
          fill="#999999"
        />
        <path
          d="M458.963 91.8994H439.264C432.751 91.8994 427.466 97.1963 427.466 103.698V105.164H421.532C421.146 103.073 419.316 101.482 417.111 101.482C416.565 101.482 416.122 101.925 416.122 102.47V126.079C416.122 126.625 416.565 127.068 417.111 127.068C419.463 127.068 421.373 125.249 421.578 122.942L436.002 117.77H458.963C463.839 117.77 467.806 113.803 467.806 108.927V100.731C467.806 95.855 463.839 91.8881 458.963 91.8881V91.8994ZM421.612 120.828V107.165H427.466V116.792C427.466 117.338 427.909 117.781 428.455 117.781H430.114L421.612 120.828ZM465.817 108.938C465.817 112.723 462.748 115.792 458.963 115.792H429.455V103.698C429.455 98.2875 433.854 93.8772 439.276 93.8772H458.974C462.759 93.8772 465.828 96.9462 465.828 100.731V108.927L465.817 108.938Z"
          fill="#999999"
        />
        <path
          d="M459.042 96.1733H439.139C435.138 96.1733 431.887 99.4241 431.887 103.425V112.507C431.887 113.053 432.331 113.496 432.876 113.496H459.042C461.429 113.496 463.373 111.552 463.373 109.165V100.504C463.373 98.117 461.429 96.1733 459.042 96.1733Z"
          fill="#999999"
        />
        <path
          d="M13.0601 91.8994H32.7585C39.2716 91.8994 44.5571 97.1963 44.5571 103.698V105.164H50.4905C50.8769 103.073 52.707 101.482 54.9121 101.482C55.4577 101.482 55.901 101.925 55.901 102.47V126.079C55.901 126.625 55.4577 127.068 54.9121 127.068C52.5592 127.068 50.6496 125.249 50.445 122.942L36.0207 117.77H13.0601C8.18376 117.77 4.2168 113.803 4.2168 108.927V100.731C4.2168 95.855 8.18376 91.8881 13.0601 91.8881V91.8994ZM50.3995 120.828V107.165H44.5457V116.792C44.5457 117.338 44.1024 117.781 43.5568 117.781H41.8973L50.3995 120.828ZM6.20596 108.938C6.20596 112.723 9.27496 115.792 13.0601 115.792H42.5679V103.698C42.5679 98.2875 38.169 93.8772 32.7471 93.8772H13.0601C9.27496 93.8772 6.20596 96.9462 6.20596 100.731V108.927V108.938Z"
          fill="#999999"
        />
        <path
          d="M12.9691 96.1733H32.8721C36.8732 96.1733 40.1241 99.4241 40.1241 103.425V112.507C40.1241 113.053 39.6808 113.496 39.1352 113.496H12.9691C10.5821 113.496 8.63843 111.552 8.63843 109.165V100.504C8.63843 98.117 10.5821 96.1733 12.9691 96.1733Z"
          fill="#999999"
        />
        <path
          d="M66.6084 486.243H56.5716V553.056H66.6084V486.243Z"
          fill="#231F20"
        />
        <path
          d="M415.224 486.243H405.187V553.056H415.224V486.243Z"
          fill="#231F20"
        />
        <rect
          x="67"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(5) && selectedTyre?.includes(5)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(5)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(5, "current")}
          className="cursor-pointer"
          key={5}
        />
        <rect
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(4) && selectedTyre?.includes(4)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(4)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(4, "current")}
          className="cursor-pointer"
          key={4}
        />
        <rect
          x="349"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(3) && selectedTyre?.includes(3)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(3)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(3, "current")}
          className="cursor-pointer"
          key={3}
        />
        <rect
          x="416"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(2) && selectedTyre?.includes(2)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(2)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(2, "current")}
          className="cursor-pointer"
          key={2}
        />
        <rect
          x="382"
          y="192"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(1) && selectedTyre?.includes(1)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(1)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(1, "current")}
          className="cursor-pointer"
          key={1}
        />
        <rect
          x="34"
          y="192"
          width="56"
          height="126"
          rx="18"
          fill={
            addedTyre?.includes(6) && selectedTyre?.includes(6)
              ? "rgba(58, 165, 86, 1)"
              : addedTyre?.includes(6)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(6, "current")}
          className="cursor-pointer"
          key={6}
        />
        <path
          d="M408.89 269V248.29L404.178 249.544V245.44L411.094 242.4H414.21V269H408.89Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M434.9 533V529.238C436.521 527.946 438.092 526.654 439.612 525.362C441.157 524.07 442.538 522.791 443.754 521.524C444.97 520.232 445.933 518.978 446.642 517.762C447.351 516.546 447.706 515.368 447.706 514.228C447.706 513.519 447.579 512.873 447.326 512.29C447.073 511.682 446.667 511.201 446.11 510.846C445.578 510.466 444.869 510.276 443.982 510.276C443.095 510.276 442.348 510.479 441.74 510.884C441.132 511.289 440.676 511.834 440.372 512.518C440.068 513.177 439.916 513.924 439.916 514.76H434.938C435.014 512.809 435.457 511.175 436.268 509.858C437.079 508.541 438.168 507.565 439.536 506.932C440.904 506.273 442.437 505.944 444.134 505.944C446.009 505.944 447.592 506.299 448.884 507.008C450.176 507.692 451.151 508.629 451.81 509.82C452.494 511.011 452.836 512.379 452.836 513.924C452.836 515.089 452.621 516.229 452.19 517.344C451.785 518.459 451.202 519.548 450.442 520.612C449.707 521.651 448.871 522.651 447.934 523.614C446.997 524.577 446.021 525.501 445.008 526.388C443.995 527.249 443.007 528.06 442.044 528.82H453.482V533H434.9Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M377.4 533.456C375.677 533.456 374.094 533.139 372.65 532.506C371.206 531.873 370.053 530.91 369.192 529.618C368.331 528.326 367.875 526.692 367.824 524.716H372.84C372.865 525.552 373.055 526.312 373.41 526.996C373.765 527.655 374.284 528.187 374.968 528.592C375.652 528.972 376.463 529.162 377.4 529.162C378.287 529.162 379.047 528.985 379.68 528.63C380.313 528.275 380.795 527.807 381.124 527.224C381.453 526.641 381.618 525.97 381.618 525.21C381.618 524.323 381.39 523.589 380.934 523.006C380.503 522.398 379.895 521.942 379.11 521.638C378.35 521.334 377.476 521.182 376.488 521.182H374.512V516.964H376.488C377.729 516.964 378.768 516.673 379.604 516.09C380.465 515.507 380.896 514.633 380.896 513.468C380.896 512.505 380.579 511.733 379.946 511.15C379.338 510.567 378.477 510.276 377.362 510.276C376.146 510.276 375.196 510.631 374.512 511.34C373.828 512.049 373.448 512.923 373.372 513.962H368.356C368.432 512.29 368.85 510.859 369.61 509.668C370.395 508.452 371.447 507.527 372.764 506.894C374.081 506.261 375.614 505.944 377.362 505.944C379.211 505.944 380.769 506.273 382.036 506.932C383.328 507.565 384.303 508.427 384.962 509.516C385.621 510.605 385.95 511.783 385.95 513.05C385.95 514.089 385.747 515.013 385.342 515.824C384.962 516.635 384.443 517.306 383.784 517.838C383.125 518.37 382.403 518.75 381.618 518.978C382.606 519.181 383.467 519.573 384.202 520.156C384.962 520.713 385.545 521.435 385.95 522.322C386.381 523.209 386.596 524.235 386.596 525.4C386.596 526.844 386.241 528.187 385.532 529.428C384.848 530.644 383.809 531.619 382.416 532.354C381.048 533.089 379.376 533.456 377.4 533.456Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M29.782 533V528.174H16.71V524.108L29.098 506.4H34.912V523.728H38.37V528.174H34.912V533H29.782ZM22.182 523.728H30.124V512.062L22.182 523.728Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M94.122 533.456C92.1967 533.456 90.5247 533.114 89.106 532.43C87.7127 531.746 86.6233 530.809 85.838 529.618C85.0527 528.427 84.5967 527.072 84.47 525.552H89.486C89.6633 526.54 90.17 527.376 91.006 528.06C91.842 528.744 92.8933 529.086 94.16 529.086C95.072 529.086 95.87 528.858 96.554 528.402C97.238 527.946 97.77 527.338 98.15 526.578C98.53 525.793 98.72 524.906 98.72 523.918C98.72 522.905 98.5173 522.031 98.112 521.296C97.732 520.561 97.2 519.991 96.516 519.586C95.8573 519.181 95.0973 518.978 94.236 518.978C93.1467 518.978 92.2093 519.244 91.424 519.776C90.664 520.283 90.1193 520.903 89.79 521.638H84.812L87.016 506.4H101.95V510.884H90.816L89.714 516.812C90.2713 516.229 91.0187 515.761 91.956 515.406C92.8933 515.026 93.9447 514.836 95.11 514.836C96.554 514.836 97.808 515.089 98.872 515.596C99.936 516.077 100.823 516.749 101.532 517.61C102.241 518.446 102.773 519.409 103.128 520.498C103.483 521.562 103.66 522.689 103.66 523.88C103.66 525.273 103.419 526.553 102.938 527.718C102.482 528.883 101.823 529.897 100.962 530.758C100.126 531.619 99.1253 532.291 97.96 532.772C96.82 533.228 95.5407 533.456 94.122 533.456Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M63.616 269.456C61.6147 269.456 59.9173 269.089 58.524 268.354C57.156 267.619 56.054 266.631 55.218 265.39C54.4073 264.149 53.812 262.768 53.432 261.248C53.0773 259.703 52.9 258.145 52.9 256.574C52.9 253.585 53.318 251.001 54.154 248.822C54.99 246.643 56.1933 244.959 57.764 243.768C59.3347 242.552 61.2347 241.944 63.464 241.944C65.3387 241.944 66.922 242.311 68.214 243.046C69.506 243.755 70.5067 244.693 71.216 245.858C71.9253 247.023 72.3433 248.277 72.47 249.62H67.682C67.4793 248.505 67.0107 247.657 66.276 247.074C65.5413 246.466 64.5913 246.162 63.426 246.162C62.3367 246.162 61.3867 246.491 60.576 247.15C59.7653 247.809 59.132 248.797 58.676 250.114C58.2453 251.431 57.992 253.091 57.916 255.092C57.916 255.117 57.916 255.155 57.916 255.206C57.916 255.257 57.916 255.295 57.916 255.32C58.3213 254.636 58.8533 254.028 59.512 253.496C60.1707 252.964 60.9307 252.546 61.792 252.242C62.6533 251.938 63.5653 251.786 64.528 251.786C65.9973 251.786 67.3653 252.141 68.632 252.85C69.8987 253.559 70.9247 254.56 71.71 255.852C72.4953 257.144 72.888 258.677 72.888 260.45C72.888 262.046 72.4953 263.541 71.71 264.934C70.95 266.302 69.8733 267.404 68.48 268.24C67.0867 269.051 65.4653 269.456 63.616 269.456ZM63.312 265.048C64.224 265.048 65.022 264.858 65.706 264.478C66.4153 264.098 66.9727 263.579 67.378 262.92C67.7833 262.236 67.986 261.463 67.986 260.602C67.986 259.69 67.7833 258.905 67.378 258.246C66.9727 257.587 66.4153 257.068 65.706 256.688C64.9967 256.308 64.186 256.118 63.274 256.118C62.3873 256.118 61.5893 256.308 60.88 256.688C60.1707 257.068 59.6007 257.6 59.17 258.284C58.7647 258.943 58.562 259.703 58.562 260.564C58.562 261.451 58.7647 262.236 59.17 262.92C59.6007 263.579 60.1707 264.098 60.88 264.478C61.6147 264.858 62.4253 265.048 63.312 265.048Z"
          fill="white"
          fillOpacity="0.2"
        />
      </svg>
    );
  };
  const truck10 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="298"
      height="353"
      viewBox="0 0 428 683"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M371.35 654.35C371.35 669.22 359.26 681.31 344.39 681.31H83.6601C68.7901 681.31 56.7001 669.22 56.7001 654.35V278.83H55.5801V654.35C55.5801 669.84 68.1801 682.44 83.6701 682.44H344.39C359.88 682.44 372.48 669.84 372.48 654.35V278.83H371.36V654.35H371.35ZM303.09 10.7H124.95C86.7001 10.7 55.5701 41.82 55.5701 80.08V169.2H56.6901V80.08C56.6901 42.44 87.3101 11.82 124.95 11.82H303.09C340.73 11.82 371.35 42.43 371.35 80.08V169.2H372.47V80.08C372.47 41.82 341.35 10.7 303.09 10.7Z"
        fill="#231F20"
      />
      <path
        d="M362.21 652.84C362.21 663.81 353.28 672.73 342.31 672.73H85.74C74.77 672.73 65.84 663.81 65.84 652.84V278.83H64.72V652.84C64.72 664.43 74.15 673.85 85.74 673.85H342.31C353.91 673.85 363.33 664.43 363.33 652.84V278.83H362.21V652.84ZM301.03 19.26H127.03C92.67 19.26 64.72 47.22 64.72 81.57V169.19H65.84V81.57C65.84 47.84 93.29 20.38 127.03 20.38H301.03C334.76 20.38 362.21 47.84 362.21 81.57V169.19H363.33V81.57C363.33 47.22 335.38 19.26 301.03 19.26Z"
        fill="#231F20"
      />
      <path
        opacity="0.6"
        d="M342.75 52.04H81.52C92.65 36.76 110.68 26.82 131.04 26.82H292.54C313.1 26.82 331.34 36.74 342.75 52.04Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M160.89 11.26H116.74C118.62 4.44 121.67 0 125.11 0H152.41C155.89 0 158.97 4.43 160.9 11.26H160.89Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M306.93 11.26H262.78C264.65 4.44 267.7 0 271.14 0H298.44C301.92 0 305 4.43 306.93 11.26Z"
        fill="#999999"
      />
      <path
        d="M410.17 80.85H392.84C387.11 80.85 382.46 85.51 382.46 91.23V92.52H377.24C376.9 90.68 375.29 89.28 373.35 89.28C372.87 89.28 372.48 89.67 372.48 90.15V110.92C372.48 111.4 372.87 111.79 373.35 111.79C375.42 111.79 377.1 110.19 377.28 108.16L389.97 103.61H410.17C414.46 103.61 417.95 100.12 417.95 95.83V88.62C417.95 84.33 414.46 80.84 410.17 80.84V80.85ZM377.32 106.3V94.28H382.47V102.75C382.47 103.23 382.86 103.62 383.34 103.62H384.8L377.32 106.3ZM416.21 95.84C416.21 99.17 413.51 101.87 410.18 101.87H384.22V91.23C384.22 86.47 388.09 82.59 392.86 82.59H410.19C413.52 82.59 416.22 85.29 416.22 88.62V95.83L416.21 95.84Z"
        fill="#999999"
      />
      <path
        d="M410.25 84.61H392.74C389.22 84.61 386.36 87.47 386.36 90.99V98.98C386.36 99.46 386.75 99.85 387.23 99.85H410.25C412.35 99.85 414.06 98.14 414.06 96.04V88.42C414.06 86.32 412.35 84.61 410.25 84.61Z"
        fill="#999999"
      />
      <path
        d="M17.8801 80.85H35.2101C40.9401 80.85 45.5901 85.51 45.5901 91.23V92.52H50.8101C51.1501 90.68 52.7601 89.28 54.7001 89.28C55.1801 89.28 55.5701 89.67 55.5701 90.15V110.92C55.5701 111.4 55.1801 111.79 54.7001 111.79C52.6301 111.79 50.9501 110.19 50.7701 108.16L38.0801 103.61H17.8801C13.5901 103.61 10.1001 100.12 10.1001 95.83V88.62C10.1001 84.33 13.5901 80.84 17.8801 80.84V80.85ZM50.7401 106.3V94.28H45.5901V102.75C45.5901 103.23 45.2001 103.62 44.7201 103.62H43.2601L50.7401 106.3ZM11.8501 95.84C11.8501 99.17 14.5501 101.87 17.8801 101.87H43.8401V91.23C43.8401 86.47 39.9701 82.59 35.2001 82.59H17.8801C14.5501 82.59 11.8501 85.29 11.8501 88.62V95.83V95.84Z"
        fill="#999999"
      />
      <path
        d="M17.81 84.61H35.32C38.84 84.61 41.7 87.47 41.7 90.99V98.98C41.7 99.46 41.31 99.85 40.83 99.85H17.81C15.71 99.85 14 98.14 14 96.04V88.42C14 86.32 15.71 84.61 17.81 84.61Z"
        fill="#999999"
      />
      <path d="M64.7201 366.27H55.8901V425.05H64.7201V366.27Z" fill="#231F20" />
      <path d="M371.42 366.27H362.59V425.05H371.42V366.27Z" fill="#231F20" />
      <path d="M64.9899 529.72H56.1599V588.5H64.9899V529.72Z" fill="#231F20" />
      <path d="M371.69 529.72H362.86V588.5H371.69V529.72Z" fill="#231F20" />
      <rect
        x="307"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "current")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "current")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        x="372"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "current")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="65"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "current")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="307"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "current")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "current")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="372"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "current")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="339"
        y="159"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "current")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="33"
        y="159"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "current")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="65"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "current")}
        className="cursor-pointer"
        key={9}
      />
      <path
        d="M365.89 236V215.29L361.178 216.544V212.44L368.094 209.4H371.21V236H365.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M390.9 406V402.238C392.521 400.946 394.092 399.654 395.612 398.362C397.157 397.07 398.538 395.791 399.754 394.524C400.97 393.232 401.933 391.978 402.642 390.762C403.351 389.546 403.706 388.368 403.706 387.228C403.706 386.519 403.579 385.873 403.326 385.29C403.073 384.682 402.667 384.201 402.11 383.846C401.578 383.466 400.869 383.276 399.982 383.276C399.095 383.276 398.348 383.479 397.74 383.884C397.132 384.289 396.676 384.834 396.372 385.518C396.068 386.177 395.916 386.924 395.916 387.76H390.938C391.014 385.809 391.457 384.175 392.268 382.858C393.079 381.541 394.168 380.565 395.536 379.932C396.904 379.273 398.437 378.944 400.134 378.944C402.009 378.944 403.592 379.299 404.884 380.008C406.176 380.692 407.151 381.629 407.81 382.82C408.494 384.011 408.836 385.379 408.836 386.924C408.836 388.089 408.621 389.229 408.19 390.344C407.785 391.459 407.202 392.548 406.442 393.612C405.707 394.651 404.871 395.651 403.934 396.614C402.997 397.577 402.021 398.501 401.008 399.388C399.995 400.249 399.007 401.06 398.044 401.82H409.482V406H390.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M402.782 572V567.174H389.71V563.108L402.098 545.4H407.912V562.728H411.37V567.174H407.912V572H402.782ZM395.182 562.728H403.124V551.062L395.182 562.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M335.122 572.456C333.197 572.456 331.525 572.114 330.106 571.43C328.713 570.746 327.623 569.809 326.838 568.618C326.053 567.427 325.597 566.072 325.47 564.552H330.486C330.663 565.54 331.17 566.376 332.006 567.06C332.842 567.744 333.893 568.086 335.16 568.086C336.072 568.086 336.87 567.858 337.554 567.402C338.238 566.946 338.77 566.338 339.15 565.578C339.53 564.793 339.72 563.906 339.72 562.918C339.72 561.905 339.517 561.031 339.112 560.296C338.732 559.561 338.2 558.991 337.516 558.586C336.857 558.181 336.097 557.978 335.236 557.978C334.147 557.978 333.209 558.244 332.424 558.776C331.664 559.283 331.119 559.903 330.79 560.638H325.812L328.016 545.4H342.95V549.884H331.816L330.714 555.812C331.271 555.229 332.019 554.761 332.956 554.406C333.893 554.026 334.945 553.836 336.11 553.836C337.554 553.836 338.808 554.089 339.872 554.596C340.936 555.077 341.823 555.749 342.532 556.61C343.241 557.446 343.773 558.409 344.128 559.498C344.483 560.562 344.66 561.689 344.66 562.88C344.66 564.273 344.419 565.553 343.938 566.718C343.482 567.883 342.823 568.897 341.962 569.758C341.126 570.619 340.125 571.291 338.96 571.772C337.82 572.228 336.541 572.456 335.122 572.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M334.4 407.456C332.677 407.456 331.094 407.139 329.65 406.506C328.206 405.873 327.053 404.91 326.192 403.618C325.331 402.326 324.875 400.692 324.824 398.716H329.84C329.865 399.552 330.055 400.312 330.41 400.996C330.765 401.655 331.284 402.187 331.968 402.592C332.652 402.972 333.463 403.162 334.4 403.162C335.287 403.162 336.047 402.985 336.68 402.63C337.313 402.275 337.795 401.807 338.124 401.224C338.453 400.641 338.618 399.97 338.618 399.21C338.618 398.323 338.39 397.589 337.934 397.006C337.503 396.398 336.895 395.942 336.11 395.638C335.35 395.334 334.476 395.182 333.488 395.182H331.512V390.964H333.488C334.729 390.964 335.768 390.673 336.604 390.09C337.465 389.507 337.896 388.633 337.896 387.468C337.896 386.505 337.579 385.733 336.946 385.15C336.338 384.567 335.477 384.276 334.362 384.276C333.146 384.276 332.196 384.631 331.512 385.34C330.828 386.049 330.448 386.923 330.372 387.962H325.356C325.432 386.29 325.85 384.859 326.61 383.668C327.395 382.452 328.447 381.527 329.764 380.894C331.081 380.261 332.614 379.944 334.362 379.944C336.211 379.944 337.769 380.273 339.036 380.932C340.328 381.565 341.303 382.427 341.962 383.516C342.621 384.605 342.95 385.783 342.95 387.05C342.95 388.089 342.747 389.013 342.342 389.824C341.962 390.635 341.443 391.306 340.784 391.838C340.125 392.37 339.403 392.75 338.618 392.978C339.606 393.181 340.467 393.573 341.202 394.156C341.962 394.713 342.545 395.435 342.95 396.322C343.381 397.209 343.596 398.235 343.596 399.4C343.596 400.844 343.241 402.187 342.532 403.428C341.848 404.644 340.809 405.619 339.416 406.354C338.048 407.089 336.376 407.456 334.4 407.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.616 571.456C25.6147 571.456 23.9173 571.089 22.524 570.354C21.156 569.619 20.054 568.631 19.218 567.39C18.4073 566.149 17.812 564.768 17.432 563.248C17.0773 561.703 16.9 560.145 16.9 558.574C16.9 555.585 17.318 553.001 18.154 550.822C18.99 548.643 20.1933 546.959 21.764 545.768C23.3347 544.552 25.2347 543.944 27.464 543.944C29.3387 543.944 30.922 544.311 32.214 545.046C33.506 545.755 34.5067 546.693 35.216 547.858C35.9253 549.023 36.3433 550.277 36.47 551.62H31.682C31.4793 550.505 31.0107 549.657 30.276 549.074C29.5413 548.466 28.5913 548.162 27.426 548.162C26.3367 548.162 25.3867 548.491 24.576 549.15C23.7653 549.809 23.132 550.797 22.676 552.114C22.2453 553.431 21.992 555.091 21.916 557.092C21.916 557.117 21.916 557.155 21.916 557.206C21.916 557.257 21.916 557.295 21.916 557.32C22.3213 556.636 22.8533 556.028 23.512 555.496C24.1707 554.964 24.9307 554.546 25.792 554.242C26.6533 553.938 27.5653 553.786 28.528 553.786C29.9973 553.786 31.3653 554.141 32.632 554.85C33.8987 555.559 34.9247 556.56 35.71 557.852C36.4953 559.144 36.888 560.677 36.888 562.45C36.888 564.046 36.4953 565.541 35.71 566.934C34.95 568.302 33.8733 569.404 32.48 570.24C31.0867 571.051 29.4653 571.456 27.616 571.456ZM27.312 567.048C28.224 567.048 29.022 566.858 29.706 566.478C30.4153 566.098 30.9727 565.579 31.378 564.92C31.7833 564.236 31.986 563.463 31.986 562.602C31.986 561.69 31.7833 560.905 31.378 560.246C30.9727 559.587 30.4153 559.068 29.706 558.688C28.9967 558.308 28.186 558.118 27.274 558.118C26.3873 558.118 25.5893 558.308 24.88 558.688C24.1707 559.068 23.6007 559.6 23.17 560.284C22.7647 560.943 22.562 561.703 22.562 562.564C22.562 563.451 22.7647 564.236 23.17 564.92C23.6007 565.579 24.1707 566.098 24.88 566.478C25.6147 566.858 26.4253 567.048 27.312 567.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M88.218 571L97.984 548.77H85.102V544.4H103.228V548.01L93.538 571H88.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.008 406.456C25.2093 406.456 23.5627 406.127 22.068 405.468C20.5987 404.809 19.4333 403.885 18.572 402.694C17.7107 401.503 17.28 400.123 17.28 398.552C17.28 397.463 17.4573 396.475 17.812 395.588C18.192 394.701 18.7113 393.916 19.37 393.232C20.0287 392.548 20.814 392.029 21.726 391.674C20.586 391.142 19.6613 390.382 18.952 389.394C18.268 388.406 17.926 387.291 17.926 386.05C17.926 384.809 18.268 383.643 18.952 382.554C19.636 381.465 20.6493 380.591 21.992 379.932C23.3347 379.273 25.0067 378.944 27.008 378.944C29.0093 378.944 30.6813 379.273 32.024 379.932C33.3667 380.591 34.38 381.465 35.064 382.554C35.748 383.643 36.09 384.809 36.09 386.05C36.09 387.266 35.7353 388.381 35.026 389.394C34.342 390.382 33.43 391.142 32.29 391.674C33.202 392.054 33.9873 392.586 34.646 393.27C35.33 393.929 35.8493 394.701 36.204 395.588C36.584 396.475 36.774 397.463 36.774 398.552C36.774 400.123 36.3307 401.503 35.444 402.694C34.5827 403.885 33.4173 404.809 31.948 405.468C30.4787 406.127 28.832 406.456 27.008 406.456ZM27.008 402.162C28.5787 402.162 29.7567 401.782 30.542 401.022C31.3273 400.262 31.72 399.299 31.72 398.134C31.72 396.842 31.302 395.829 30.466 395.094C29.6553 394.334 28.5027 393.954 27.008 393.954C25.5387 393.954 24.3733 394.334 23.512 395.094C22.676 395.829 22.258 396.842 22.258 398.134C22.258 399.299 22.6633 400.262 23.474 401.022C24.2847 401.782 25.4627 402.162 27.008 402.162ZM27.008 390.192C28.3 390.192 29.288 389.863 29.972 389.204C30.6813 388.545 31.036 387.697 31.036 386.658C31.036 385.543 30.6813 384.682 29.972 384.074C29.288 383.441 28.3 383.124 27.008 383.124C25.7413 383.124 24.7533 383.441 24.044 384.074C23.3347 384.682 22.98 385.556 22.98 386.696C22.98 387.709 23.3347 388.545 24.044 389.204C24.7533 389.863 25.7413 390.192 27.008 390.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M91.628 406.456C89.7787 406.456 88.208 406.101 86.916 405.392C85.624 404.657 84.6233 403.707 83.914 402.542C83.23 401.377 82.812 400.123 82.66 398.78H87.448C87.676 399.895 88.1447 400.756 88.854 401.364C89.5887 401.947 90.5387 402.238 91.704 402.238C92.7933 402.238 93.7307 401.921 94.516 401.288C95.3267 400.629 95.96 399.654 96.416 398.362C96.872 397.045 97.1253 395.423 97.176 393.498C97.176 393.422 97.176 393.346 97.176 393.27C97.176 393.194 97.176 393.131 97.176 393.08C96.8213 393.739 96.302 394.347 95.618 394.904C94.934 395.436 94.1613 395.854 93.3 396.158C92.464 396.462 91.5647 396.614 90.602 396.614C89.158 396.614 87.79 396.259 86.498 395.55C85.206 394.841 84.1673 393.84 83.382 392.548C82.5967 391.256 82.204 389.723 82.204 387.95C82.204 386.329 82.5967 384.834 83.382 383.466C84.1673 382.098 85.2567 381.009 86.65 380.198C88.0433 379.362 89.652 378.944 91.476 378.944C93.5027 378.944 95.2 379.311 96.568 380.046C97.936 380.781 99.0253 381.769 99.836 383.01C100.672 384.251 101.267 385.645 101.622 387.19C102.002 388.71 102.192 390.255 102.192 391.826C102.192 394.79 101.774 397.374 100.938 399.578C100.127 401.757 98.9367 403.454 97.366 404.67C95.7953 405.861 93.8827 406.456 91.628 406.456ZM91.818 392.282C92.73 392.282 93.528 392.092 94.212 391.712C94.9213 391.332 95.4787 390.813 95.884 390.154C96.3147 389.47 96.53 388.697 96.53 387.836C96.53 386.949 96.3147 386.164 95.884 385.48C95.4787 384.796 94.9213 384.277 94.212 383.922C93.5027 383.542 92.692 383.352 91.78 383.352C90.8933 383.352 90.0953 383.542 89.386 383.922C88.6767 384.302 88.1193 384.821 87.714 385.48C87.334 386.139 87.144 386.911 87.144 387.798C87.144 388.685 87.334 389.47 87.714 390.154C88.1193 390.813 88.6767 391.332 89.386 391.712C90.0953 392.092 90.906 392.282 91.818 392.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 234V213.29L41.178 214.544V210.44L48.094 207.4H51.21V234H45.89ZM67.2178 234.456C64.8111 234.456 62.7338 233.873 60.9858 232.708C59.2378 231.543 57.8951 229.934 56.9578 227.882C56.0458 225.805 55.5898 223.411 55.5898 220.7C55.5898 217.989 56.0458 215.608 56.9578 213.556C57.8951 211.479 59.2251 209.857 60.9478 208.692C62.6958 207.527 64.7858 206.944 67.2178 206.944C69.6498 206.944 71.7271 207.527 73.4498 208.692C75.1978 209.857 76.5278 211.479 77.4398 213.556C78.3771 215.608 78.8458 217.989 78.8458 220.7C78.8458 223.411 78.3771 225.805 77.4398 227.882C76.5278 229.934 75.1978 231.543 73.4498 232.708C71.7271 233.873 69.6498 234.456 67.2178 234.456ZM67.2178 229.858C68.4845 229.858 69.5991 229.491 70.5618 228.756C71.5245 227.996 72.2718 226.932 72.8038 225.564C73.3611 224.196 73.6398 222.575 73.6398 220.7C73.6398 218.8 73.3611 217.179 72.8038 215.836C72.2718 214.468 71.5245 213.417 70.5618 212.682C69.5991 211.947 68.4845 211.58 67.2178 211.58C65.9511 211.58 64.8365 211.947 63.8738 212.682C62.9111 213.417 62.1511 214.468 61.5938 215.836C61.0618 217.179 60.7958 218.8 60.7958 220.7C60.7958 222.575 61.0618 224.196 61.5938 225.564C62.1511 226.932 62.9111 227.996 63.8738 228.756C64.8365 229.491 65.9511 229.858 67.2178 229.858Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truck12 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="228"
      height="606"
      viewBox="0 0 428 806"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-80px" }}
    >
      <path
        d="M303.09 10.7H124.95C86.6998 10.7 55.5698 41.82 55.5698 80.08V169.2H56.6998V80.08C56.6998 42.44 87.3198 11.82 124.95 11.82H303.09C340.73 11.82 371.35 42.44 371.35 80.08V169.2H372.47V80.08C372.47 41.82 341.35 10.7 303.09 10.7ZM371.35 777.68C371.35 792.55 359.25 804.65 344.38 804.65H83.6598C68.7898 804.65 56.6998 792.55 56.6998 777.68V420.04H55.5698V777.68C55.5698 793.17 68.1698 805.77 83.6598 805.77H344.38C359.87 805.77 372.47 793.17 372.47 777.68V420.04H371.35V777.68ZM371.35 278.84V310.24H372.47V278.84H371.35ZM56.6998 278.84H55.5698V310.24H56.6998V278.84Z"
        fill="#231F20"
      />
      <path
        d="M301.02 19.27H127.03C92.66 19.27 64.71 47.23 64.71 81.58V169.2H65.84V81.58C65.84 47.85 93.28 20.39 127.03 20.39H301.02C334.76 20.39 362.2 47.85 362.2 81.58V169.2H363.33V81.58C363.33 47.23 335.38 19.27 301.02 19.27ZM362.2 776.18C362.2 787.15 353.28 796.07 342.3 796.07H85.74C74.76 796.07 65.84 787.15 65.84 776.18V420.04H64.71V776.18C64.71 787.77 74.15 797.19 85.74 797.19H342.3C353.91 797.19 363.33 787.77 363.33 776.18V420.04H362.2V776.18ZM362.2 278.84V310.24H363.33V278.84H362.2ZM65.84 278.84H64.71V310.24H65.84V278.84Z"
        fill="#231F20"
      />
      <path
        opacity="0.6"
        d="M342.75 52.04H81.52C92.65 36.76 110.68 26.82 131.04 26.82H292.54C313.1 26.82 331.34 36.74 342.75 52.04Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M160.89 11.26H116.74C118.62 4.44 121.67 0 125.11 0H152.41C155.89 0 158.97 4.43 160.9 11.26H160.89Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M306.93 11.26H262.78C264.65 4.44 267.7 0 271.14 0H298.44C301.92 0 305 4.43 306.93 11.26Z"
        fill="#999999"
      />
      <path
        d="M410.17 80.85H392.84C387.11 80.85 382.46 85.51 382.46 91.23V92.52H377.24C376.9 90.68 375.29 89.28 373.35 89.28C372.87 89.28 372.48 89.67 372.48 90.15V110.92C372.48 111.4 372.87 111.79 373.35 111.79C375.42 111.79 377.1 110.19 377.28 108.16L389.97 103.61H410.17C414.46 103.61 417.95 100.12 417.95 95.83V88.62C417.95 84.33 414.46 80.84 410.17 80.84V80.85ZM377.32 106.3V94.28H382.47V102.75C382.47 103.23 382.86 103.62 383.34 103.62H384.8L377.32 106.3ZM416.21 95.84C416.21 99.17 413.51 101.87 410.18 101.87H384.22V91.23C384.22 86.47 388.09 82.59 392.86 82.59H410.19C413.52 82.59 416.22 85.29 416.22 88.62V95.83L416.21 95.84Z"
        fill="#999999"
      />
      <path
        d="M410.25 84.61H392.74C389.22 84.61 386.36 87.47 386.36 90.99V98.98C386.36 99.46 386.75 99.85 387.23 99.85H410.25C412.35 99.85 414.06 98.14 414.06 96.04V88.42C414.06 86.32 412.35 84.61 410.25 84.61Z"
        fill="#999999"
      />
      <path
        d="M17.8801 80.85H35.2101C40.9401 80.85 45.5901 85.51 45.5901 91.23V92.52H50.8101C51.1501 90.68 52.7601 89.28 54.7001 89.28C55.1801 89.28 55.5701 89.67 55.5701 90.15V110.92C55.5701 111.4 55.1801 111.79 54.7001 111.79C52.6301 111.79 50.9501 110.19 50.7701 108.16L38.0801 103.61H17.8801C13.5901 103.61 10.1001 100.12 10.1001 95.83V88.62C10.1001 84.33 13.5901 80.84 17.8801 80.84V80.85ZM50.7401 106.3V94.28H45.5901V102.75C45.5901 103.23 45.2001 103.62 44.7201 103.62H43.2601L50.7401 106.3ZM11.8501 95.84C11.8501 99.17 14.5501 101.87 17.8801 101.87H43.8401V91.23C43.8401 86.47 39.9701 82.59 35.2001 82.59H17.8801C14.5501 82.59 11.8501 85.29 11.8501 88.62V95.83V95.84Z"
        fill="#999999"
      />
      <path
        d="M17.81 84.61H35.32C38.84 84.61 41.7 87.47 41.7 90.99V98.98C41.7 99.46 41.31 99.85 40.83 99.85H17.81C15.71 99.85 14 98.14 14 96.04V88.42C14 86.32 15.71 84.61 17.81 84.61Z"
        fill="#999999"
      />
      <path d="M64.7201 507.27H55.8901V566.05H64.7201V507.27Z" fill="#231F20" />
      <path d="M371.42 507.27H362.59V566.05H371.42V507.27Z" fill="#231F20" />
      <path d="M64.9902 668.72H56.1602V727.5H64.9902V668.72Z" fill="#231F20" />
      <path d="M371.69 668.72H362.86V727.5H371.69V668.72Z" fill="#231F20" />
      <rect
        x="306"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "current")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "current")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "current")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="307"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "current")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="371"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "current")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="65"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "current")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="65"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "current")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="372"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "current")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="339"
        y="302"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "current")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="339"
        y="160"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "current")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="33"
        y="160"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(12) && selectedTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "current")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="33"
        y="302"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(11) && selectedTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "current")}
        className="cursor-pointer"
        key={11}
      />
      <path
        d="M365.89 237V216.29L361.178 217.544V213.44L368.094 210.4H371.21V237H365.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M357.9 378V374.238C359.521 372.946 361.092 371.654 362.612 370.362C364.157 369.07 365.538 367.791 366.754 366.524C367.97 365.232 368.933 363.978 369.642 362.762C370.351 361.546 370.706 360.368 370.706 359.228C370.706 358.519 370.579 357.873 370.326 357.29C370.073 356.682 369.667 356.201 369.11 355.846C368.578 355.466 367.869 355.276 366.982 355.276C366.095 355.276 365.348 355.479 364.74 355.884C364.132 356.289 363.676 356.834 363.372 357.518C363.068 358.177 362.916 358.924 362.916 359.76H357.938C358.014 357.809 358.457 356.175 359.268 354.858C360.079 353.541 361.168 352.565 362.536 351.932C363.904 351.273 365.437 350.944 367.134 350.944C369.009 350.944 370.592 351.299 371.884 352.008C373.176 352.692 374.151 353.629 374.81 354.82C375.494 356.011 375.836 357.379 375.836 358.924C375.836 360.089 375.621 361.229 375.19 362.344C374.785 363.459 374.202 364.548 373.442 365.612C372.707 366.651 371.871 367.651 370.934 368.614C369.997 369.577 369.021 370.501 368.008 371.388C366.995 372.249 366.007 373.06 365.044 373.82H376.482V378H357.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M400.4 551.456C398.677 551.456 397.094 551.139 395.65 550.506C394.206 549.873 393.053 548.91 392.192 547.618C391.331 546.326 390.875 544.692 390.824 542.716H395.84C395.865 543.552 396.055 544.312 396.41 544.996C396.765 545.655 397.284 546.187 397.968 546.592C398.652 546.972 399.463 547.162 400.4 547.162C401.287 547.162 402.047 546.985 402.68 546.63C403.313 546.275 403.795 545.807 404.124 545.224C404.453 544.641 404.618 543.97 404.618 543.21C404.618 542.323 404.39 541.589 403.934 541.006C403.503 540.398 402.895 539.942 402.11 539.638C401.35 539.334 400.476 539.182 399.488 539.182H397.512V534.964H399.488C400.729 534.964 401.768 534.673 402.604 534.09C403.465 533.507 403.896 532.633 403.896 531.468C403.896 530.505 403.579 529.733 402.946 529.15C402.338 528.567 401.477 528.276 400.362 528.276C399.146 528.276 398.196 528.631 397.512 529.34C396.828 530.049 396.448 530.923 396.372 531.962H391.356C391.432 530.29 391.85 528.859 392.61 527.668C393.395 526.452 394.447 525.527 395.764 524.894C397.081 524.261 398.614 523.944 400.362 523.944C402.211 523.944 403.769 524.273 405.036 524.932C406.328 525.565 407.303 526.427 407.962 527.516C408.621 528.605 408.95 529.783 408.95 531.05C408.95 532.089 408.747 533.013 408.342 533.824C407.962 534.635 407.443 535.306 406.784 535.838C406.125 536.37 405.403 536.75 404.618 536.978C405.606 537.181 406.467 537.573 407.202 538.156C407.962 538.713 408.545 539.435 408.95 540.322C409.381 541.209 409.596 542.235 409.596 543.4C409.596 544.844 409.241 546.187 408.532 547.428C407.848 548.644 406.809 549.619 405.416 550.354C404.048 551.089 402.376 551.456 400.4 551.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M337.782 551V546.174H324.71V542.108L337.098 524.4H342.912V541.728H346.37V546.174H342.912V551H337.782ZM330.182 541.728H338.124V530.062L330.182 541.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M399.122 711.456C397.197 711.456 395.525 711.114 394.106 710.43C392.713 709.746 391.623 708.809 390.838 707.618C390.053 706.427 389.597 705.072 389.47 703.552H394.486C394.663 704.54 395.17 705.376 396.006 706.06C396.842 706.744 397.893 707.086 399.16 707.086C400.072 707.086 400.87 706.858 401.554 706.402C402.238 705.946 402.77 705.338 403.15 704.578C403.53 703.793 403.72 702.906 403.72 701.918C403.72 700.905 403.517 700.031 403.112 699.296C402.732 698.561 402.2 697.991 401.516 697.586C400.857 697.181 400.097 696.978 399.236 696.978C398.147 696.978 397.209 697.244 396.424 697.776C395.664 698.283 395.119 698.903 394.79 699.638H389.812L392.016 684.4H406.95V688.884H395.816L394.714 694.812C395.271 694.229 396.019 693.761 396.956 693.406C397.893 693.026 398.945 692.836 400.11 692.836C401.554 692.836 402.808 693.089 403.872 693.596C404.936 694.077 405.823 694.749 406.532 695.61C407.241 696.446 407.773 697.409 408.128 698.498C408.483 699.562 408.66 700.689 408.66 701.88C408.66 703.273 408.419 704.553 407.938 705.718C407.482 706.883 406.823 707.897 405.962 708.758C405.126 709.619 404.125 710.291 402.96 710.772C401.82 711.228 400.541 711.456 399.122 711.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M335.616 711.456C333.615 711.456 331.917 711.089 330.524 710.354C329.156 709.619 328.054 708.631 327.218 707.39C326.407 706.149 325.812 704.768 325.432 703.248C325.077 701.703 324.9 700.145 324.9 698.574C324.9 695.585 325.318 693.001 326.154 690.822C326.99 688.643 328.193 686.959 329.764 685.768C331.335 684.552 333.235 683.944 335.464 683.944C337.339 683.944 338.922 684.311 340.214 685.046C341.506 685.755 342.507 686.693 343.216 687.858C343.925 689.023 344.343 690.277 344.47 691.62H339.682C339.479 690.505 339.011 689.657 338.276 689.074C337.541 688.466 336.591 688.162 335.426 688.162C334.337 688.162 333.387 688.491 332.576 689.15C331.765 689.809 331.132 690.797 330.676 692.114C330.245 693.431 329.992 695.091 329.916 697.092C329.916 697.117 329.916 697.155 329.916 697.206C329.916 697.257 329.916 697.295 329.916 697.32C330.321 696.636 330.853 696.028 331.512 695.496C332.171 694.964 332.931 694.546 333.792 694.242C334.653 693.938 335.565 693.786 336.528 693.786C337.997 693.786 339.365 694.141 340.632 694.85C341.899 695.559 342.925 696.56 343.71 697.852C344.495 699.144 344.888 700.677 344.888 702.45C344.888 704.046 344.495 705.541 343.71 706.934C342.95 708.302 341.873 709.404 340.48 710.24C339.087 711.051 337.465 711.456 335.616 711.456ZM335.312 707.048C336.224 707.048 337.022 706.858 337.706 706.478C338.415 706.098 338.973 705.579 339.378 704.92C339.783 704.236 339.986 703.463 339.986 702.602C339.986 701.69 339.783 700.905 339.378 700.246C338.973 699.587 338.415 699.068 337.706 698.688C336.997 698.308 336.186 698.118 335.274 698.118C334.387 698.118 333.589 698.308 332.88 698.688C332.171 699.068 331.601 699.6 331.17 700.284C330.765 700.943 330.562 701.703 330.562 702.564C330.562 703.451 330.765 704.236 331.17 704.92C331.601 705.579 332.171 706.098 332.88 706.478C333.615 706.858 334.425 707.048 335.312 707.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M21.218 712L30.984 689.77H18.102V685.4H36.228V689.01L26.538 712H21.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M94.008 712.456C92.2093 712.456 90.5627 712.127 89.068 711.468C87.5987 710.809 86.4333 709.885 85.572 708.694C84.7107 707.503 84.28 706.123 84.28 704.552C84.28 703.463 84.4573 702.475 84.812 701.588C85.192 700.701 85.7113 699.916 86.37 699.232C87.0287 698.548 87.814 698.029 88.726 697.674C87.586 697.142 86.6613 696.382 85.952 695.394C85.268 694.406 84.926 693.291 84.926 692.05C84.926 690.809 85.268 689.643 85.952 688.554C86.636 687.465 87.6493 686.591 88.992 685.932C90.3347 685.273 92.0067 684.944 94.008 684.944C96.0093 684.944 97.6813 685.273 99.024 685.932C100.367 686.591 101.38 687.465 102.064 688.554C102.748 689.643 103.09 690.809 103.09 692.05C103.09 693.266 102.735 694.381 102.026 695.394C101.342 696.382 100.43 697.142 99.29 697.674C100.202 698.054 100.987 698.586 101.646 699.27C102.33 699.929 102.849 700.701 103.204 701.588C103.584 702.475 103.774 703.463 103.774 704.552C103.774 706.123 103.331 707.503 102.444 708.694C101.583 709.885 100.417 710.809 98.948 711.468C97.4787 712.127 95.832 712.456 94.008 712.456ZM94.008 708.162C95.5787 708.162 96.7567 707.782 97.542 707.022C98.3273 706.262 98.72 705.299 98.72 704.134C98.72 702.842 98.302 701.829 97.466 701.094C96.6553 700.334 95.5027 699.954 94.008 699.954C92.5387 699.954 91.3733 700.334 90.512 701.094C89.676 701.829 89.258 702.842 89.258 704.134C89.258 705.299 89.6633 706.262 90.474 707.022C91.2847 707.782 92.4627 708.162 94.008 708.162ZM94.008 696.192C95.3 696.192 96.288 695.863 96.972 695.204C97.6813 694.545 98.036 693.697 98.036 692.658C98.036 691.543 97.6813 690.682 96.972 690.074C96.288 689.441 95.3 689.124 94.008 689.124C92.7413 689.124 91.7533 689.441 91.044 690.074C90.3347 690.682 89.98 691.556 89.98 692.696C89.98 693.709 90.3347 694.545 91.044 695.204C91.7533 695.863 92.7413 696.192 94.008 696.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M28.628 551.456C26.7787 551.456 25.208 551.101 23.916 550.392C22.624 549.657 21.6233 548.707 20.914 547.542C20.23 546.377 19.812 545.123 19.66 543.78H24.448C24.676 544.895 25.1447 545.756 25.854 546.364C26.5887 546.947 27.5387 547.238 28.704 547.238C29.7933 547.238 30.7307 546.921 31.516 546.288C32.3267 545.629 32.96 544.654 33.416 543.362C33.872 542.045 34.1253 540.423 34.176 538.498C34.176 538.422 34.176 538.346 34.176 538.27C34.176 538.194 34.176 538.131 34.176 538.08C33.8213 538.739 33.302 539.347 32.618 539.904C31.934 540.436 31.1613 540.854 30.3 541.158C29.464 541.462 28.5647 541.614 27.602 541.614C26.158 541.614 24.79 541.259 23.498 540.55C22.206 539.841 21.1673 538.84 20.382 537.548C19.5967 536.256 19.204 534.723 19.204 532.95C19.204 531.329 19.5967 529.834 20.382 528.466C21.1673 527.098 22.2567 526.009 23.65 525.198C25.0433 524.362 26.652 523.944 28.476 523.944C30.5027 523.944 32.2 524.311 33.568 525.046C34.936 525.781 36.0253 526.769 36.836 528.01C37.672 529.251 38.2673 530.645 38.622 532.19C39.002 533.71 39.192 535.255 39.192 536.826C39.192 539.79 38.774 542.374 37.938 544.578C37.1273 546.757 35.9367 548.454 34.366 549.67C32.7953 550.861 30.8827 551.456 28.628 551.456ZM28.818 537.282C29.73 537.282 30.528 537.092 31.212 536.712C31.9213 536.332 32.4787 535.813 32.884 535.154C33.3147 534.47 33.53 533.697 33.53 532.836C33.53 531.949 33.3147 531.164 32.884 530.48C32.4787 529.796 31.9213 529.277 31.212 528.922C30.5027 528.542 29.692 528.352 28.78 528.352C27.8933 528.352 27.0953 528.542 26.386 528.922C25.6767 529.302 25.1193 529.821 24.714 530.48C24.334 531.139 24.144 531.911 24.144 532.798C24.144 533.685 24.334 534.47 24.714 535.154C25.1193 535.813 25.6767 536.332 26.386 536.712C27.0953 537.092 27.906 537.282 28.818 537.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M77.89 550V529.29L73.178 530.544V526.44L80.094 523.4H83.21V550H77.89ZM99.2178 550.456C96.8111 550.456 94.7338 549.873 92.9858 548.708C91.2378 547.543 89.8951 545.934 88.9578 543.882C88.0458 541.805 87.5898 539.411 87.5898 536.7C87.5898 533.989 88.0458 531.608 88.9578 529.556C89.8951 527.479 91.2251 525.857 92.9478 524.692C94.6958 523.527 96.7858 522.944 99.2178 522.944C101.65 522.944 103.727 523.527 105.45 524.692C107.198 525.857 108.528 527.479 109.44 529.556C110.377 531.608 110.846 533.989 110.846 536.7C110.846 539.411 110.377 541.805 109.44 543.882C108.528 545.934 107.198 547.543 105.45 548.708C103.727 549.873 101.65 550.456 99.2178 550.456ZM99.2178 545.858C100.484 545.858 101.599 545.491 102.562 544.756C103.524 543.996 104.272 542.932 104.804 541.564C105.361 540.196 105.64 538.575 105.64 536.7C105.64 534.8 105.361 533.179 104.804 531.836C104.272 530.468 103.524 529.417 102.562 528.682C101.599 527.947 100.484 527.58 99.2178 527.58C97.9511 527.58 96.8365 527.947 95.8738 528.682C94.9111 529.417 94.1511 530.468 93.5938 531.836C93.0618 533.179 92.7958 534.8 92.7958 536.7C92.7958 538.575 93.0618 540.196 93.5938 541.564C94.1511 542.932 94.9111 543.996 95.8738 544.756C96.8365 545.491 97.9511 545.858 99.2178 545.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M52.89 379V358.29L48.178 359.544V355.44L55.094 352.4H58.21V379H52.89ZM66.7318 379V358.29L62.0198 359.544V355.44L68.9358 352.4H72.0518V379H66.7318Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M48.89 237V216.29L44.178 217.544V213.44L51.094 210.4H54.21V237H48.89ZM58.7418 237V233.238C60.3631 231.946 61.9338 230.654 63.4538 229.362C64.9991 228.07 66.3798 226.791 67.5958 225.524C68.8118 224.232 69.7745 222.978 70.4838 221.762C71.1931 220.546 71.5478 219.368 71.5478 218.228C71.5478 217.519 71.4211 216.873 71.1678 216.29C70.9145 215.682 70.5091 215.201 69.9518 214.846C69.4198 214.466 68.7105 214.276 67.8238 214.276C66.9371 214.276 66.1898 214.479 65.5818 214.884C64.9738 215.289 64.5178 215.834 64.2138 216.518C63.9098 217.177 63.7578 217.924 63.7578 218.76H58.7798C58.8558 216.809 59.2991 215.175 60.1098 213.858C60.9205 212.541 62.0098 211.565 63.3778 210.932C64.7458 210.273 66.2785 209.944 67.9758 209.944C69.8505 209.944 71.4338 210.299 72.7258 211.008C74.0178 211.692 74.9931 212.629 75.6518 213.82C76.3358 215.011 76.6778 216.379 76.6778 217.924C76.6778 219.089 76.4625 220.229 76.0318 221.344C75.6265 222.459 75.0438 223.548 74.2838 224.612C73.5491 225.651 72.7131 226.651 71.7758 227.614C70.8385 228.577 69.8631 229.501 68.8498 230.388C67.8365 231.249 66.8485 232.06 65.8858 232.82H77.3238V237H58.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truck14 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-60px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <g opacity="0.6">
        <path
          d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M384.534 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.534C386.475 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.475 78.1924 384.534 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "current")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "current")}
        className="cursor-pointer"
        key={6}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "current")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "current")}
        className="cursor-pointer"
        key={4}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "current")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(11) && selectedTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "current")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "current")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "current")}
        className="cursor-pointer"
        key={9}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="262"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "current")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="320"
        y="403"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "current")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "current")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="264"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(13) && selectedTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "current")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="31"
        y="405"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(12) && selectedTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "current")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(14) && selectedTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "current")}
        className="cursor-pointer"
        key={14}
      />
      <path
        d="M346.89 197V176.29L342.178 177.544V173.44L349.094 170.4H352.21V197H346.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M338.9 338V334.238C340.521 332.946 342.092 331.654 343.612 330.362C345.157 329.07 346.538 327.791 347.754 326.524C348.97 325.232 349.933 323.978 350.642 322.762C351.351 321.546 351.706 320.368 351.706 319.228C351.706 318.519 351.579 317.873 351.326 317.29C351.073 316.682 350.667 316.201 350.11 315.846C349.578 315.466 348.869 315.276 347.982 315.276C347.095 315.276 346.348 315.479 345.74 315.884C345.132 316.289 344.676 316.834 344.372 317.518C344.068 318.177 343.916 318.924 343.916 319.76H338.938C339.014 317.809 339.457 316.175 340.268 314.858C341.079 313.541 342.168 312.565 343.536 311.932C344.904 311.273 346.437 310.944 348.134 310.944C350.009 310.944 351.592 311.299 352.884 312.008C354.176 312.692 355.151 313.629 355.81 314.82C356.494 316.011 356.836 317.379 356.836 318.924C356.836 320.089 356.621 321.229 356.19 322.344C355.785 323.459 355.202 324.548 354.442 325.612C353.707 326.651 352.871 327.651 351.934 328.614C350.997 329.577 350.021 330.501 349.008 331.388C347.995 332.249 347.007 333.06 346.044 333.82H357.482V338H338.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M347.4 480.456C345.677 480.456 344.094 480.139 342.65 479.506C341.206 478.873 340.053 477.91 339.192 476.618C338.331 475.326 337.875 473.692 337.824 471.716H342.84C342.865 472.552 343.055 473.312 343.41 473.996C343.765 474.655 344.284 475.187 344.968 475.592C345.652 475.972 346.463 476.162 347.4 476.162C348.287 476.162 349.047 475.985 349.68 475.63C350.313 475.275 350.795 474.807 351.124 474.224C351.453 473.641 351.618 472.97 351.618 472.21C351.618 471.323 351.39 470.589 350.934 470.006C350.503 469.398 349.895 468.942 349.11 468.638C348.35 468.334 347.476 468.182 346.488 468.182H344.512V463.964H346.488C347.729 463.964 348.768 463.673 349.604 463.09C350.465 462.507 350.896 461.633 350.896 460.468C350.896 459.505 350.579 458.733 349.946 458.15C349.338 457.567 348.477 457.276 347.362 457.276C346.146 457.276 345.196 457.631 344.512 458.34C343.828 459.049 343.448 459.923 343.372 460.962H338.356C338.432 459.29 338.85 457.859 339.61 456.668C340.395 455.452 341.447 454.527 342.764 453.894C344.081 453.261 345.614 452.944 347.362 452.944C349.211 452.944 350.769 453.273 352.036 453.932C353.328 454.565 354.303 455.427 354.962 456.516C355.621 457.605 355.95 458.783 355.95 460.05C355.95 461.089 355.747 462.013 355.342 462.824C354.962 463.635 354.443 464.306 353.784 464.838C353.125 465.37 352.403 465.75 351.618 465.978C352.606 466.181 353.467 466.573 354.202 467.156C354.962 467.713 355.545 468.435 355.95 469.322C356.381 470.209 356.596 471.235 356.596 472.4C356.596 473.844 356.241 475.187 355.532 476.428C354.848 477.644 353.809 478.619 352.416 479.354C351.048 480.089 349.376 480.456 347.4 480.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M383.782 663V658.174H370.71V654.108L383.098 636.4H388.912V653.728H392.37V658.174H388.912V663H383.782ZM376.182 653.728H384.124V642.062L376.182 653.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.122 662.456C311.197 662.456 309.525 662.114 308.106 661.43C306.713 660.746 305.623 659.809 304.838 658.618C304.053 657.427 303.597 656.072 303.47 654.552H308.486C308.663 655.54 309.17 656.376 310.006 657.06C310.842 657.744 311.893 658.086 313.16 658.086C314.072 658.086 314.87 657.858 315.554 657.402C316.238 656.946 316.77 656.338 317.15 655.578C317.53 654.793 317.72 653.906 317.72 652.918C317.72 651.905 317.517 651.031 317.112 650.296C316.732 649.561 316.2 648.991 315.516 648.586C314.857 648.181 314.097 647.978 313.236 647.978C312.147 647.978 311.209 648.244 310.424 648.776C309.664 649.283 309.119 649.903 308.79 650.638H303.812L306.016 635.4H320.95V639.884H309.816L308.714 645.812C309.271 645.229 310.019 644.761 310.956 644.406C311.893 644.026 312.945 643.836 314.11 643.836C315.554 643.836 316.808 644.089 317.872 644.596C318.936 645.077 319.823 645.749 320.532 646.61C321.241 647.446 321.773 648.409 322.128 649.498C322.483 650.562 322.66 651.689 322.66 652.88C322.66 654.273 322.419 655.553 321.938 656.718C321.482 657.883 320.823 658.897 319.962 659.758C319.126 660.619 318.125 661.291 316.96 661.772C315.82 662.228 314.541 662.456 313.122 662.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M380.616 823.456C378.615 823.456 376.917 823.089 375.524 822.354C374.156 821.619 373.054 820.631 372.218 819.39C371.407 818.149 370.812 816.768 370.432 815.248C370.077 813.703 369.9 812.145 369.9 810.574C369.9 807.585 370.318 805.001 371.154 802.822C371.99 800.643 373.193 798.959 374.764 797.768C376.335 796.552 378.235 795.944 380.464 795.944C382.339 795.944 383.922 796.311 385.214 797.046C386.506 797.755 387.507 798.693 388.216 799.858C388.925 801.023 389.343 802.277 389.47 803.62H384.682C384.479 802.505 384.011 801.657 383.276 801.074C382.541 800.466 381.591 800.162 380.426 800.162C379.337 800.162 378.387 800.491 377.576 801.15C376.765 801.809 376.132 802.797 375.676 804.114C375.245 805.431 374.992 807.091 374.916 809.092C374.916 809.117 374.916 809.155 374.916 809.206C374.916 809.257 374.916 809.295 374.916 809.32C375.321 808.636 375.853 808.028 376.512 807.496C377.171 806.964 377.931 806.546 378.792 806.242C379.653 805.938 380.565 805.786 381.528 805.786C382.997 805.786 384.365 806.141 385.632 806.85C386.899 807.559 387.925 808.56 388.71 809.852C389.495 811.144 389.888 812.677 389.888 814.45C389.888 816.046 389.495 817.541 388.71 818.934C387.95 820.302 386.873 821.404 385.48 822.24C384.087 823.051 382.465 823.456 380.616 823.456ZM380.312 819.048C381.224 819.048 382.022 818.858 382.706 818.478C383.415 818.098 383.973 817.579 384.378 816.92C384.783 816.236 384.986 815.463 384.986 814.602C384.986 813.69 384.783 812.905 384.378 812.246C383.973 811.587 383.415 811.068 382.706 810.688C381.997 810.308 381.186 810.118 380.274 810.118C379.387 810.118 378.589 810.308 377.88 810.688C377.171 811.068 376.601 811.6 376.17 812.284C375.765 812.943 375.562 813.703 375.562 814.564C375.562 815.451 375.765 816.236 376.17 816.92C376.601 817.579 377.171 818.098 377.88 818.478C378.615 818.858 379.425 819.048 380.312 819.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M309.218 824L318.984 801.77H306.102V797.4H324.228V801.01L314.538 824H309.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M29.008 824.456C27.2093 824.456 25.5627 824.127 24.068 823.468C22.5987 822.809 21.4333 821.885 20.572 820.694C19.7107 819.503 19.28 818.123 19.28 816.552C19.28 815.463 19.4573 814.475 19.812 813.588C20.192 812.701 20.7113 811.916 21.37 811.232C22.0287 810.548 22.814 810.029 23.726 809.674C22.586 809.142 21.6613 808.382 20.952 807.394C20.268 806.406 19.926 805.291 19.926 804.05C19.926 802.809 20.268 801.643 20.952 800.554C21.636 799.465 22.6493 798.591 23.992 797.932C25.3347 797.273 27.0067 796.944 29.008 796.944C31.0093 796.944 32.6813 797.273 34.024 797.932C35.3667 798.591 36.38 799.465 37.064 800.554C37.748 801.643 38.09 802.809 38.09 804.05C38.09 805.266 37.7353 806.381 37.026 807.394C36.342 808.382 35.43 809.142 34.29 809.674C35.202 810.054 35.9873 810.586 36.646 811.27C37.33 811.929 37.8493 812.701 38.204 813.588C38.584 814.475 38.774 815.463 38.774 816.552C38.774 818.123 38.3307 819.503 37.444 820.694C36.5827 821.885 35.4173 822.809 33.948 823.468C32.4787 824.127 30.832 824.456 29.008 824.456ZM29.008 820.162C30.5787 820.162 31.7567 819.782 32.542 819.022C33.3273 818.262 33.72 817.299 33.72 816.134C33.72 814.842 33.302 813.829 32.466 813.094C31.6553 812.334 30.5027 811.954 29.008 811.954C27.5387 811.954 26.3733 812.334 25.512 813.094C24.676 813.829 24.258 814.842 24.258 816.134C24.258 817.299 24.6633 818.262 25.474 819.022C26.2847 819.782 27.4627 820.162 29.008 820.162ZM29.008 808.192C30.3 808.192 31.288 807.863 31.972 807.204C32.6813 806.545 33.036 805.697 33.036 804.658C33.036 803.543 32.6813 802.682 31.972 802.074C31.288 801.441 30.3 801.124 29.008 801.124C27.7413 801.124 26.7533 801.441 26.044 802.074C25.3347 802.682 24.98 803.556 24.98 804.696C24.98 805.709 25.3347 806.545 26.044 807.204C26.7533 807.863 27.7413 808.192 29.008 808.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M93.628 824.456C91.7787 824.456 90.208 824.101 88.916 823.392C87.624 822.657 86.6233 821.707 85.914 820.542C85.23 819.377 84.812 818.123 84.66 816.78H89.448C89.676 817.895 90.1447 818.756 90.854 819.364C91.5887 819.947 92.5387 820.238 93.704 820.238C94.7933 820.238 95.7307 819.921 96.516 819.288C97.3267 818.629 97.96 817.654 98.416 816.362C98.872 815.045 99.1253 813.423 99.176 811.498C99.176 811.422 99.176 811.346 99.176 811.27C99.176 811.194 99.176 811.131 99.176 811.08C98.8213 811.739 98.302 812.347 97.618 812.904C96.934 813.436 96.1613 813.854 95.3 814.158C94.464 814.462 93.5647 814.614 92.602 814.614C91.158 814.614 89.79 814.259 88.498 813.55C87.206 812.841 86.1673 811.84 85.382 810.548C84.5967 809.256 84.204 807.723 84.204 805.95C84.204 804.329 84.5967 802.834 85.382 801.466C86.1673 800.098 87.2567 799.009 88.65 798.198C90.0433 797.362 91.652 796.944 93.476 796.944C95.5027 796.944 97.2 797.311 98.568 798.046C99.936 798.781 101.025 799.769 101.836 801.01C102.672 802.251 103.267 803.645 103.622 805.19C104.002 806.71 104.192 808.255 104.192 809.826C104.192 812.79 103.774 815.374 102.938 817.578C102.127 819.757 100.937 821.454 99.366 822.67C97.7953 823.861 95.8827 824.456 93.628 824.456ZM93.818 810.282C94.73 810.282 95.528 810.092 96.212 809.712C96.9213 809.332 97.4787 808.813 97.884 808.154C98.3147 807.47 98.53 806.697 98.53 805.836C98.53 804.949 98.3147 804.164 97.884 803.48C97.4787 802.796 96.9213 802.277 96.212 801.922C95.5027 801.542 94.692 801.352 93.78 801.352C92.8933 801.352 92.0953 801.542 91.386 801.922C90.6767 802.302 90.1193 802.821 89.714 803.48C89.334 804.139 89.144 804.911 89.144 805.798C89.144 806.685 89.334 807.47 89.714 808.154C90.1193 808.813 90.6767 809.332 91.386 809.712C92.0953 810.092 92.906 810.282 93.818 810.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 662V641.29L8.178 642.544V638.44L15.094 635.4H18.21V662H12.89ZM34.2178 662.456C31.8111 662.456 29.7338 661.873 27.9858 660.708C26.2378 659.543 24.8951 657.934 23.9578 655.882C23.0458 653.805 22.5898 651.411 22.5898 648.7C22.5898 645.989 23.0458 643.608 23.9578 641.556C24.8951 639.479 26.2251 637.857 27.9478 636.692C29.6958 635.527 31.7858 634.944 34.2178 634.944C36.6498 634.944 38.7271 635.527 40.4498 636.692C42.1978 637.857 43.5278 639.479 44.4398 641.556C45.3771 643.608 45.8458 645.989 45.8458 648.7C45.8458 651.411 45.3771 653.805 44.4398 655.882C43.5278 657.934 42.1978 659.543 40.4498 660.708C38.7271 661.873 36.6498 662.456 34.2178 662.456ZM34.2178 657.858C35.4845 657.858 36.5991 657.491 37.5618 656.756C38.5245 655.996 39.2718 654.932 39.8038 653.564C40.3611 652.196 40.6398 650.575 40.6398 648.7C40.6398 646.8 40.3611 645.179 39.8038 643.836C39.2718 642.468 38.5245 641.417 37.5618 640.682C36.5991 639.947 35.4845 639.58 34.2178 639.58C32.9511 639.58 31.8365 639.947 30.8738 640.682C29.9111 641.417 29.1511 642.468 28.5938 643.836C28.0618 645.179 27.7958 646.8 27.7958 648.7C27.7958 650.575 28.0618 652.196 28.5938 653.564C29.1511 654.932 29.9111 655.996 30.8738 656.756C31.8365 657.491 32.9511 657.858 34.2178 657.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M86.89 663V642.29L82.178 643.544V639.44L89.094 636.4H92.21V663H86.89ZM100.732 663V642.29L96.0198 643.544V639.44L102.936 636.4H106.052V663H100.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 481V460.29L42.178 461.544V457.44L49.094 454.4H52.21V481H46.89ZM56.7418 481V477.238C58.3631 475.946 59.9338 474.654 61.4538 473.362C62.9991 472.07 64.3798 470.791 65.5958 469.524C66.8118 468.232 67.7745 466.978 68.4838 465.762C69.1931 464.546 69.5478 463.368 69.5478 462.228C69.5478 461.519 69.4211 460.873 69.1678 460.29C68.9145 459.682 68.5091 459.201 67.9518 458.846C67.4198 458.466 66.7105 458.276 65.8238 458.276C64.9371 458.276 64.1898 458.479 63.5818 458.884C62.9738 459.289 62.5178 459.834 62.2138 460.518C61.9098 461.177 61.7578 461.924 61.7578 462.76H56.7798C56.8558 460.809 57.2991 459.175 58.1098 457.858C58.9205 456.541 60.0098 455.565 61.3778 454.932C62.7458 454.273 64.2785 453.944 65.9758 453.944C67.8505 453.944 69.4338 454.299 70.7258 455.008C72.0178 455.692 72.9931 456.629 73.6518 457.82C74.3358 459.011 74.6778 460.379 74.6778 461.924C74.6778 463.089 74.4625 464.229 74.0318 465.344C73.6265 466.459 73.0438 467.548 72.2838 468.612C71.5491 469.651 70.7131 470.651 69.7758 471.614C68.8385 472.577 67.8631 473.501 66.8498 474.388C65.8365 475.249 64.8485 476.06 63.8858 476.82H75.3238V481H56.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 340V319.29L42.178 320.544V316.44L49.094 313.4H52.21V340H46.89ZM66.2418 340.456C64.5191 340.456 62.9358 340.139 61.4918 339.506C60.0478 338.873 58.8951 337.91 58.0338 336.618C57.1725 335.326 56.7165 333.692 56.6658 331.716H61.6818C61.7071 332.552 61.8971 333.312 62.2518 333.996C62.6065 334.655 63.1258 335.187 63.8098 335.592C64.4938 335.972 65.3045 336.162 66.2418 336.162C67.1285 336.162 67.8885 335.985 68.5218 335.63C69.1551 335.275 69.6365 334.807 69.9658 334.224C70.2951 333.641 70.4598 332.97 70.4598 332.21C70.4598 331.323 70.2318 330.589 69.7758 330.006C69.3451 329.398 68.7371 328.942 67.9518 328.638C67.1918 328.334 66.3178 328.182 65.3298 328.182H63.3538V323.964H65.3298C66.5711 323.964 67.6098 323.673 68.4458 323.09C69.3071 322.507 69.7378 321.633 69.7378 320.468C69.7378 319.505 69.4211 318.733 68.7878 318.15C68.1798 317.567 67.3185 317.276 66.2038 317.276C64.9878 317.276 64.0378 317.631 63.3538 318.34C62.6698 319.049 62.2898 319.923 62.2138 320.962H57.1978C57.2738 319.29 57.6918 317.859 58.4518 316.668C59.2371 315.452 60.2885 314.527 61.6058 313.894C62.9231 313.261 64.4558 312.944 66.2038 312.944C68.0531 312.944 69.6111 313.273 70.8778 313.932C72.1698 314.565 73.1451 315.427 73.8038 316.516C74.4625 317.605 74.7918 318.783 74.7918 320.05C74.7918 321.089 74.5891 322.013 74.1838 322.824C73.8038 323.635 73.2845 324.306 72.6258 324.838C71.9671 325.37 71.2451 325.75 70.4598 325.978C71.4478 326.181 72.3091 326.573 73.0438 327.156C73.8038 327.713 74.3865 328.435 74.7918 329.322C75.2225 330.209 75.4378 331.235 75.4378 332.4C75.4378 333.844 75.0831 335.187 74.3738 336.428C73.6898 337.644 72.6511 338.619 71.2578 339.354C69.8898 340.089 68.2178 340.456 66.2418 340.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 200V179.29L41.178 180.544V176.44L48.094 173.4H51.21V200H45.89ZM68.6238 200V195.174H55.5518V191.108L67.9398 173.4H73.7538V190.728H77.2118V195.174H73.7538V200H68.6238ZM61.0238 190.728H68.9658V179.062L61.0238 190.728Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truck16 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-40px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <g opacity="0.6">
        <path
          d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M384.535 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.535C386.476 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.476 78.1924 384.535 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "current")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "current")}
        className="cursor-pointer"
        key={7}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "current")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "current")}
        className="cursor-pointer"
        key={5}
      />
      <path d="M352 461H343V515H352V461Z" fill="#231F20" />
      <rect
        x="286"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "current")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="353"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "current")}
        className="cursor-pointer"
        key={3}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(11) && selectedTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "current")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(12) && selectedTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "current")}
        className="cursor-pointer"
        key={12}
      />
      <path d="M66 461H57V515H66V461Z" fill="#231F20" />
      <rect
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(13) && selectedTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "current")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="67"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(14) && selectedTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "current")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "current")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "current")}
        className="cursor-pointer"
        key={10}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="262"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "current")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "current")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="264"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(15) && selectedTyre?.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(15)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "current")}
        className="cursor-pointer"
        key={15}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(16) && selectedTyre?.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(16)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "current")}
        className="cursor-pointer"
        key={16}
      />
      <path
        d="M346.89 198V177.29L342.178 178.544V174.44L349.094 171.4H352.21V198H346.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M338.9 338V334.238C340.521 332.946 342.092 331.654 343.612 330.362C345.157 329.07 346.538 327.791 347.754 326.524C348.97 325.232 349.933 323.978 350.642 322.762C351.351 321.546 351.706 320.368 351.706 319.228C351.706 318.519 351.579 317.873 351.326 317.29C351.073 316.682 350.667 316.201 350.11 315.846C349.578 315.466 348.869 315.276 347.982 315.276C347.095 315.276 346.348 315.479 345.74 315.884C345.132 316.289 344.676 316.834 344.372 317.518C344.068 318.177 343.916 318.924 343.916 319.76H338.938C339.014 317.809 339.457 316.175 340.268 314.858C341.079 313.541 342.168 312.565 343.536 311.932C344.904 311.273 346.437 310.944 348.134 310.944C350.009 310.944 351.592 311.299 352.884 312.008C354.176 312.692 355.151 313.629 355.81 314.82C356.494 316.011 356.836 317.379 356.836 318.924C356.836 320.089 356.621 321.229 356.19 322.344C355.785 323.459 355.202 324.548 354.442 325.612C353.707 326.651 352.871 327.651 351.934 328.614C350.997 329.577 350.021 330.501 349.008 331.388C347.995 332.249 347.007 333.06 346.044 333.82H357.482V338H338.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.4 501.456C379.677 501.456 378.094 501.139 376.65 500.506C375.206 499.873 374.053 498.91 373.192 497.618C372.331 496.326 371.875 494.692 371.824 492.716H376.84C376.865 493.552 377.055 494.312 377.41 494.996C377.765 495.655 378.284 496.187 378.968 496.592C379.652 496.972 380.463 497.162 381.4 497.162C382.287 497.162 383.047 496.985 383.68 496.63C384.313 496.275 384.795 495.807 385.124 495.224C385.453 494.641 385.618 493.97 385.618 493.21C385.618 492.323 385.39 491.589 384.934 491.006C384.503 490.398 383.895 489.942 383.11 489.638C382.35 489.334 381.476 489.182 380.488 489.182H378.512V484.964H380.488C381.729 484.964 382.768 484.673 383.604 484.09C384.465 483.507 384.896 482.633 384.896 481.468C384.896 480.505 384.579 479.733 383.946 479.15C383.338 478.567 382.477 478.276 381.362 478.276C380.146 478.276 379.196 478.631 378.512 479.34C377.828 480.049 377.448 480.923 377.372 481.962H372.356C372.432 480.29 372.85 478.859 373.61 477.668C374.395 476.452 375.447 475.527 376.764 474.894C378.081 474.261 379.614 473.944 381.362 473.944C383.211 473.944 384.769 474.273 386.036 474.932C387.328 475.565 388.303 476.427 388.962 477.516C389.621 478.605 389.95 479.783 389.95 481.05C389.95 482.089 389.747 483.013 389.342 483.824C388.962 484.635 388.443 485.306 387.784 485.838C387.125 486.37 386.403 486.75 385.618 486.978C386.606 487.181 387.467 487.573 388.202 488.156C388.962 488.713 389.545 489.435 389.95 490.322C390.381 491.209 390.596 492.235 390.596 493.4C390.596 494.844 390.241 496.187 389.532 497.428C388.848 498.644 387.809 499.619 386.416 500.354C385.048 501.089 383.376 501.456 381.4 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M316.782 501V496.174H303.71V492.108L316.098 474.4H321.912V491.728H325.37V496.174H321.912V501H316.782ZM309.182 491.728H317.124V480.062L309.182 491.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.122 663.456C379.197 663.456 377.525 663.114 376.106 662.43C374.713 661.746 373.623 660.809 372.838 659.618C372.053 658.427 371.597 657.072 371.47 655.552H376.486C376.663 656.54 377.17 657.376 378.006 658.06C378.842 658.744 379.893 659.086 381.16 659.086C382.072 659.086 382.87 658.858 383.554 658.402C384.238 657.946 384.77 657.338 385.15 656.578C385.53 655.793 385.72 654.906 385.72 653.918C385.72 652.905 385.517 652.031 385.112 651.296C384.732 650.561 384.2 649.991 383.516 649.586C382.857 649.181 382.097 648.978 381.236 648.978C380.147 648.978 379.209 649.244 378.424 649.776C377.664 650.283 377.119 650.903 376.79 651.638H371.812L374.016 636.4H388.95V640.884H377.816L376.714 646.812C377.271 646.229 378.019 645.761 378.956 645.406C379.893 645.026 380.945 644.836 382.11 644.836C383.554 644.836 384.808 645.089 385.872 645.596C386.936 646.077 387.823 646.749 388.532 647.61C389.241 648.446 389.773 649.409 390.128 650.498C390.483 651.562 390.66 652.689 390.66 653.88C390.66 655.273 390.419 656.553 389.938 657.718C389.482 658.883 388.823 659.897 387.962 660.758C387.126 661.619 386.125 662.291 384.96 662.772C383.82 663.228 382.541 663.456 381.122 663.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M314.616 663.456C312.615 663.456 310.917 663.089 309.524 662.354C308.156 661.619 307.054 660.631 306.218 659.39C305.407 658.149 304.812 656.768 304.432 655.248C304.077 653.703 303.9 652.145 303.9 650.574C303.9 647.585 304.318 645.001 305.154 642.822C305.99 640.643 307.193 638.959 308.764 637.768C310.335 636.552 312.235 635.944 314.464 635.944C316.339 635.944 317.922 636.311 319.214 637.046C320.506 637.755 321.507 638.693 322.216 639.858C322.925 641.023 323.343 642.277 323.47 643.62H318.682C318.479 642.505 318.011 641.657 317.276 641.074C316.541 640.466 315.591 640.162 314.426 640.162C313.337 640.162 312.387 640.491 311.576 641.15C310.765 641.809 310.132 642.797 309.676 644.114C309.245 645.431 308.992 647.091 308.916 649.092C308.916 649.117 308.916 649.155 308.916 649.206C308.916 649.257 308.916 649.295 308.916 649.32C309.321 648.636 309.853 648.028 310.512 647.496C311.171 646.964 311.931 646.546 312.792 646.242C313.653 645.938 314.565 645.786 315.528 645.786C316.997 645.786 318.365 646.141 319.632 646.85C320.899 647.559 321.925 648.56 322.71 649.852C323.495 651.144 323.888 652.677 323.888 654.45C323.888 656.046 323.495 657.541 322.71 658.934C321.95 660.302 320.873 661.404 319.48 662.24C318.087 663.051 316.465 663.456 314.616 663.456ZM314.312 659.048C315.224 659.048 316.022 658.858 316.706 658.478C317.415 658.098 317.973 657.579 318.378 656.92C318.783 656.236 318.986 655.463 318.986 654.602C318.986 653.69 318.783 652.905 318.378 652.246C317.973 651.587 317.415 651.068 316.706 650.688C315.997 650.308 315.186 650.118 314.274 650.118C313.387 650.118 312.589 650.308 311.88 650.688C311.171 651.068 310.601 651.6 310.17 652.284C309.765 652.943 309.562 653.703 309.562 654.564C309.562 655.451 309.765 656.236 310.17 656.92C310.601 657.579 311.171 658.098 311.88 658.478C312.615 658.858 313.425 659.048 314.312 659.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M374.218 824L383.984 801.77H371.102V797.4H389.228V801.01L379.538 824H374.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M314.008 824.456C312.209 824.456 310.563 824.127 309.068 823.468C307.599 822.809 306.433 821.885 305.572 820.694C304.711 819.503 304.28 818.123 304.28 816.552C304.28 815.463 304.457 814.475 304.812 813.588C305.192 812.701 305.711 811.916 306.37 811.232C307.029 810.548 307.814 810.029 308.726 809.674C307.586 809.142 306.661 808.382 305.952 807.394C305.268 806.406 304.926 805.291 304.926 804.05C304.926 802.809 305.268 801.643 305.952 800.554C306.636 799.465 307.649 798.591 308.992 797.932C310.335 797.273 312.007 796.944 314.008 796.944C316.009 796.944 317.681 797.273 319.024 797.932C320.367 798.591 321.38 799.465 322.064 800.554C322.748 801.643 323.09 802.809 323.09 804.05C323.09 805.266 322.735 806.381 322.026 807.394C321.342 808.382 320.43 809.142 319.29 809.674C320.202 810.054 320.987 810.586 321.646 811.27C322.33 811.929 322.849 812.701 323.204 813.588C323.584 814.475 323.774 815.463 323.774 816.552C323.774 818.123 323.331 819.503 322.444 820.694C321.583 821.885 320.417 822.809 318.948 823.468C317.479 824.127 315.832 824.456 314.008 824.456ZM314.008 820.162C315.579 820.162 316.757 819.782 317.542 819.022C318.327 818.262 318.72 817.299 318.72 816.134C318.72 814.842 318.302 813.829 317.466 813.094C316.655 812.334 315.503 811.954 314.008 811.954C312.539 811.954 311.373 812.334 310.512 813.094C309.676 813.829 309.258 814.842 309.258 816.134C309.258 817.299 309.663 818.262 310.474 819.022C311.285 819.782 312.463 820.162 314.008 820.162ZM314.008 808.192C315.3 808.192 316.288 807.863 316.972 807.204C317.681 806.545 318.036 805.697 318.036 804.658C318.036 803.543 317.681 802.682 316.972 802.074C316.288 801.441 315.3 801.124 314.008 801.124C312.741 801.124 311.753 801.441 311.044 802.074C310.335 802.682 309.98 803.556 309.98 804.696C309.98 805.709 310.335 806.545 311.044 807.204C311.753 807.863 312.741 808.192 314.008 808.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.628 823.456C25.7787 823.456 24.208 823.101 22.916 822.392C21.624 821.657 20.6233 820.707 19.914 819.542C19.23 818.377 18.812 817.123 18.66 815.78H23.448C23.676 816.895 24.1447 817.756 24.854 818.364C25.5887 818.947 26.5387 819.238 27.704 819.238C28.7933 819.238 29.7307 818.921 30.516 818.288C31.3267 817.629 31.96 816.654 32.416 815.362C32.872 814.045 33.1253 812.423 33.176 810.498C33.176 810.422 33.176 810.346 33.176 810.27C33.176 810.194 33.176 810.131 33.176 810.08C32.8213 810.739 32.302 811.347 31.618 811.904C30.934 812.436 30.1613 812.854 29.3 813.158C28.464 813.462 27.5647 813.614 26.602 813.614C25.158 813.614 23.79 813.259 22.498 812.55C21.206 811.841 20.1673 810.84 19.382 809.548C18.5967 808.256 18.204 806.723 18.204 804.95C18.204 803.329 18.5967 801.834 19.382 800.466C20.1673 799.098 21.2567 798.009 22.65 797.198C24.0433 796.362 25.652 795.944 27.476 795.944C29.5027 795.944 31.2 796.311 32.568 797.046C33.936 797.781 35.0253 798.769 35.836 800.01C36.672 801.251 37.2673 802.645 37.622 804.19C38.002 805.71 38.192 807.255 38.192 808.826C38.192 811.79 37.774 814.374 36.938 816.578C36.1273 818.757 34.9367 820.454 33.366 821.67C31.7953 822.861 29.8827 823.456 27.628 823.456ZM27.818 809.282C28.73 809.282 29.528 809.092 30.212 808.712C30.9213 808.332 31.4787 807.813 31.884 807.154C32.3147 806.47 32.53 805.697 32.53 804.836C32.53 803.949 32.3147 803.164 31.884 802.48C31.4787 801.796 30.9213 801.277 30.212 800.922C29.5027 800.542 28.692 800.352 27.78 800.352C26.8933 800.352 26.0953 800.542 25.386 800.922C24.6767 801.302 24.1193 801.821 23.714 802.48C23.334 803.139 23.144 803.911 23.144 804.798C23.144 805.685 23.334 806.47 23.714 807.154C24.1193 807.813 24.6767 808.332 25.386 808.712C26.0953 809.092 26.906 809.282 27.818 809.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M79.89 824V803.29L75.178 804.544V800.44L82.094 797.4H85.21V824H79.89ZM101.218 824.456C98.8111 824.456 96.7338 823.873 94.9858 822.708C93.2378 821.543 91.8951 819.934 90.9578 817.882C90.0458 815.805 89.5898 813.411 89.5898 810.7C89.5898 807.989 90.0458 805.608 90.9578 803.556C91.8951 801.479 93.2251 799.857 94.9478 798.692C96.6958 797.527 98.7858 796.944 101.218 796.944C103.65 796.944 105.727 797.527 107.45 798.692C109.198 799.857 110.528 801.479 111.44 803.556C112.377 805.608 112.846 807.989 112.846 810.7C112.846 813.411 112.377 815.805 111.44 817.882C110.528 819.934 109.198 821.543 107.45 822.708C105.727 823.873 103.65 824.456 101.218 824.456ZM101.218 819.858C102.484 819.858 103.599 819.491 104.562 818.756C105.524 817.996 106.272 816.932 106.804 815.564C107.361 814.196 107.64 812.575 107.64 810.7C107.64 808.8 107.361 807.179 106.804 805.836C106.272 804.468 105.524 803.417 104.562 802.682C103.599 801.947 102.484 801.58 101.218 801.58C99.9511 801.58 98.8365 801.947 97.8738 802.682C96.9111 803.417 96.1511 804.468 95.5938 805.836C95.0618 807.179 94.7958 808.8 94.7958 810.7C94.7958 812.575 95.0618 814.196 95.5938 815.564C96.1511 816.932 96.9111 817.996 97.8738 818.756C98.8365 819.491 99.9511 819.858 101.218 819.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M19.89 662V641.29L15.178 642.544V638.44L22.094 635.4H25.21V662H19.89ZM33.7318 662V641.29L29.0198 642.544V638.44L35.9358 635.4H39.0518V662H33.7318Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 662V641.29L78.178 642.544V638.44L85.094 635.4H88.21V662H82.89ZM92.7418 662V658.238C94.3631 656.946 95.9338 655.654 97.4538 654.362C98.9991 653.07 100.38 651.791 101.596 650.524C102.812 649.232 103.774 647.978 104.484 646.762C105.193 645.546 105.548 644.368 105.548 643.228C105.548 642.519 105.421 641.873 105.168 641.29C104.914 640.682 104.509 640.201 103.952 639.846C103.42 639.466 102.71 639.276 101.824 639.276C100.937 639.276 100.19 639.479 99.5818 639.884C98.9738 640.289 98.5178 640.834 98.2138 641.518C97.9098 642.177 97.7578 642.924 97.7578 643.76H92.7798C92.8558 641.809 93.2991 640.175 94.1098 638.858C94.9205 637.541 96.0098 636.565 97.3778 635.932C98.7458 635.273 100.278 634.944 101.976 634.944C103.85 634.944 105.434 635.299 106.726 636.008C108.018 636.692 108.993 637.629 109.652 638.82C110.336 640.011 110.678 641.379 110.678 642.924C110.678 644.089 110.462 645.229 110.032 646.344C109.626 647.459 109.044 648.548 108.284 649.612C107.549 650.651 106.713 651.651 105.776 652.614C104.838 653.577 103.863 654.501 102.85 655.388C101.836 656.249 100.848 657.06 99.8858 657.82H111.324V662H92.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M15.89 502V481.29L11.178 482.544V478.44L18.094 475.4H21.21V502H15.89ZM35.2418 502.456C33.5191 502.456 31.9358 502.139 30.4918 501.506C29.0478 500.873 27.8951 499.91 27.0338 498.618C26.1725 497.326 25.7165 495.692 25.6658 493.716H30.6818C30.7071 494.552 30.8971 495.312 31.2518 495.996C31.6065 496.655 32.1258 497.187 32.8098 497.592C33.4938 497.972 34.3045 498.162 35.2418 498.162C36.1285 498.162 36.8885 497.985 37.5218 497.63C38.1551 497.275 38.6365 496.807 38.9658 496.224C39.2951 495.641 39.4598 494.97 39.4598 494.21C39.4598 493.323 39.2318 492.589 38.7758 492.006C38.3451 491.398 37.7371 490.942 36.9518 490.638C36.1918 490.334 35.3178 490.182 34.3298 490.182H32.3538V485.964H34.3298C35.5711 485.964 36.6098 485.673 37.4458 485.09C38.3071 484.507 38.7378 483.633 38.7378 482.468C38.7378 481.505 38.4211 480.733 37.7878 480.15C37.1798 479.567 36.3185 479.276 35.2038 479.276C33.9878 479.276 33.0378 479.631 32.3538 480.34C31.6698 481.049 31.2898 481.923 31.2138 482.962H26.1978C26.2738 481.29 26.6918 479.859 27.4518 478.668C28.2371 477.452 29.2885 476.527 30.6058 475.894C31.9231 475.261 33.4558 474.944 35.2038 474.944C37.0531 474.944 38.6111 475.273 39.8778 475.932C41.1698 476.565 42.1451 477.427 42.8038 478.516C43.4625 479.605 43.7918 480.783 43.7918 482.05C43.7918 483.089 43.5891 484.013 43.1838 484.824C42.8038 485.635 42.2845 486.306 41.6258 486.838C40.9671 487.37 40.2451 487.75 39.4598 487.978C40.4478 488.181 41.3091 488.573 42.0438 489.156C42.8038 489.713 43.3865 490.435 43.7918 491.322C44.2225 492.209 44.4378 493.235 44.4378 494.4C44.4378 495.844 44.0831 497.187 43.3738 498.428C42.6898 499.644 41.6511 500.619 40.2578 501.354C38.8898 502.089 37.2178 502.456 35.2418 502.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M81.89 502V481.29L77.178 482.544V478.44L84.094 475.4H87.21V502H81.89ZM104.624 502V497.174H91.5518V493.108L103.94 475.4H109.754V492.728H113.212V497.174H109.754V502H104.624ZM97.0238 492.728H104.966V481.062L97.0238 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 340V319.29L42.178 320.544V316.44L49.094 313.4H52.21V340H46.89ZM66.9638 340.456C65.0385 340.456 63.3665 340.114 61.9478 339.43C60.5545 338.746 59.4651 337.809 58.6798 336.618C57.8945 335.427 57.4385 334.072 57.3118 332.552H62.3278C62.5051 333.54 63.0118 334.376 63.8478 335.06C64.6838 335.744 65.7351 336.086 67.0018 336.086C67.9138 336.086 68.7118 335.858 69.3958 335.402C70.0798 334.946 70.6118 334.338 70.9918 333.578C71.3718 332.793 71.5618 331.906 71.5618 330.918C71.5618 329.905 71.3591 329.031 70.9538 328.296C70.5738 327.561 70.0418 326.991 69.3578 326.586C68.6991 326.181 67.9391 325.978 67.0778 325.978C65.9885 325.978 65.0511 326.244 64.2658 326.776C63.5058 327.283 62.9611 327.903 62.6318 328.638H57.6538L59.8578 313.4H74.7918V317.884H63.6578L62.5558 323.812C63.1131 323.229 63.8605 322.761 64.7978 322.406C65.7351 322.026 66.7865 321.836 67.9518 321.836C69.3958 321.836 70.6498 322.089 71.7138 322.596C72.7778 323.077 73.6645 323.749 74.3738 324.61C75.0831 325.446 75.6151 326.409 75.9698 327.498C76.3245 328.562 76.5018 329.689 76.5018 330.88C76.5018 332.273 76.2611 333.553 75.7798 334.718C75.3238 335.883 74.6651 336.897 73.8038 337.758C72.9678 338.619 71.9671 339.291 70.8018 339.772C69.6618 340.228 68.3825 340.456 66.9638 340.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 203V182.29L41.178 183.544V179.44L48.094 176.4H51.21V203H45.89ZM66.4578 203.456C64.4565 203.456 62.7591 203.089 61.3658 202.354C59.9978 201.619 58.8958 200.631 58.0598 199.39C57.2491 198.149 56.6538 196.768 56.2738 195.248C55.9191 193.703 55.7418 192.145 55.7418 190.574C55.7418 187.585 56.1598 185.001 56.9958 182.822C57.8318 180.643 59.0351 178.959 60.6058 177.768C62.1765 176.552 64.0765 175.944 66.3058 175.944C68.1805 175.944 69.7638 176.311 71.0558 177.046C72.3478 177.755 73.3485 178.693 74.0578 179.858C74.7671 181.023 75.1851 182.277 75.3118 183.62H70.5238C70.3211 182.505 69.8525 181.657 69.1178 181.074C68.3831 180.466 67.4331 180.162 66.2678 180.162C65.1785 180.162 64.2285 180.491 63.4178 181.15C62.6071 181.809 61.9738 182.797 61.5178 184.114C61.0871 185.431 60.8338 187.091 60.7578 189.092C60.7578 189.117 60.7578 189.155 60.7578 189.206C60.7578 189.257 60.7578 189.295 60.7578 189.32C61.1631 188.636 61.6951 188.028 62.3538 187.496C63.0125 186.964 63.7725 186.546 64.6338 186.242C65.4951 185.938 66.4071 185.786 67.3698 185.786C68.8391 185.786 70.2071 186.141 71.4738 186.85C72.7405 187.559 73.7665 188.56 74.5518 189.852C75.3371 191.144 75.7298 192.677 75.7298 194.45C75.7298 196.046 75.3371 197.541 74.5518 198.934C73.7918 200.302 72.7151 201.404 71.3218 202.24C69.9285 203.051 68.3071 203.456 66.4578 203.456ZM66.1538 199.048C67.0658 199.048 67.8638 198.858 68.5478 198.478C69.2571 198.098 69.8145 197.579 70.2198 196.92C70.6251 196.236 70.8278 195.463 70.8278 194.602C70.8278 193.69 70.6251 192.905 70.2198 192.246C69.8145 191.587 69.2571 191.068 68.5478 190.688C67.8385 190.308 67.0278 190.118 66.1158 190.118C65.2291 190.118 64.4311 190.308 63.7218 190.688C63.0125 191.068 62.4425 191.6 62.0118 192.284C61.6065 192.943 61.4038 193.703 61.4038 194.564C61.4038 195.451 61.6065 196.236 62.0118 196.92C62.4425 197.579 63.0125 198.098 63.7218 198.478C64.4565 198.858 65.2671 199.048 66.1538 199.048Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truck18 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-40px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <path
        d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
        fill="#BFBEBE"
      />
      <path
        d="M384.535 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.535C386.476 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.476 78.1924 384.535 78.1924Z"
        fill="#BFBEBE"
      />
      <path
        d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
        fill="#BFBEBE"
      />
      <path
        d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
        fill="#BFBEBE"
      />
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "current")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "current")}
        className="cursor-pointer"
        key={8}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "current")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "current")}
        className="cursor-pointer"
        key={6}
      />
      <path d="M352 461H343V515H352V461Z" fill="#231F20" />
      <rect
        x="286"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "current")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="353"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "current")}
        className="cursor-pointer"
        key={4}
      />
      <path d="M352 294H343V348H352V294Z" fill="#231F20" />
      <rect
        x="286"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "current")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="353"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "current")}
        className="cursor-pointer"
        key={2}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(12) && selectedTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "current")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(13) && selectedTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "current")}
        className="cursor-pointer"
        key={13}
      />
      <path d="M66 461H57V515H66V461Z" fill="#231F20" />
      <rect
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(14) && selectedTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "current")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="67"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(15) && selectedTyre?.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(15)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "current")}
        className="cursor-pointer"
        key={15}
      />
      <path d="M66 294H57V348H66V294Z" fill="#231F20" />
      <rect
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(16) && selectedTyre?.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(16)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "current")}
        className="cursor-pointer"
        key={16}
      />
      <rect
        x="67"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(17) && selectedTyre?.includes(17)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(17)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(17, "current")}
        className="cursor-pointer"
        key={17}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "current")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(11) && selectedTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "current")}
        className="cursor-pointer"
        key={11}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "current")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(18, "current")}
        className="cursor-pointer"
        key={18}
      />
      <path
        d="M345.89 197V176.29L341.178 177.544V173.44L348.094 170.4H351.21V197H345.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M372.9 334V330.238C374.521 328.946 376.092 327.654 377.612 326.362C379.157 325.07 380.538 323.791 381.754 322.524C382.97 321.232 383.933 319.978 384.642 318.762C385.351 317.546 385.706 316.368 385.706 315.228C385.706 314.519 385.579 313.873 385.326 313.29C385.073 312.682 384.667 312.201 384.11 311.846C383.578 311.466 382.869 311.276 381.982 311.276C381.095 311.276 380.348 311.479 379.74 311.884C379.132 312.289 378.676 312.834 378.372 313.518C378.068 314.177 377.916 314.924 377.916 315.76H372.938C373.014 313.809 373.457 312.175 374.268 310.858C375.079 309.541 376.168 308.565 377.536 307.932C378.904 307.273 380.437 306.944 382.134 306.944C384.009 306.944 385.592 307.299 386.884 308.008C388.176 308.692 389.151 309.629 389.81 310.82C390.494 312.011 390.836 313.379 390.836 314.924C390.836 316.089 390.621 317.229 390.19 318.344C389.785 319.459 389.202 320.548 388.442 321.612C387.707 322.651 386.871 323.651 385.934 324.614C384.997 325.577 384.021 326.501 383.008 327.388C381.995 328.249 381.007 329.06 380.044 329.82H391.482V334H372.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.4 334.456C311.677 334.456 310.094 334.139 308.65 333.506C307.206 332.873 306.053 331.91 305.192 330.618C304.331 329.326 303.875 327.692 303.824 325.716H308.84C308.865 326.552 309.055 327.312 309.41 327.996C309.765 328.655 310.284 329.187 310.968 329.592C311.652 329.972 312.463 330.162 313.4 330.162C314.287 330.162 315.047 329.985 315.68 329.63C316.313 329.275 316.795 328.807 317.124 328.224C317.453 327.641 317.618 326.97 317.618 326.21C317.618 325.323 317.39 324.589 316.934 324.006C316.503 323.398 315.895 322.942 315.11 322.638C314.35 322.334 313.476 322.182 312.488 322.182H310.512V317.964H312.488C313.729 317.964 314.768 317.673 315.604 317.09C316.465 316.507 316.896 315.633 316.896 314.468C316.896 313.505 316.579 312.733 315.946 312.15C315.338 311.567 314.477 311.276 313.362 311.276C312.146 311.276 311.196 311.631 310.512 312.34C309.828 313.049 309.448 313.923 309.372 314.962H304.356C304.432 313.29 304.85 311.859 305.61 310.668C306.395 309.452 307.447 308.527 308.764 307.894C310.081 307.261 311.614 306.944 313.362 306.944C315.211 306.944 316.769 307.273 318.036 307.932C319.328 308.565 320.303 309.427 320.962 310.516C321.621 311.605 321.95 312.783 321.95 314.05C321.95 315.089 321.747 316.013 321.342 316.824C320.962 317.635 320.443 318.306 319.784 318.838C319.125 319.37 318.403 319.75 317.618 319.978C318.606 320.181 319.467 320.573 320.202 321.156C320.962 321.713 321.545 322.435 321.95 323.322C322.381 324.209 322.596 325.235 322.596 326.4C322.596 327.844 322.241 329.187 321.532 330.428C320.848 331.644 319.809 332.619 318.416 333.354C317.048 334.089 315.376 334.456 313.4 334.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M383.782 502V497.174H370.71V493.108L383.098 475.4H388.912V492.728H392.37V497.174H388.912V502H383.782ZM376.182 492.728H384.124V481.062L376.182 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.122 501.456C311.197 501.456 309.525 501.114 308.106 500.43C306.713 499.746 305.623 498.809 304.838 497.618C304.053 496.427 303.597 495.072 303.47 493.552H308.486C308.663 494.54 309.17 495.376 310.006 496.06C310.842 496.744 311.893 497.086 313.16 497.086C314.072 497.086 314.87 496.858 315.554 496.402C316.238 495.946 316.77 495.338 317.15 494.578C317.53 493.793 317.72 492.906 317.72 491.918C317.72 490.905 317.517 490.031 317.112 489.296C316.732 488.561 316.2 487.991 315.516 487.586C314.857 487.181 314.097 486.978 313.236 486.978C312.147 486.978 311.209 487.244 310.424 487.776C309.664 488.283 309.119 488.903 308.79 489.638H303.812L306.016 474.4H320.95V478.884H309.816L308.714 484.812C309.271 484.229 310.019 483.761 310.956 483.406C311.893 483.026 312.945 482.836 314.11 482.836C315.554 482.836 316.808 483.089 317.872 483.596C318.936 484.077 319.823 484.749 320.532 485.61C321.241 486.446 321.773 487.409 322.128 488.498C322.483 489.562 322.66 490.689 322.66 491.88C322.66 493.273 322.419 494.553 321.938 495.718C321.482 496.883 320.823 497.897 319.962 498.758C319.126 499.619 318.125 500.291 316.96 500.772C315.82 501.228 314.541 501.456 313.122 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M382.616 662.456C380.615 662.456 378.917 662.089 377.524 661.354C376.156 660.619 375.054 659.631 374.218 658.39C373.407 657.149 372.812 655.768 372.432 654.248C372.077 652.703 371.9 651.145 371.9 649.574C371.9 646.585 372.318 644.001 373.154 641.822C373.99 639.643 375.193 637.959 376.764 636.768C378.335 635.552 380.235 634.944 382.464 634.944C384.339 634.944 385.922 635.311 387.214 636.046C388.506 636.755 389.507 637.693 390.216 638.858C390.925 640.023 391.343 641.277 391.47 642.62H386.682C386.479 641.505 386.011 640.657 385.276 640.074C384.541 639.466 383.591 639.162 382.426 639.162C381.337 639.162 380.387 639.491 379.576 640.15C378.765 640.809 378.132 641.797 377.676 643.114C377.245 644.431 376.992 646.091 376.916 648.092C376.916 648.117 376.916 648.155 376.916 648.206C376.916 648.257 376.916 648.295 376.916 648.32C377.321 647.636 377.853 647.028 378.512 646.496C379.171 645.964 379.931 645.546 380.792 645.242C381.653 644.938 382.565 644.786 383.528 644.786C384.997 644.786 386.365 645.141 387.632 645.85C388.899 646.559 389.925 647.56 390.71 648.852C391.495 650.144 391.888 651.677 391.888 653.45C391.888 655.046 391.495 656.541 390.71 657.934C389.95 659.302 388.873 660.404 387.48 661.24C386.087 662.051 384.465 662.456 382.616 662.456ZM382.312 658.048C383.224 658.048 384.022 657.858 384.706 657.478C385.415 657.098 385.973 656.579 386.378 655.92C386.783 655.236 386.986 654.463 386.986 653.602C386.986 652.69 386.783 651.905 386.378 651.246C385.973 650.587 385.415 650.068 384.706 649.688C383.997 649.308 383.186 649.118 382.274 649.118C381.387 649.118 380.589 649.308 379.88 649.688C379.171 650.068 378.601 650.6 378.17 651.284C377.765 651.943 377.562 652.703 377.562 653.564C377.562 654.451 377.765 655.236 378.17 655.92C378.601 656.579 379.171 657.098 379.88 657.478C380.615 657.858 381.425 658.048 382.312 658.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M307.218 662L316.984 639.77H304.102V635.4H322.228V639.01L312.538 662H307.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.008 823.456C379.209 823.456 377.563 823.127 376.068 822.468C374.599 821.809 373.433 820.885 372.572 819.694C371.711 818.503 371.28 817.123 371.28 815.552C371.28 814.463 371.457 813.475 371.812 812.588C372.192 811.701 372.711 810.916 373.37 810.232C374.029 809.548 374.814 809.029 375.726 808.674C374.586 808.142 373.661 807.382 372.952 806.394C372.268 805.406 371.926 804.291 371.926 803.05C371.926 801.809 372.268 800.643 372.952 799.554C373.636 798.465 374.649 797.591 375.992 796.932C377.335 796.273 379.007 795.944 381.008 795.944C383.009 795.944 384.681 796.273 386.024 796.932C387.367 797.591 388.38 798.465 389.064 799.554C389.748 800.643 390.09 801.809 390.09 803.05C390.09 804.266 389.735 805.381 389.026 806.394C388.342 807.382 387.43 808.142 386.29 808.674C387.202 809.054 387.987 809.586 388.646 810.27C389.33 810.929 389.849 811.701 390.204 812.588C390.584 813.475 390.774 814.463 390.774 815.552C390.774 817.123 390.331 818.503 389.444 819.694C388.583 820.885 387.417 821.809 385.948 822.468C384.479 823.127 382.832 823.456 381.008 823.456ZM381.008 819.162C382.579 819.162 383.757 818.782 384.542 818.022C385.327 817.262 385.72 816.299 385.72 815.134C385.72 813.842 385.302 812.829 384.466 812.094C383.655 811.334 382.503 810.954 381.008 810.954C379.539 810.954 378.373 811.334 377.512 812.094C376.676 812.829 376.258 813.842 376.258 815.134C376.258 816.299 376.663 817.262 377.474 818.022C378.285 818.782 379.463 819.162 381.008 819.162ZM381.008 807.192C382.3 807.192 383.288 806.863 383.972 806.204C384.681 805.545 385.036 804.697 385.036 803.658C385.036 802.543 384.681 801.682 383.972 801.074C383.288 800.441 382.3 800.124 381.008 800.124C379.741 800.124 378.753 800.441 378.044 801.074C377.335 801.682 376.98 802.556 376.98 803.696C376.98 804.709 377.335 805.545 378.044 806.204C378.753 806.863 379.741 807.192 381.008 807.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.628 823.456C311.779 823.456 310.208 823.101 308.916 822.392C307.624 821.657 306.623 820.707 305.914 819.542C305.23 818.377 304.812 817.123 304.66 815.78H309.448C309.676 816.895 310.145 817.756 310.854 818.364C311.589 818.947 312.539 819.238 313.704 819.238C314.793 819.238 315.731 818.921 316.516 818.288C317.327 817.629 317.96 816.654 318.416 815.362C318.872 814.045 319.125 812.423 319.176 810.498C319.176 810.422 319.176 810.346 319.176 810.27C319.176 810.194 319.176 810.131 319.176 810.08C318.821 810.739 318.302 811.347 317.618 811.904C316.934 812.436 316.161 812.854 315.3 813.158C314.464 813.462 313.565 813.614 312.602 813.614C311.158 813.614 309.79 813.259 308.498 812.55C307.206 811.841 306.167 810.84 305.382 809.548C304.597 808.256 304.204 806.723 304.204 804.95C304.204 803.329 304.597 801.834 305.382 800.466C306.167 799.098 307.257 798.009 308.65 797.198C310.043 796.362 311.652 795.944 313.476 795.944C315.503 795.944 317.2 796.311 318.568 797.046C319.936 797.781 321.025 798.769 321.836 800.01C322.672 801.251 323.267 802.645 323.622 804.19C324.002 805.71 324.192 807.255 324.192 808.826C324.192 811.79 323.774 814.374 322.938 816.578C322.127 818.757 320.937 820.454 319.366 821.67C317.795 822.861 315.883 823.456 313.628 823.456ZM313.818 809.282C314.73 809.282 315.528 809.092 316.212 808.712C316.921 808.332 317.479 807.813 317.884 807.154C318.315 806.47 318.53 805.697 318.53 804.836C318.53 803.949 318.315 803.164 317.884 802.48C317.479 801.796 316.921 801.277 316.212 800.922C315.503 800.542 314.692 800.352 313.78 800.352C312.893 800.352 312.095 800.542 311.386 800.922C310.677 801.302 310.119 801.821 309.714 802.48C309.334 803.139 309.144 803.911 309.144 804.798C309.144 805.685 309.334 806.47 309.714 807.154C310.119 807.813 310.677 808.332 311.386 808.712C312.095 809.092 312.906 809.282 313.818 809.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 823V802.29L9.178 803.544V799.44L16.094 796.4H19.21V823H13.89ZM35.2178 823.456C32.8111 823.456 30.7338 822.873 28.9858 821.708C27.2378 820.543 25.8951 818.934 24.9578 816.882C24.0458 814.805 23.5898 812.411 23.5898 809.7C23.5898 806.989 24.0458 804.608 24.9578 802.556C25.8951 800.479 27.2251 798.857 28.9478 797.692C30.6958 796.527 32.7858 795.944 35.2178 795.944C37.6498 795.944 39.7271 796.527 41.4498 797.692C43.1978 798.857 44.5278 800.479 45.4398 802.556C46.3771 804.608 46.8458 806.989 46.8458 809.7C46.8458 812.411 46.3771 814.805 45.4398 816.882C44.5278 818.934 43.1978 820.543 41.4498 821.708C39.7271 822.873 37.6498 823.456 35.2178 823.456ZM35.2178 818.858C36.4845 818.858 37.5991 818.491 38.5618 817.756C39.5245 816.996 40.2718 815.932 40.8038 814.564C41.3611 813.196 41.6398 811.575 41.6398 809.7C41.6398 807.8 41.3611 806.179 40.8038 804.836C40.2718 803.468 39.5245 802.417 38.5618 801.682C37.5991 800.947 36.4845 800.58 35.2178 800.58C33.9511 800.58 32.8365 800.947 31.8738 801.682C30.9111 802.417 30.1511 803.468 29.5938 804.836C29.0618 806.179 28.7958 807.8 28.7958 809.7C28.7958 811.575 29.0618 813.196 29.5938 814.564C30.1511 815.932 30.9111 816.996 31.8738 817.756C32.8365 818.491 33.9511 818.858 35.2178 818.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M86.89 823V802.29L82.178 803.544V799.44L89.094 796.4H92.21V823H86.89ZM100.732 823V802.29L96.0198 803.544V799.44L102.936 796.4H106.052V823H100.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 661V640.29L9.178 641.544V637.44L16.094 634.4H19.21V661H13.89ZM23.7418 661V657.238C25.3631 655.946 26.9338 654.654 28.4538 653.362C29.9991 652.07 31.3798 650.791 32.5958 649.524C33.8118 648.232 34.7745 646.978 35.4838 645.762C36.1931 644.546 36.5478 643.368 36.5478 642.228C36.5478 641.519 36.4211 640.873 36.1678 640.29C35.9145 639.682 35.5091 639.201 34.9518 638.846C34.4198 638.466 33.7105 638.276 32.8238 638.276C31.9371 638.276 31.1898 638.479 30.5818 638.884C29.9738 639.289 29.5178 639.834 29.2138 640.518C28.9098 641.177 28.7578 641.924 28.7578 642.76H23.7798C23.8558 640.809 24.2991 639.175 25.1098 637.858C25.9205 636.541 27.0098 635.565 28.3778 634.932C29.7458 634.273 31.2785 633.944 32.9758 633.944C34.8505 633.944 36.4338 634.299 37.7258 635.008C39.0178 635.692 39.9931 636.629 40.6518 637.82C41.3358 639.011 41.6778 640.379 41.6778 641.924C41.6778 643.089 41.4625 644.229 41.0318 645.344C40.6265 646.459 40.0438 647.548 39.2838 648.612C38.5491 649.651 37.7131 650.651 36.7758 651.614C35.8385 652.577 34.8631 653.501 33.8498 654.388C32.8365 655.249 31.8485 656.06 30.8858 656.82H42.3238V661H23.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 662V641.29L78.178 642.544V638.44L85.094 635.4H88.21V662H82.89ZM102.242 662.456C100.519 662.456 98.9358 662.139 97.4918 661.506C96.0478 660.873 94.8951 659.91 94.0338 658.618C93.1725 657.326 92.7165 655.692 92.6658 653.716H97.6818C97.7071 654.552 97.8971 655.312 98.2518 655.996C98.6065 656.655 99.1258 657.187 99.8098 657.592C100.494 657.972 101.304 658.162 102.242 658.162C103.128 658.162 103.888 657.985 104.522 657.63C105.155 657.275 105.636 656.807 105.966 656.224C106.295 655.641 106.46 654.97 106.46 654.21C106.46 653.323 106.232 652.589 105.776 652.006C105.345 651.398 104.737 650.942 103.952 650.638C103.192 650.334 102.318 650.182 101.33 650.182H99.3538V645.964H101.33C102.571 645.964 103.61 645.673 104.446 645.09C105.307 644.507 105.738 643.633 105.738 642.468C105.738 641.505 105.421 640.733 104.788 640.15C104.18 639.567 103.318 639.276 102.204 639.276C100.988 639.276 100.038 639.631 99.3538 640.34C98.6698 641.049 98.2898 641.923 98.2138 642.962H93.1978C93.2738 641.29 93.6918 639.859 94.4518 638.668C95.2371 637.452 96.2885 636.527 97.6058 635.894C98.9231 635.261 100.456 634.944 102.204 634.944C104.053 634.944 105.611 635.273 106.878 635.932C108.17 636.565 109.145 637.427 109.804 638.516C110.462 639.605 110.792 640.783 110.792 642.05C110.792 643.089 110.589 644.013 110.184 644.824C109.804 645.635 109.284 646.306 108.626 646.838C107.967 647.37 107.245 647.75 106.46 647.978C107.448 648.181 108.309 648.573 109.044 649.156C109.804 649.713 110.386 650.435 110.792 651.322C111.222 652.209 111.438 653.235 111.438 654.4C111.438 655.844 111.083 657.187 110.374 658.428C109.69 659.644 108.651 660.619 107.258 661.354C105.89 662.089 104.218 662.456 102.242 662.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 502V481.29L9.178 482.544V478.44L16.094 475.4H19.21V502H13.89ZM36.6238 502V497.174H23.5518V493.108L35.9398 475.4H41.7538V492.728H45.2118V497.174H41.7538V502H36.6238ZM29.0238 492.728H36.9658V481.062L29.0238 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M80.89 501V480.29L76.178 481.544V477.44L83.094 474.4H86.21V501H80.89ZM100.964 501.456C99.0385 501.456 97.3665 501.114 95.9478 500.43C94.5545 499.746 93.4651 498.809 92.6798 497.618C91.8945 496.427 91.4385 495.072 91.3118 493.552H96.3278C96.5051 494.54 97.0118 495.376 97.8478 496.06C98.6838 496.744 99.7351 497.086 101.002 497.086C101.914 497.086 102.712 496.858 103.396 496.402C104.08 495.946 104.612 495.338 104.992 494.578C105.372 493.793 105.562 492.906 105.562 491.918C105.562 490.905 105.359 490.031 104.954 489.296C104.574 488.561 104.042 487.991 103.358 487.586C102.699 487.181 101.939 486.978 101.078 486.978C99.9885 486.978 99.0511 487.244 98.2658 487.776C97.5058 488.283 96.9611 488.903 96.6318 489.638H91.6538L93.8578 474.4H108.792V478.884H97.6578L96.5558 484.812C97.1131 484.229 97.8605 483.761 98.7978 483.406C99.7351 483.026 100.786 482.836 101.952 482.836C103.396 482.836 104.65 483.089 105.714 483.596C106.778 484.077 107.664 484.749 108.374 485.61C109.083 486.446 109.615 487.409 109.97 488.498C110.324 489.562 110.502 490.689 110.502 491.88C110.502 493.273 110.261 494.553 109.78 495.718C109.324 496.883 108.665 497.897 107.804 498.758C106.968 499.619 105.967 500.291 104.802 500.772C103.662 501.228 102.382 501.456 100.964 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 334V313.29L9.178 314.544V310.44L16.094 307.4H19.21V334H13.89ZM34.4578 334.456C32.4565 334.456 30.7591 334.089 29.3658 333.354C27.9978 332.619 26.8958 331.631 26.0598 330.39C25.2491 329.149 24.6538 327.768 24.2738 326.248C23.9191 324.703 23.7418 323.145 23.7418 321.574C23.7418 318.585 24.1598 316.001 24.9958 313.822C25.8318 311.643 27.0351 309.959 28.6058 308.768C30.1765 307.552 32.0765 306.944 34.3058 306.944C36.1805 306.944 37.7638 307.311 39.0558 308.046C40.3478 308.755 41.3485 309.693 42.0578 310.858C42.7671 312.023 43.1851 313.277 43.3118 314.62H38.5238C38.3211 313.505 37.8525 312.657 37.1178 312.074C36.3831 311.466 35.4331 311.162 34.2678 311.162C33.1785 311.162 32.2285 311.491 31.4178 312.15C30.6071 312.809 29.9738 313.797 29.5178 315.114C29.0871 316.431 28.8338 318.091 28.7578 320.092C28.7578 320.117 28.7578 320.155 28.7578 320.206C28.7578 320.257 28.7578 320.295 28.7578 320.32C29.1631 319.636 29.6951 319.028 30.3538 318.496C31.0125 317.964 31.7725 317.546 32.6338 317.242C33.4951 316.938 34.4071 316.786 35.3698 316.786C36.8391 316.786 38.2071 317.141 39.4738 317.85C40.7405 318.559 41.7665 319.56 42.5518 320.852C43.3371 322.144 43.7298 323.677 43.7298 325.45C43.7298 327.046 43.3371 328.541 42.5518 329.934C41.7918 331.302 40.7151 332.404 39.3218 333.24C37.9285 334.051 36.3071 334.456 34.4578 334.456ZM34.1538 330.048C35.0658 330.048 35.8638 329.858 36.5478 329.478C37.2571 329.098 37.8145 328.579 38.2198 327.92C38.6251 327.236 38.8278 326.463 38.8278 325.602C38.8278 324.69 38.6251 323.905 38.2198 323.246C37.8145 322.587 37.2571 322.068 36.5478 321.688C35.8385 321.308 35.0278 321.118 34.1158 321.118C33.2291 321.118 32.4311 321.308 31.7218 321.688C31.0125 322.068 30.4425 322.6 30.0118 323.284C29.6065 323.943 29.4038 324.703 29.4038 325.564C29.4038 326.451 29.6065 327.236 30.0118 327.92C30.4425 328.579 31.0125 329.098 31.7218 329.478C32.4565 329.858 33.2671 330.048 34.1538 330.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 334V313.29L78.178 314.544V310.44L85.094 307.4H88.21V334H82.89ZM95.0598 334L104.826 311.77H91.9438V307.4H110.07V311.01L100.38 334H95.0598Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 197V176.29L42.178 177.544V173.44L49.094 170.4H52.21V197H46.89ZM66.8498 197.456C65.0511 197.456 63.4045 197.127 61.9098 196.468C60.4405 195.809 59.2751 194.885 58.4138 193.694C57.5525 192.503 57.1218 191.123 57.1218 189.552C57.1218 188.463 57.2991 187.475 57.6538 186.588C58.0338 185.701 58.5531 184.916 59.2118 184.232C59.8705 183.548 60.6558 183.029 61.5678 182.674C60.4278 182.142 59.5031 181.382 58.7938 180.394C58.1098 179.406 57.7678 178.291 57.7678 177.05C57.7678 175.809 58.1098 174.643 58.7938 173.554C59.4778 172.465 60.4911 171.591 61.8338 170.932C63.1765 170.273 64.8485 169.944 66.8498 169.944C68.8511 169.944 70.5231 170.273 71.8658 170.932C73.2085 171.591 74.2218 172.465 74.9058 173.554C75.5898 174.643 75.9318 175.809 75.9318 177.05C75.9318 178.266 75.5771 179.381 74.8678 180.394C74.1838 181.382 73.2718 182.142 72.1318 182.674C73.0438 183.054 73.8291 183.586 74.4878 184.27C75.1718 184.929 75.6911 185.701 76.0458 186.588C76.4258 187.475 76.6158 188.463 76.6158 189.552C76.6158 191.123 76.1725 192.503 75.2858 193.694C74.4245 194.885 73.2591 195.809 71.7898 196.468C70.3205 197.127 68.6738 197.456 66.8498 197.456ZM66.8498 193.162C68.4205 193.162 69.5985 192.782 70.3838 192.022C71.1691 191.262 71.5618 190.299 71.5618 189.134C71.5618 187.842 71.1438 186.829 70.3078 186.094C69.4971 185.334 68.3445 184.954 66.8498 184.954C65.3805 184.954 64.2151 185.334 63.3538 186.094C62.5178 186.829 62.0998 187.842 62.0998 189.134C62.0998 190.299 62.5051 191.262 63.3158 192.022C64.1265 192.782 65.3045 193.162 66.8498 193.162ZM66.8498 181.192C68.1418 181.192 69.1298 180.863 69.8138 180.204C70.5231 179.545 70.8778 178.697 70.8778 177.658C70.8778 176.543 70.5231 175.682 69.8138 175.074C69.1298 174.441 68.1418 174.124 66.8498 174.124C65.5831 174.124 64.5951 174.441 63.8858 175.074C63.1765 175.682 62.8218 176.556 62.8218 177.696C62.8218 178.709 63.1765 179.545 63.8858 180.204C64.5951 180.863 65.5831 181.192 66.8498 181.192Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truck22 = ({ selectedTyre, addedTyre, handleSelection }) => (
    <svg
      width="179"
      height="760"
      viewBox="0 0 379 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-85px" }}
    >
      <path
        d="M52.4633 69.4987C52.4633 36.4893 79.2228 9.72983 112.232 9.72983H266.768C299.777 9.72983 326.537 36.4893 326.537 69.4988V942.587C326.537 951.543 319.276 958.803 310.32 958.803H68.6797C59.7236 958.803 52.4633 951.543 52.4633 942.587V69.4987Z"
        stroke="black"
        strokeWidth="0.92665"
      />
      <path
        d="M61.4633 75.8655C61.4633 45.4149 86.1484 20.7298 116.599 20.7298H262.401C292.852 20.7298 317.537 45.4149 317.537 75.8655V933.587C317.537 942.543 310.276 949.803 301.32 949.803H77.6797C68.7237 949.803 61.4633 942.543 61.4633 933.587V75.8655Z"
        stroke="black"
        strokeWidth="0.92665"
      />
      <path
        opacity="0.6"
        d="M301.546 44.7638H77.8379C87.3692 31.6785 102.809 23.1663 120.245 23.1663H258.548C276.155 23.1663 291.775 31.6614 301.546 44.7638Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M142.786 9.64266H104.978C106.588 3.80226 109.199 0 112.145 0H135.524C138.504 0 141.142 3.79369 142.795 9.64266H142.786Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M267.849 9.64266H230.04C231.65 3.80226 234.253 0 237.208 0H260.587C263.567 0 266.204 3.79369 267.857 9.64266H267.849Z"
        fill="#BFBEBE"
      />
      <path
        d="M356.27 69.2371H341.429C336.522 69.2371 332.54 73.2277 332.54 78.1261V79.2308H328.069C327.778 77.6551 326.4 76.4562 324.738 76.4562C324.327 76.4562 323.993 76.7902 323.993 77.2012V94.9879C323.993 95.399 324.327 95.733 324.738 95.733C326.511 95.733 327.95 94.3628 328.104 92.6244L338.971 88.7279H356.27C359.943 88.7279 362.932 85.7392 362.932 82.0654V75.891C362.932 72.2172 359.943 69.2285 356.27 69.2285V69.2371ZM328.129 91.0315V80.738H332.54V87.9914C332.54 88.4025 332.874 88.7365 333.285 88.7365H334.535L328.129 91.0315ZM361.433 82.0739C361.433 84.9256 359.121 87.2378 356.27 87.2378H334.038V78.1261C334.038 74.0498 337.352 70.7271 341.437 70.7271H356.278C359.13 70.7271 361.442 73.0393 361.442 75.891V82.0654L361.433 82.0739Z"
        fill="#BFBEBE"
      />
      <path
        d="M356.33 72.457H341.335C338.32 72.457 335.871 74.9062 335.871 77.9206V84.7629C335.871 85.174 336.205 85.508 336.616 85.508H356.33C358.128 85.508 359.592 84.0436 359.592 82.2452V75.7197C359.592 73.9214 358.128 72.457 356.33 72.457Z"
        fill="#BFBEBE"
      />
      <path
        d="M20.3266 69.2371H35.1674C40.0743 69.2371 44.0564 73.2277 44.0564 78.1261V79.2308H48.5266C48.8178 77.6551 50.1966 76.4562 51.8579 76.4562C52.269 76.4562 52.6029 76.7902 52.6029 77.2012V94.9879C52.6029 95.399 52.269 95.733 51.8579 95.733C50.0852 95.733 48.6465 94.3628 48.4924 92.6244L37.6251 88.7279H20.3266C16.6528 88.7279 13.6641 85.7392 13.6641 82.0654V75.891C13.6641 72.2172 16.6528 69.2285 20.3266 69.2285V69.2371ZM48.4581 91.0315V80.738H44.0479V87.9914C44.0479 88.4025 43.7139 88.7365 43.3028 88.7365H42.0525L48.4581 91.0315ZM15.1541 82.0739C15.1541 84.9256 17.4663 87.2378 20.318 87.2378H42.5492V78.1261C42.5492 74.0498 39.2351 70.7271 35.1502 70.7271H20.3266C17.4749 70.7271 15.1627 73.0393 15.1627 75.891V82.0654L15.1541 82.0739Z"
        fill="#BFBEBE"
      />
      <path
        d="M20.2579 72.457H35.2528C38.2672 72.457 40.7164 74.9062 40.7164 77.9206V84.7629C40.7164 85.174 40.3824 85.508 39.9714 85.508H20.2579C18.4595 85.508 16.9951 84.0436 16.9951 82.2452V75.7197C16.9951 73.9214 18.4595 72.457 20.2579 72.457Z"
        fill="#BFBEBE"
      />
      <path
        d="M326.181 272.435H317.841V322.474H326.181V272.435Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(3)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(3) && selectedTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="327.107"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(2)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(2) && selectedTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <path
        d="M326.181 400.359H317.841V450.399H326.181V400.359Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(5)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(5) && selectedTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="327.107"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(4)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(4) && selectedTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <path
        d="M326.181 687.508H317.841V737.548H326.181V687.508Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(9)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(9) && selectedTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="327.107"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(8)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(8) && selectedTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <path
        d="M61.1592 687.508H52.8193V737.548H61.1592V687.508Z"
        fill="#231F20"
      />
      <rect
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(14)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(14) && selectedTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "new")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="62.0859"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(15)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(15) && selectedTyre?.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "new")}
        className="cursor-pointer"
        key={15}
      />
      <path
        d="M326.181 535.318H317.841V585.357H326.181V535.318Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(7)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(7) && selectedTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="327.107"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(6)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(6) && selectedTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <path
        d="M61.1592 535.318H52.8193V585.357H61.1592V535.318Z"
        fill="#231F20"
      />
      <rect
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(16)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(16) && selectedTyre?.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "new")}
        className="cursor-pointer"
        key={16}
      />
      <rect
        x="62.0859"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(17)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(17) && selectedTyre?.includes(17)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(17, "new")}
        className="cursor-pointer"
        key={17}
      />
      <path
        d="M61.1592 272.435H52.8193V322.474H61.1592V272.435Z"
        fill="#231F20"
      />
      <rect
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(20)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(20) && selectedTyre?.includes(20)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(20, "new")}
        className="cursor-pointer"
        key={20}
      />
      <rect
        x="62.0859"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(21)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(21) && selectedTyre?.includes(21)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(21, "new")}
        className="cursor-pointer"
        key={21}
      />
      <path
        d="M61.1592 400.359H52.8193V450.399H61.1592V400.359Z"
        fill="#231F20"
      />
      <rect
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(18)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(18) && selectedTyre?.includes(18)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(18, "new")}
        className="cursor-pointer"
        key={18}
      />
      <rect
        x="62.0859"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(19)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(19) && selectedTyre?.includes(19)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(19, "new")}
        className="cursor-pointer"
        key={19}
      />
      <path
        d="M61.1582 839.699H52.8184V889.738H61.1582V839.699Z"
        fill="#231F20"
      />
      <path
        d="M326.181 839.699H317.841V889.738H326.181V839.699Z"
        fill="#231F20"
      />
      <rect
        x="265.948"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(11)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(11) && selectedTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="326.181"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(10)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="0.925781"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(12)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(12) && selectedTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="61.1582"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(13)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(13) && selectedTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "new")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="296.528"
        y="112.125"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(1)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(1) && selectedTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="28.7256"
        y="113.978"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          addedTyre.includes(22)
            ? "rgb(77, 120, 137)"
            : addedTyre?.includes(22) && selectedTyre?.includes(22)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(22, "new")}
        className="cursor-pointer"
        key={22}
      />
      <path
        d="M317.89 181V160.29L313.178 161.544V157.44L320.094 154.4H323.21V181H317.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M343.9 310V306.238C345.521 304.946 347.092 303.654 348.612 302.362C350.157 301.07 351.538 299.791 352.754 298.524C353.97 297.232 354.933 295.978 355.642 294.762C356.351 293.546 356.706 292.368 356.706 291.228C356.706 290.519 356.579 289.873 356.326 289.29C356.073 288.682 355.667 288.201 355.11 287.846C354.578 287.466 353.869 287.276 352.982 287.276C352.095 287.276 351.348 287.479 350.74 287.884C350.132 288.289 349.676 288.834 349.372 289.518C349.068 290.177 348.916 290.924 348.916 291.76H343.938C344.014 289.809 344.457 288.175 345.268 286.858C346.079 285.541 347.168 284.565 348.536 283.932C349.904 283.273 351.437 282.944 353.134 282.944C355.009 282.944 356.592 283.299 357.884 284.008C359.176 284.692 360.151 285.629 360.81 286.82C361.494 288.011 361.836 289.379 361.836 290.924C361.836 292.089 361.621 293.229 361.19 294.344C360.785 295.459 360.202 296.548 359.442 297.612C358.707 298.651 357.871 299.651 356.934 300.614C355.997 301.577 355.021 302.501 354.008 303.388C352.995 304.249 352.007 305.06 351.044 305.82H362.482V310H343.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M291.4 310.456C289.677 310.456 288.094 310.139 286.65 309.506C285.206 308.873 284.053 307.91 283.192 306.618C282.331 305.326 281.875 303.692 281.824 301.716H286.84C286.865 302.552 287.055 303.312 287.41 303.996C287.765 304.655 288.284 305.187 288.968 305.592C289.652 305.972 290.463 306.162 291.4 306.162C292.287 306.162 293.047 305.985 293.68 305.63C294.313 305.275 294.795 304.807 295.124 304.224C295.453 303.641 295.618 302.97 295.618 302.21C295.618 301.323 295.39 300.589 294.934 300.006C294.503 299.398 293.895 298.942 293.11 298.638C292.35 298.334 291.476 298.182 290.488 298.182H288.512V293.964H290.488C291.729 293.964 292.768 293.673 293.604 293.09C294.465 292.507 294.896 291.633 294.896 290.468C294.896 289.505 294.579 288.733 293.946 288.15C293.338 287.567 292.477 287.276 291.362 287.276C290.146 287.276 289.196 287.631 288.512 288.34C287.828 289.049 287.448 289.923 287.372 290.962H282.356C282.432 289.29 282.85 287.859 283.61 286.668C284.395 285.452 285.447 284.527 286.764 283.894C288.081 283.261 289.614 282.944 291.362 282.944C293.211 282.944 294.769 283.273 296.036 283.932C297.328 284.565 298.303 285.427 298.962 286.516C299.621 287.605 299.95 288.783 299.95 290.05C299.95 291.089 299.747 292.013 299.342 292.824C298.962 293.635 298.443 294.306 297.784 294.838C297.125 295.37 296.403 295.75 295.618 295.978C296.606 296.181 297.467 296.573 298.202 297.156C298.962 297.713 299.545 298.435 299.95 299.322C300.381 300.209 300.596 301.235 300.596 302.4C300.596 303.844 300.241 305.187 299.532 306.428C298.848 307.644 297.809 308.619 296.416 309.354C295.048 310.089 293.376 310.456 291.4 310.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M355.782 437V432.174H342.71V428.108L355.098 410.4H360.912V427.728H364.37V432.174H360.912V437H355.782ZM348.182 427.728H356.124V416.062L348.182 427.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M290.122 437.456C288.197 437.456 286.525 437.114 285.106 436.43C283.713 435.746 282.623 434.809 281.838 433.618C281.053 432.427 280.597 431.072 280.47 429.552H285.486C285.663 430.54 286.17 431.376 287.006 432.06C287.842 432.744 288.893 433.086 290.16 433.086C291.072 433.086 291.87 432.858 292.554 432.402C293.238 431.946 293.77 431.338 294.15 430.578C294.53 429.793 294.72 428.906 294.72 427.918C294.72 426.905 294.517 426.031 294.112 425.296C293.732 424.561 293.2 423.991 292.516 423.586C291.857 423.181 291.097 422.978 290.236 422.978C289.147 422.978 288.209 423.244 287.424 423.776C286.664 424.283 286.119 424.903 285.79 425.638H280.812L283.016 410.4H297.95V414.884H286.816L285.714 420.812C286.271 420.229 287.019 419.761 287.956 419.406C288.893 419.026 289.945 418.836 291.11 418.836C292.554 418.836 293.808 419.089 294.872 419.596C295.936 420.077 296.823 420.749 297.532 421.61C298.241 422.446 298.773 423.409 299.128 424.498C299.483 425.562 299.66 426.689 299.66 427.88C299.66 429.273 299.419 430.553 298.938 431.718C298.482 432.883 297.823 433.897 296.962 434.758C296.126 435.619 295.125 436.291 293.96 436.772C292.82 437.228 291.541 437.456 290.122 437.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M352.616 575.456C350.615 575.456 348.917 575.089 347.524 574.354C346.156 573.619 345.054 572.631 344.218 571.39C343.407 570.149 342.812 568.768 342.432 567.248C342.077 565.703 341.9 564.145 341.9 562.574C341.9 559.585 342.318 557.001 343.154 554.822C343.99 552.643 345.193 550.959 346.764 549.768C348.335 548.552 350.235 547.944 352.464 547.944C354.339 547.944 355.922 548.311 357.214 549.046C358.506 549.755 359.507 550.693 360.216 551.858C360.925 553.023 361.343 554.277 361.47 555.62H356.682C356.479 554.505 356.011 553.657 355.276 553.074C354.541 552.466 353.591 552.162 352.426 552.162C351.337 552.162 350.387 552.491 349.576 553.15C348.765 553.809 348.132 554.797 347.676 556.114C347.245 557.431 346.992 559.091 346.916 561.092C346.916 561.117 346.916 561.155 346.916 561.206C346.916 561.257 346.916 561.295 346.916 561.32C347.321 560.636 347.853 560.028 348.512 559.496C349.171 558.964 349.931 558.546 350.792 558.242C351.653 557.938 352.565 557.786 353.528 557.786C354.997 557.786 356.365 558.141 357.632 558.85C358.899 559.559 359.925 560.56 360.71 561.852C361.495 563.144 361.888 564.677 361.888 566.45C361.888 568.046 361.495 569.541 360.71 570.934C359.95 572.302 358.873 573.404 357.48 574.24C356.087 575.051 354.465 575.456 352.616 575.456ZM352.312 571.048C353.224 571.048 354.022 570.858 354.706 570.478C355.415 570.098 355.973 569.579 356.378 568.92C356.783 568.236 356.986 567.463 356.986 566.602C356.986 565.69 356.783 564.905 356.378 564.246C355.973 563.587 355.415 563.068 354.706 562.688C353.997 562.308 353.186 562.118 352.274 562.118C351.387 562.118 350.589 562.308 349.88 562.688C349.171 563.068 348.601 563.6 348.17 564.284C347.765 564.943 347.562 565.703 347.562 566.564C347.562 567.451 347.765 568.236 348.17 568.92C348.601 569.579 349.171 570.098 349.88 570.478C350.615 570.858 351.425 571.048 352.312 571.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M282.218 573L291.984 550.77H279.102V546.4H297.228V550.01L287.538 573H282.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M352.008 728.456C350.209 728.456 348.563 728.127 347.068 727.468C345.599 726.809 344.433 725.885 343.572 724.694C342.711 723.503 342.28 722.123 342.28 720.552C342.28 719.463 342.457 718.475 342.812 717.588C343.192 716.701 343.711 715.916 344.37 715.232C345.029 714.548 345.814 714.029 346.726 713.674C345.586 713.142 344.661 712.382 343.952 711.394C343.268 710.406 342.926 709.291 342.926 708.05C342.926 706.809 343.268 705.643 343.952 704.554C344.636 703.465 345.649 702.591 346.992 701.932C348.335 701.273 350.007 700.944 352.008 700.944C354.009 700.944 355.681 701.273 357.024 701.932C358.367 702.591 359.38 703.465 360.064 704.554C360.748 705.643 361.09 706.809 361.09 708.05C361.09 709.266 360.735 710.381 360.026 711.394C359.342 712.382 358.43 713.142 357.29 713.674C358.202 714.054 358.987 714.586 359.646 715.27C360.33 715.929 360.849 716.701 361.204 717.588C361.584 718.475 361.774 719.463 361.774 720.552C361.774 722.123 361.331 723.503 360.444 724.694C359.583 725.885 358.417 726.809 356.948 727.468C355.479 728.127 353.832 728.456 352.008 728.456ZM352.008 724.162C353.579 724.162 354.757 723.782 355.542 723.022C356.327 722.262 356.72 721.299 356.72 720.134C356.72 718.842 356.302 717.829 355.466 717.094C354.655 716.334 353.503 715.954 352.008 715.954C350.539 715.954 349.373 716.334 348.512 717.094C347.676 717.829 347.258 718.842 347.258 720.134C347.258 721.299 347.663 722.262 348.474 723.022C349.285 723.782 350.463 724.162 352.008 724.162ZM352.008 712.192C353.3 712.192 354.288 711.863 354.972 711.204C355.681 710.545 356.036 709.697 356.036 708.658C356.036 707.543 355.681 706.682 354.972 706.074C354.288 705.441 353.3 705.124 352.008 705.124C350.741 705.124 349.753 705.441 349.044 706.074C348.335 706.682 347.98 707.556 347.98 708.696C347.98 709.709 348.335 710.545 349.044 711.204C349.753 711.863 350.741 712.192 352.008 712.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M290.628 728.456C288.779 728.456 287.208 728.101 285.916 727.392C284.624 726.657 283.623 725.707 282.914 724.542C282.23 723.377 281.812 722.123 281.66 720.78H286.448C286.676 721.895 287.145 722.756 287.854 723.364C288.589 723.947 289.539 724.238 290.704 724.238C291.793 724.238 292.731 723.921 293.516 723.288C294.327 722.629 294.96 721.654 295.416 720.362C295.872 719.045 296.125 717.423 296.176 715.498C296.176 715.422 296.176 715.346 296.176 715.27C296.176 715.194 296.176 715.131 296.176 715.08C295.821 715.739 295.302 716.347 294.618 716.904C293.934 717.436 293.161 717.854 292.3 718.158C291.464 718.462 290.565 718.614 289.602 718.614C288.158 718.614 286.79 718.259 285.498 717.55C284.206 716.841 283.167 715.84 282.382 714.548C281.597 713.256 281.204 711.723 281.204 709.95C281.204 708.329 281.597 706.834 282.382 705.466C283.167 704.098 284.257 703.009 285.65 702.198C287.043 701.362 288.652 700.944 290.476 700.944C292.503 700.944 294.2 701.311 295.568 702.046C296.936 702.781 298.025 703.769 298.836 705.01C299.672 706.251 300.267 707.645 300.622 709.19C301.002 710.71 301.192 712.255 301.192 713.826C301.192 716.79 300.774 719.374 299.938 721.578C299.127 723.757 297.937 725.454 296.366 726.67C294.795 727.861 292.883 728.456 290.628 728.456ZM290.818 714.282C291.73 714.282 292.528 714.092 293.212 713.712C293.921 713.332 294.479 712.813 294.884 712.154C295.315 711.47 295.53 710.697 295.53 709.836C295.53 708.949 295.315 708.164 294.884 707.48C294.479 706.796 293.921 706.277 293.212 705.922C292.503 705.542 291.692 705.352 290.78 705.352C289.893 705.352 289.095 705.542 288.386 705.922C287.677 706.302 287.119 706.821 286.714 707.48C286.334 708.139 286.144 708.911 286.144 709.798C286.144 710.685 286.334 711.47 286.714 712.154C287.119 712.813 287.677 713.332 288.386 713.712C289.095 714.092 289.906 714.282 290.818 714.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M337.89 878V857.29L333.178 858.544V854.44L340.094 851.4H343.21V878H337.89ZM359.218 878.456C356.811 878.456 354.734 877.873 352.986 876.708C351.238 875.543 349.895 873.934 348.958 871.882C348.046 869.805 347.59 867.411 347.59 864.7C347.59 861.989 348.046 859.608 348.958 857.556C349.895 855.479 351.225 853.857 352.948 852.692C354.696 851.527 356.786 850.944 359.218 850.944C361.65 850.944 363.727 851.527 365.45 852.692C367.198 853.857 368.528 855.479 369.44 857.556C370.377 859.608 370.846 861.989 370.846 864.7C370.846 867.411 370.377 869.805 369.44 871.882C368.528 873.934 367.198 875.543 365.45 876.708C363.727 877.873 361.65 878.456 359.218 878.456ZM359.218 873.858C360.484 873.858 361.599 873.491 362.562 872.756C363.524 871.996 364.272 870.932 364.804 869.564C365.361 868.196 365.64 866.575 365.64 864.7C365.64 862.8 365.361 861.179 364.804 859.836C364.272 858.468 363.524 857.417 362.562 856.682C361.599 855.947 360.484 855.58 359.218 855.58C357.951 855.58 356.836 855.947 355.874 856.682C354.911 857.417 354.151 858.468 353.594 859.836C353.062 861.179 352.796 862.8 352.796 864.7C352.796 866.575 353.062 868.196 353.594 869.564C354.151 870.932 354.911 871.996 355.874 872.756C356.836 873.491 357.951 873.858 359.218 873.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M283.89 880V859.29L279.178 860.544V856.44L286.094 853.4H289.21V880H283.89ZM297.732 880V859.29L293.02 860.544V856.44L299.936 853.4H303.052V880H297.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M14.89 880V859.29L10.178 860.544V856.44L17.094 853.4H20.21V880H14.89ZM24.7418 880V876.238C26.3631 874.946 27.9338 873.654 29.4538 872.362C30.9991 871.07 32.3798 869.791 33.5958 868.524C34.8118 867.232 35.7745 865.978 36.4838 864.762C37.1931 863.546 37.5478 862.368 37.5478 861.228C37.5478 860.519 37.4211 859.873 37.1678 859.29C36.9145 858.682 36.5091 858.201 35.9518 857.846C35.4198 857.466 34.7105 857.276 33.8238 857.276C32.9371 857.276 32.1898 857.479 31.5818 857.884C30.9738 858.289 30.5178 858.834 30.2138 859.518C29.9098 860.177 29.7578 860.924 29.7578 861.76H24.7798C24.8558 859.809 25.2991 858.175 26.1098 856.858C26.9205 855.541 28.0098 854.565 29.3778 853.932C30.7458 853.273 32.2785 852.944 33.9758 852.944C35.8505 852.944 37.4338 853.299 38.7258 854.008C40.0178 854.692 40.9931 855.629 41.6518 856.82C42.3358 858.011 42.6778 859.379 42.6778 860.924C42.6778 862.089 42.4625 863.229 42.0318 864.344C41.6265 865.459 41.0438 866.548 40.2838 867.612C39.5491 868.651 38.7131 869.651 37.7758 870.614C36.8385 871.577 35.8631 872.501 34.8498 873.388C33.8365 874.249 32.8485 875.06 31.8858 875.82H43.3238V880H24.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 880V859.29L70.178 860.544V856.44L77.094 853.4H80.21V880H74.89ZM94.2418 880.456C92.5191 880.456 90.9358 880.139 89.4918 879.506C88.0478 878.873 86.8951 877.91 86.0338 876.618C85.1725 875.326 84.7165 873.692 84.6658 871.716H89.6818C89.7071 872.552 89.8971 873.312 90.2518 873.996C90.6065 874.655 91.1258 875.187 91.8098 875.592C92.4938 875.972 93.3045 876.162 94.2418 876.162C95.1285 876.162 95.8885 875.985 96.5218 875.63C97.1551 875.275 97.6365 874.807 97.9658 874.224C98.2951 873.641 98.4598 872.97 98.4598 872.21C98.4598 871.323 98.2318 870.589 97.7758 870.006C97.3451 869.398 96.7371 868.942 95.9518 868.638C95.1918 868.334 94.3178 868.182 93.3298 868.182H91.3538V863.964H93.3298C94.5711 863.964 95.6098 863.673 96.4458 863.09C97.3071 862.507 97.7378 861.633 97.7378 860.468C97.7378 859.505 97.4211 858.733 96.7878 858.15C96.1798 857.567 95.3185 857.276 94.2038 857.276C92.9878 857.276 92.0378 857.631 91.3538 858.34C90.6698 859.049 90.2898 859.923 90.2138 860.962H85.1978C85.2738 859.29 85.6918 857.859 86.4518 856.668C87.2371 855.452 88.2885 854.527 89.6058 853.894C90.9231 853.261 92.4558 852.944 94.2038 852.944C96.0531 852.944 97.6111 853.273 98.8778 853.932C100.17 854.565 101.145 855.427 101.804 856.516C102.462 857.605 102.792 858.783 102.792 860.05C102.792 861.089 102.589 862.013 102.184 862.824C101.804 863.635 101.284 864.306 100.626 864.838C99.9671 865.37 99.2451 865.75 98.4598 865.978C99.4478 866.181 100.309 866.573 101.044 867.156C101.804 867.713 102.386 868.435 102.792 869.322C103.222 870.209 103.438 871.235 103.438 872.4C103.438 873.844 103.083 875.187 102.374 876.428C101.69 877.644 100.651 878.619 99.2578 879.354C97.8898 880.089 96.2178 880.456 94.2418 880.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 726V705.29L8.178 706.544V702.44L15.094 699.4H18.21V726H12.89ZM35.6238 726V721.174H22.5518V717.108L34.9398 699.4H40.7538V716.728H44.2118V721.174H40.7538V726H35.6238ZM28.0238 716.728H35.9658V705.062L28.0238 716.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 726V705.29L70.178 706.544V702.44L77.094 699.4H80.21V726H74.89ZM94.9638 726.456C93.0385 726.456 91.3665 726.114 89.9478 725.43C88.5545 724.746 87.4651 723.809 86.6798 722.618C85.8945 721.427 85.4385 720.072 85.3118 718.552H90.3278C90.5051 719.54 91.0118 720.376 91.8478 721.06C92.6838 721.744 93.7351 722.086 95.0018 722.086C95.9138 722.086 96.7118 721.858 97.3958 721.402C98.0798 720.946 98.6118 720.338 98.9918 719.578C99.3718 718.793 99.5618 717.906 99.5618 716.918C99.5618 715.905 99.3591 715.031 98.9538 714.296C98.5738 713.561 98.0418 712.991 97.3578 712.586C96.6991 712.181 95.9391 711.978 95.0778 711.978C93.9885 711.978 93.0511 712.244 92.2658 712.776C91.5058 713.283 90.9611 713.903 90.6318 714.638H85.6538L87.8578 699.4H102.792V703.884H91.6578L90.5558 709.812C91.1131 709.229 91.8605 708.761 92.7978 708.406C93.7351 708.026 94.7865 707.836 95.9518 707.836C97.3958 707.836 98.6498 708.089 99.7138 708.596C100.778 709.077 101.664 709.749 102.374 710.61C103.083 711.446 103.615 712.409 103.97 713.498C104.324 714.562 104.502 715.689 104.502 716.88C104.502 718.273 104.261 719.553 103.78 720.718C103.324 721.883 102.665 722.897 101.804 723.758C100.968 724.619 99.9671 725.291 98.8018 725.772C97.6618 726.228 96.3825 726.456 94.9638 726.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 570V549.29L9.178 550.544V546.44L16.094 543.4H19.21V570H13.89ZM34.4578 570.456C32.4565 570.456 30.7591 570.089 29.3658 569.354C27.9978 568.619 26.8958 567.631 26.0598 566.39C25.2491 565.149 24.6538 563.768 24.2738 562.248C23.9191 560.703 23.7418 559.145 23.7418 557.574C23.7418 554.585 24.1598 552.001 24.9958 549.822C25.8318 547.643 27.0351 545.959 28.6058 544.768C30.1765 543.552 32.0765 542.944 34.3058 542.944C36.1805 542.944 37.7638 543.311 39.0558 544.046C40.3478 544.755 41.3485 545.693 42.0578 546.858C42.7671 548.023 43.1851 549.277 43.3118 550.62H38.5238C38.3211 549.505 37.8525 548.657 37.1178 548.074C36.3831 547.466 35.4331 547.162 34.2678 547.162C33.1785 547.162 32.2285 547.491 31.4178 548.15C30.6071 548.809 29.9738 549.797 29.5178 551.114C29.0871 552.431 28.8338 554.091 28.7578 556.092C28.7578 556.117 28.7578 556.155 28.7578 556.206C28.7578 556.257 28.7578 556.295 28.7578 556.32C29.1631 555.636 29.6951 555.028 30.3538 554.496C31.0125 553.964 31.7725 553.546 32.6338 553.242C33.4951 552.938 34.4071 552.786 35.3698 552.786C36.8391 552.786 38.2071 553.141 39.4738 553.85C40.7405 554.559 41.7665 555.56 42.5518 556.852C43.3371 558.144 43.7298 559.677 43.7298 561.45C43.7298 563.046 43.3371 564.541 42.5518 565.934C41.7918 567.302 40.7151 568.404 39.3218 569.24C37.9285 570.051 36.3071 570.456 34.4578 570.456ZM34.1538 566.048C35.0658 566.048 35.8638 565.858 36.5478 565.478C37.2571 565.098 37.8145 564.579 38.2198 563.92C38.6251 563.236 38.8278 562.463 38.8278 561.602C38.8278 560.69 38.6251 559.905 38.2198 559.246C37.8145 558.587 37.2571 558.068 36.5478 557.688C35.8385 557.308 35.0278 557.118 34.1158 557.118C33.2291 557.118 32.4311 557.308 31.7218 557.688C31.0125 558.068 30.4425 558.6 30.0118 559.284C29.6065 559.943 29.4038 560.703 29.4038 561.564C29.4038 562.451 29.6065 563.236 30.0118 563.92C30.4425 564.579 31.0125 565.098 31.7218 565.478C32.4565 565.858 33.2671 566.048 34.1538 566.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M76.89 570V549.29L72.178 550.544V546.44L79.094 543.4H82.21V570H76.89ZM89.0598 570L98.8258 547.77H85.9438V543.4H104.07V547.01L94.3798 570H89.0598Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 438V417.29L8.178 418.544V414.44L15.094 411.4H18.21V438H12.89ZM32.8498 438.456C31.0511 438.456 29.4045 438.127 27.9098 437.468C26.4405 436.809 25.2751 435.885 24.4138 434.694C23.5525 433.503 23.1218 432.123 23.1218 430.552C23.1218 429.463 23.2991 428.475 23.6538 427.588C24.0338 426.701 24.5531 425.916 25.2118 425.232C25.8705 424.548 26.6558 424.029 27.5678 423.674C26.4278 423.142 25.5031 422.382 24.7938 421.394C24.1098 420.406 23.7678 419.291 23.7678 418.05C23.7678 416.809 24.1098 415.643 24.7938 414.554C25.4778 413.465 26.4911 412.591 27.8338 411.932C29.1765 411.273 30.8485 410.944 32.8498 410.944C34.8511 410.944 36.5231 411.273 37.8658 411.932C39.2085 412.591 40.2218 413.465 40.9058 414.554C41.5898 415.643 41.9318 416.809 41.9318 418.05C41.9318 419.266 41.5771 420.381 40.8678 421.394C40.1838 422.382 39.2718 423.142 38.1318 423.674C39.0438 424.054 39.8291 424.586 40.4878 425.27C41.1718 425.929 41.6911 426.701 42.0458 427.588C42.4258 428.475 42.6158 429.463 42.6158 430.552C42.6158 432.123 42.1725 433.503 41.2858 434.694C40.4245 435.885 39.2591 436.809 37.7898 437.468C36.3205 438.127 34.6738 438.456 32.8498 438.456ZM32.8498 434.162C34.4205 434.162 35.5985 433.782 36.3838 433.022C37.1691 432.262 37.5618 431.299 37.5618 430.134C37.5618 428.842 37.1438 427.829 36.3078 427.094C35.4971 426.334 34.3445 425.954 32.8498 425.954C31.3805 425.954 30.2151 426.334 29.3538 427.094C28.5178 427.829 28.0998 428.842 28.0998 430.134C28.0998 431.299 28.5051 432.262 29.3158 433.022C30.1265 433.782 31.3045 434.162 32.8498 434.162ZM32.8498 422.192C34.1418 422.192 35.1298 421.863 35.8138 421.204C36.5231 420.545 36.8778 419.697 36.8778 418.658C36.8778 417.543 36.5231 416.682 35.8138 416.074C35.1298 415.441 34.1418 415.124 32.8498 415.124C31.5831 415.124 30.5951 415.441 29.8858 416.074C29.1765 416.682 28.8218 417.556 28.8218 418.696C28.8218 419.709 29.1765 420.545 29.8858 421.204C30.5951 421.863 31.5831 422.192 32.8498 422.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 438V417.29L70.178 418.544V414.44L77.094 411.4H80.21V438H74.89ZM94.4698 438.456C92.6205 438.456 91.0498 438.101 89.7578 437.392C88.4658 436.657 87.4651 435.707 86.7558 434.542C86.0718 433.377 85.6538 432.123 85.5018 430.78H90.2898C90.5178 431.895 90.9865 432.756 91.6958 433.364C92.4305 433.947 93.3805 434.238 94.5458 434.238C95.6351 434.238 96.5725 433.921 97.3578 433.288C98.1685 432.629 98.8018 431.654 99.2578 430.362C99.7138 429.045 99.9671 427.423 100.018 425.498C100.018 425.422 100.018 425.346 100.018 425.27C100.018 425.194 100.018 425.131 100.018 425.08C99.6631 425.739 99.1438 426.347 98.4598 426.904C97.7758 427.436 97.0031 427.854 96.1418 428.158C95.3058 428.462 94.4065 428.614 93.4438 428.614C91.9998 428.614 90.6318 428.259 89.3398 427.55C88.0478 426.841 87.0091 425.84 86.2238 424.548C85.4385 423.256 85.0458 421.723 85.0458 419.95C85.0458 418.329 85.4385 416.834 86.2238 415.466C87.0091 414.098 88.0985 413.009 89.4918 412.198C90.8851 411.362 92.4938 410.944 94.3178 410.944C96.3445 410.944 98.0418 411.311 99.4098 412.046C100.778 412.781 101.867 413.769 102.678 415.01C103.514 416.251 104.109 417.645 104.464 419.19C104.844 420.71 105.034 422.255 105.034 423.826C105.034 426.79 104.616 429.374 103.78 431.578C102.969 433.757 101.778 435.454 100.208 436.67C98.6371 437.861 96.7245 438.456 94.4698 438.456ZM94.6598 424.282C95.5718 424.282 96.3698 424.092 97.0538 423.712C97.7631 423.332 98.3205 422.813 98.7258 422.154C99.1565 421.47 99.3718 420.697 99.3718 419.836C99.3718 418.949 99.1565 418.164 98.7258 417.48C98.3205 416.796 97.7631 416.277 97.0538 415.922C96.3445 415.542 95.5338 415.352 94.6218 415.352C93.7351 415.352 92.9371 415.542 92.2278 415.922C91.5185 416.302 90.9611 416.821 90.5558 417.48C90.1758 418.139 89.9858 418.911 89.9858 419.798C89.9858 420.685 90.1758 421.47 90.5558 422.154C90.9611 422.813 91.5185 423.332 92.2278 423.712C92.9371 424.092 93.7478 424.282 94.6598 424.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M3.9 314V310.238C5.52133 308.946 7.092 307.654 8.612 306.362C10.1573 305.07 11.538 303.791 12.754 302.524C13.97 301.232 14.9327 299.978 15.642 298.762C16.3513 297.546 16.706 296.368 16.706 295.228C16.706 294.519 16.5793 293.873 16.326 293.29C16.0727 292.682 15.6673 292.201 15.11 291.846C14.578 291.466 13.8687 291.276 12.982 291.276C12.0953 291.276 11.348 291.479 10.74 291.884C10.132 292.289 9.676 292.834 9.372 293.518C9.068 294.177 8.916 294.924 8.916 295.76H3.938C4.014 293.809 4.45733 292.175 5.268 290.858C6.07867 289.541 7.168 288.565 8.536 287.932C9.904 287.273 11.4367 286.944 13.134 286.944C15.0087 286.944 16.592 287.299 17.884 288.008C19.176 288.692 20.1513 289.629 20.81 290.82C21.494 292.011 21.836 293.379 21.836 294.924C21.836 296.089 21.6207 297.229 21.19 298.344C20.7847 299.459 20.202 300.548 19.442 301.612C18.7073 302.651 17.8713 303.651 16.934 304.614C15.9967 305.577 15.0213 306.501 14.008 307.388C12.9947 308.249 12.0067 309.06 11.044 309.82H22.482V314H3.9ZM37.1592 314.456C34.7525 314.456 32.6752 313.873 30.9272 312.708C29.1792 311.543 27.8365 309.934 26.8992 307.882C25.9872 305.805 25.5312 303.411 25.5312 300.7C25.5312 297.989 25.9872 295.608 26.8992 293.556C27.8365 291.479 29.1665 289.857 30.8892 288.692C32.6372 287.527 34.7272 286.944 37.1592 286.944C39.5912 286.944 41.6685 287.527 43.3912 288.692C45.1392 289.857 46.4692 291.479 47.3812 293.556C48.3185 295.608 48.7872 297.989 48.7872 300.7C48.7872 303.411 48.3185 305.805 47.3812 307.882C46.4692 309.934 45.1392 311.543 43.3912 312.708C41.6685 313.873 39.5912 314.456 37.1592 314.456ZM37.1592 309.858C38.4259 309.858 39.5405 309.491 40.5032 308.756C41.4659 307.996 42.2132 306.932 42.7452 305.564C43.3025 304.196 43.5812 302.575 43.5812 300.7C43.5812 298.8 43.3025 297.179 42.7452 295.836C42.2132 294.468 41.4659 293.417 40.5032 292.682C39.5405 291.947 38.4259 291.58 37.1592 291.58C35.8925 291.58 34.7779 291.947 33.8152 292.682C32.8525 293.417 32.0925 294.468 31.5352 295.836C31.0032 297.179 30.7372 298.8 30.7372 300.7C30.7372 302.575 31.0032 304.196 31.5352 305.564C32.0925 306.932 32.8525 307.996 33.8152 308.756C34.7779 309.491 35.8925 309.858 37.1592 309.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M71.9 314V310.238C73.5213 308.946 75.092 307.654 76.612 306.362C78.1573 305.07 79.538 303.791 80.754 302.524C81.97 301.232 82.9327 299.978 83.642 298.762C84.3513 297.546 84.706 296.368 84.706 295.228C84.706 294.519 84.5793 293.873 84.326 293.29C84.0727 292.682 83.6673 292.201 83.11 291.846C82.578 291.466 81.8687 291.276 80.982 291.276C80.0953 291.276 79.348 291.479 78.74 291.884C78.132 292.289 77.676 292.834 77.372 293.518C77.068 294.177 76.916 294.924 76.916 295.76H71.938C72.014 293.809 72.4573 292.175 73.268 290.858C74.0787 289.541 75.168 288.565 76.536 287.932C77.904 287.273 79.4367 286.944 81.134 286.944C83.0087 286.944 84.592 287.299 85.884 288.008C87.176 288.692 88.1513 289.629 88.81 290.82C89.494 292.011 89.836 293.379 89.836 294.924C89.836 296.089 89.6207 297.229 89.19 298.344C88.7847 299.459 88.202 300.548 87.442 301.612C86.7073 302.651 85.8713 303.651 84.934 304.614C83.9967 305.577 83.0213 306.501 82.008 307.388C80.9947 308.249 80.0067 309.06 79.044 309.82H90.482V314H71.9ZM97.8216 314V293.29L93.1096 294.544V290.44L100.026 287.4H103.142V314H97.8216Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M32.9 187V183.238C34.5213 181.946 36.092 180.654 37.612 179.362C39.1573 178.07 40.538 176.791 41.754 175.524C42.97 174.232 43.9327 172.978 44.642 171.762C45.3513 170.546 45.706 169.368 45.706 168.228C45.706 167.519 45.5793 166.873 45.326 166.29C45.0727 165.682 44.6673 165.201 44.11 164.846C43.578 164.466 42.8687 164.276 41.982 164.276C41.0953 164.276 40.348 164.479 39.74 164.884C39.132 165.289 38.676 165.834 38.372 166.518C38.068 167.177 37.916 167.924 37.916 168.76H32.938C33.014 166.809 33.4573 165.175 34.268 163.858C35.0787 162.541 36.168 161.565 37.536 160.932C38.904 160.273 40.4367 159.944 42.134 159.944C44.0087 159.944 45.592 160.299 46.884 161.008C48.176 161.692 49.1513 162.629 49.81 163.82C50.494 165.011 50.836 166.379 50.836 167.924C50.836 169.089 50.6207 170.229 50.19 171.344C49.7847 172.459 49.202 173.548 48.442 174.612C47.7073 175.651 46.8713 176.651 45.934 177.614C44.9967 178.577 44.0213 179.501 43.008 180.388C41.9947 181.249 41.0067 182.06 40.044 182.82H51.482V187H32.9ZM54.8316 187V183.238C56.453 181.946 58.0236 180.654 59.5436 179.362C61.089 178.07 62.4696 176.791 63.6856 175.524C64.9016 174.232 65.8643 172.978 66.5736 171.762C67.283 170.546 67.6376 169.368 67.6376 168.228C67.6376 167.519 67.511 166.873 67.2576 166.29C67.0043 165.682 66.599 165.201 66.0416 164.846C65.5096 164.466 64.8003 164.276 63.9136 164.276C63.027 164.276 62.2796 164.479 61.6716 164.884C61.0636 165.289 60.6076 165.834 60.3036 166.518C59.9996 167.177 59.8476 167.924 59.8476 168.76H54.8696C54.9456 166.809 55.389 165.175 56.1996 163.858C57.0103 162.541 58.0996 161.565 59.4676 160.932C60.8356 160.273 62.3683 159.944 64.0656 159.944C65.9403 159.944 67.5236 160.299 68.8156 161.008C70.1076 161.692 71.083 162.629 71.7416 163.82C72.4256 165.011 72.7676 166.379 72.7676 167.924C72.7676 169.089 72.5523 170.229 72.1216 171.344C71.7163 172.459 71.1336 173.548 70.3736 174.612C69.639 175.651 68.803 176.651 67.8656 177.614C66.9283 178.577 65.953 179.501 64.9396 180.388C63.9263 181.249 62.9383 182.06 61.9756 182.82H73.4136V187H54.8316Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );

  const tyreSvgs = {
    6: truck6,
    10: truck10,
    12: truck12,
    14: truck14,
    16: truck16,
    18: truck18,
    22: truck22,
  };

  const truckNew6 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => {
    return (
      <svg
        width="272"
        height="256"
        viewBox="0 0 472 656"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M414.826 623.393C414.826 640.295 401.084 654.038 384.181 654.038H87.8185C70.9163 654.038 57.174 640.295 57.174 623.393V316.937H55.9009V623.393C55.9009 641 70.2229 655.322 87.8299 655.322H384.181C401.788 655.322 416.11 641 416.11 623.393V316.937H414.837V623.393H414.826ZM337.248 12.1624H134.763C91.2854 12.1624 55.9009 47.5354 55.9009 91.0242V192.324H57.174V91.0242C57.174 48.2401 91.9787 13.4354 134.763 13.4354H337.248C380.033 13.4354 414.837 48.2288 414.837 91.0242V192.324H416.11V91.0242C416.11 47.5354 380.737 12.1624 337.248 12.1624Z"
          fill="#231F20"
        />
        <path
          d="M404.437 621.688C404.437 634.157 394.286 644.296 381.817 644.296H90.1828C77.7136 644.296 67.5632 634.157 67.5632 621.688V316.937H66.2901V621.688C66.2901 634.862 77.0089 645.569 90.1828 645.569H381.817C395.002 645.569 405.71 634.862 405.71 621.688V316.937H404.437V621.688ZM334.896 21.8922H137.116C98.0599 21.8922 66.2901 53.6734 66.2901 92.7178V192.313H67.5632V92.7178C67.5632 54.3781 98.7646 23.1653 137.116 23.1653H334.896C373.235 23.1653 404.437 54.3781 404.437 92.7178V192.313H405.71V92.7178C405.71 53.6734 373.94 21.8922 334.896 21.8922Z"
          fill="#231F20"
        />
        <path
          opacity="0.6"
          d="M382.317 59.1521H85.386C98.0371 41.7838 118.531 30.4854 141.674 30.4854H325.245C348.615 30.4854 369.348 41.7611 382.317 59.1521Z"
          fill="#999999"
        />
        <path
          opacity="0.6"
          d="M175.615 12.7989H125.431C127.556 5.0468 131.023 0 134.933 0H165.964C169.92 0 173.421 5.03543 175.615 12.7989Z"
          fill="#999999"
        />
        <path
          opacity="0.6"
          d="M341.602 12.7989H291.418C293.555 5.0468 297.022 0 300.932 0H331.963C335.919 0 339.42 5.03543 341.613 12.7989H341.602Z"
          fill="#999999"
        />
        <path
          d="M458.963 91.8994H439.264C432.751 91.8994 427.466 97.1963 427.466 103.698V105.164H421.532C421.146 103.073 419.316 101.482 417.111 101.482C416.565 101.482 416.122 101.925 416.122 102.47V126.079C416.122 126.625 416.565 127.068 417.111 127.068C419.463 127.068 421.373 125.249 421.578 122.942L436.002 117.77H458.963C463.839 117.77 467.806 113.803 467.806 108.927V100.731C467.806 95.855 463.839 91.8881 458.963 91.8881V91.8994ZM421.612 120.828V107.165H427.466V116.792C427.466 117.338 427.909 117.781 428.455 117.781H430.114L421.612 120.828ZM465.817 108.938C465.817 112.723 462.748 115.792 458.963 115.792H429.455V103.698C429.455 98.2875 433.854 93.8772 439.276 93.8772H458.974C462.759 93.8772 465.828 96.9462 465.828 100.731V108.927L465.817 108.938Z"
          fill="#999999"
        />
        <path
          d="M459.042 96.1733H439.139C435.138 96.1733 431.887 99.4241 431.887 103.425V112.507C431.887 113.053 432.331 113.496 432.876 113.496H459.042C461.429 113.496 463.373 111.552 463.373 109.165V100.504C463.373 98.117 461.429 96.1733 459.042 96.1733Z"
          fill="#999999"
        />
        <path
          d="M13.0601 91.8994H32.7585C39.2716 91.8994 44.5571 97.1963 44.5571 103.698V105.164H50.4905C50.8769 103.073 52.707 101.482 54.9121 101.482C55.4577 101.482 55.901 101.925 55.901 102.47V126.079C55.901 126.625 55.4577 127.068 54.9121 127.068C52.5592 127.068 50.6496 125.249 50.445 122.942L36.0207 117.77H13.0601C8.18376 117.77 4.2168 113.803 4.2168 108.927V100.731C4.2168 95.855 8.18376 91.8881 13.0601 91.8881V91.8994ZM50.3995 120.828V107.165H44.5457V116.792C44.5457 117.338 44.1024 117.781 43.5568 117.781H41.8973L50.3995 120.828ZM6.20596 108.938C6.20596 112.723 9.27496 115.792 13.0601 115.792H42.5679V103.698C42.5679 98.2875 38.169 93.8772 32.7471 93.8772H13.0601C9.27496 93.8772 6.20596 96.9462 6.20596 100.731V108.927V108.938Z"
          fill="#999999"
        />
        <path
          d="M12.9691 96.1733H32.8721C36.8732 96.1733 40.1241 99.4241 40.1241 103.425V112.507C40.1241 113.053 39.6808 113.496 39.1352 113.496H12.9691C10.5821 113.496 8.63843 111.552 8.63843 109.165V100.504C8.63843 98.117 10.5821 96.1733 12.9691 96.1733Z"
          fill="#999999"
        />
        <path
          d="M66.6084 486.243H56.5716V553.056H66.6084V486.243Z"
          fill="#231F20"
        />
        <path
          d="M415.224 486.243H405.187V553.056H415.224V486.243Z"
          fill="#231F20"
        />
        <rect
          x="67"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(5)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(5)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(5, "new")}
          className="cursor-pointer"
          key={5}
        />
        <rect
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(4)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(4)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(4, "new")}
          className="cursor-pointer"
          key={4}
        />
        <rect
          x="349"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(3)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(3)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(3, "new")}
          className="cursor-pointer"
          key={3}
        />
        <rect
          x="416"
          y="457"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(2)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(2)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(2, "new")}
          className="cursor-pointer"
          key={2}
        />
        <rect
          x="382"
          y="192"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(1)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(1)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(1, "new")}
          className="cursor-pointer"
          key={1}
        />
        <rect
          x="34"
          y="192"
          width="56"
          height="126"
          rx="18"
          fill={
            selectedNewTyre?.includes(6)
              ? "rgba(58, 165, 86, 1)"
              : newAddedTyre?.includes(6)
              ? "rgb(77, 120, 137)"
              : "#999999"
          }
          onClick={() => handleSelection(6, "new")}
          className="cursor-pointer"
          key={6}
        />
        <path
          d="M408.89 269V248.29L404.178 249.544V245.44L411.094 242.4H414.21V269H408.89Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M434.9 533V529.238C436.521 527.946 438.092 526.654 439.612 525.362C441.157 524.07 442.538 522.791 443.754 521.524C444.97 520.232 445.933 518.978 446.642 517.762C447.351 516.546 447.706 515.368 447.706 514.228C447.706 513.519 447.579 512.873 447.326 512.29C447.073 511.682 446.667 511.201 446.11 510.846C445.578 510.466 444.869 510.276 443.982 510.276C443.095 510.276 442.348 510.479 441.74 510.884C441.132 511.289 440.676 511.834 440.372 512.518C440.068 513.177 439.916 513.924 439.916 514.76H434.938C435.014 512.809 435.457 511.175 436.268 509.858C437.079 508.541 438.168 507.565 439.536 506.932C440.904 506.273 442.437 505.944 444.134 505.944C446.009 505.944 447.592 506.299 448.884 507.008C450.176 507.692 451.151 508.629 451.81 509.82C452.494 511.011 452.836 512.379 452.836 513.924C452.836 515.089 452.621 516.229 452.19 517.344C451.785 518.459 451.202 519.548 450.442 520.612C449.707 521.651 448.871 522.651 447.934 523.614C446.997 524.577 446.021 525.501 445.008 526.388C443.995 527.249 443.007 528.06 442.044 528.82H453.482V533H434.9Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M377.4 533.456C375.677 533.456 374.094 533.139 372.65 532.506C371.206 531.873 370.053 530.91 369.192 529.618C368.331 528.326 367.875 526.692 367.824 524.716H372.84C372.865 525.552 373.055 526.312 373.41 526.996C373.765 527.655 374.284 528.187 374.968 528.592C375.652 528.972 376.463 529.162 377.4 529.162C378.287 529.162 379.047 528.985 379.68 528.63C380.313 528.275 380.795 527.807 381.124 527.224C381.453 526.641 381.618 525.97 381.618 525.21C381.618 524.323 381.39 523.589 380.934 523.006C380.503 522.398 379.895 521.942 379.11 521.638C378.35 521.334 377.476 521.182 376.488 521.182H374.512V516.964H376.488C377.729 516.964 378.768 516.673 379.604 516.09C380.465 515.507 380.896 514.633 380.896 513.468C380.896 512.505 380.579 511.733 379.946 511.15C379.338 510.567 378.477 510.276 377.362 510.276C376.146 510.276 375.196 510.631 374.512 511.34C373.828 512.049 373.448 512.923 373.372 513.962H368.356C368.432 512.29 368.85 510.859 369.61 509.668C370.395 508.452 371.447 507.527 372.764 506.894C374.081 506.261 375.614 505.944 377.362 505.944C379.211 505.944 380.769 506.273 382.036 506.932C383.328 507.565 384.303 508.427 384.962 509.516C385.621 510.605 385.95 511.783 385.95 513.05C385.95 514.089 385.747 515.013 385.342 515.824C384.962 516.635 384.443 517.306 383.784 517.838C383.125 518.37 382.403 518.75 381.618 518.978C382.606 519.181 383.467 519.573 384.202 520.156C384.962 520.713 385.545 521.435 385.95 522.322C386.381 523.209 386.596 524.235 386.596 525.4C386.596 526.844 386.241 528.187 385.532 529.428C384.848 530.644 383.809 531.619 382.416 532.354C381.048 533.089 379.376 533.456 377.4 533.456Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M29.782 533V528.174H16.71V524.108L29.098 506.4H34.912V523.728H38.37V528.174H34.912V533H29.782ZM22.182 523.728H30.124V512.062L22.182 523.728Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M94.122 533.456C92.1967 533.456 90.5247 533.114 89.106 532.43C87.7127 531.746 86.6233 530.809 85.838 529.618C85.0527 528.427 84.5967 527.072 84.47 525.552H89.486C89.6633 526.54 90.17 527.376 91.006 528.06C91.842 528.744 92.8933 529.086 94.16 529.086C95.072 529.086 95.87 528.858 96.554 528.402C97.238 527.946 97.77 527.338 98.15 526.578C98.53 525.793 98.72 524.906 98.72 523.918C98.72 522.905 98.5173 522.031 98.112 521.296C97.732 520.561 97.2 519.991 96.516 519.586C95.8573 519.181 95.0973 518.978 94.236 518.978C93.1467 518.978 92.2093 519.244 91.424 519.776C90.664 520.283 90.1193 520.903 89.79 521.638H84.812L87.016 506.4H101.95V510.884H90.816L89.714 516.812C90.2713 516.229 91.0187 515.761 91.956 515.406C92.8933 515.026 93.9447 514.836 95.11 514.836C96.554 514.836 97.808 515.089 98.872 515.596C99.936 516.077 100.823 516.749 101.532 517.61C102.241 518.446 102.773 519.409 103.128 520.498C103.483 521.562 103.66 522.689 103.66 523.88C103.66 525.273 103.419 526.553 102.938 527.718C102.482 528.883 101.823 529.897 100.962 530.758C100.126 531.619 99.1253 532.291 97.96 532.772C96.82 533.228 95.5407 533.456 94.122 533.456Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M63.616 269.456C61.6147 269.456 59.9173 269.089 58.524 268.354C57.156 267.619 56.054 266.631 55.218 265.39C54.4073 264.149 53.812 262.768 53.432 261.248C53.0773 259.703 52.9 258.145 52.9 256.574C52.9 253.585 53.318 251.001 54.154 248.822C54.99 246.643 56.1933 244.959 57.764 243.768C59.3347 242.552 61.2347 241.944 63.464 241.944C65.3387 241.944 66.922 242.311 68.214 243.046C69.506 243.755 70.5067 244.693 71.216 245.858C71.9253 247.023 72.3433 248.277 72.47 249.62H67.682C67.4793 248.505 67.0107 247.657 66.276 247.074C65.5413 246.466 64.5913 246.162 63.426 246.162C62.3367 246.162 61.3867 246.491 60.576 247.15C59.7653 247.809 59.132 248.797 58.676 250.114C58.2453 251.431 57.992 253.091 57.916 255.092C57.916 255.117 57.916 255.155 57.916 255.206C57.916 255.257 57.916 255.295 57.916 255.32C58.3213 254.636 58.8533 254.028 59.512 253.496C60.1707 252.964 60.9307 252.546 61.792 252.242C62.6533 251.938 63.5653 251.786 64.528 251.786C65.9973 251.786 67.3653 252.141 68.632 252.85C69.8987 253.559 70.9247 254.56 71.71 255.852C72.4953 257.144 72.888 258.677 72.888 260.45C72.888 262.046 72.4953 263.541 71.71 264.934C70.95 266.302 69.8733 267.404 68.48 268.24C67.0867 269.051 65.4653 269.456 63.616 269.456ZM63.312 265.048C64.224 265.048 65.022 264.858 65.706 264.478C66.4153 264.098 66.9727 263.579 67.378 262.92C67.7833 262.236 67.986 261.463 67.986 260.602C67.986 259.69 67.7833 258.905 67.378 258.246C66.9727 257.587 66.4153 257.068 65.706 256.688C64.9967 256.308 64.186 256.118 63.274 256.118C62.3873 256.118 61.5893 256.308 60.88 256.688C60.1707 257.068 59.6007 257.6 59.17 258.284C58.7647 258.943 58.562 259.703 58.562 260.564C58.562 261.451 58.7647 262.236 59.17 262.92C59.6007 263.579 60.1707 264.098 60.88 264.478C61.6147 264.858 62.4253 265.048 63.312 265.048Z"
          fill="white"
          fillOpacity="0.2"
        />
      </svg>
    );
  };
  const truckNew10 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="298"
      height="353"
      viewBox="0 0 428 683"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M371.35 654.35C371.35 669.22 359.26 681.31 344.39 681.31H83.6601C68.7901 681.31 56.7001 669.22 56.7001 654.35V278.83H55.5801V654.35C55.5801 669.84 68.1801 682.44 83.6701 682.44H344.39C359.88 682.44 372.48 669.84 372.48 654.35V278.83H371.36V654.35H371.35ZM303.09 10.7H124.95C86.7001 10.7 55.5701 41.82 55.5701 80.08V169.2H56.6901V80.08C56.6901 42.44 87.3101 11.82 124.95 11.82H303.09C340.73 11.82 371.35 42.43 371.35 80.08V169.2H372.47V80.08C372.47 41.82 341.35 10.7 303.09 10.7Z"
        fill="#231F20"
      />
      <path
        d="M362.21 652.84C362.21 663.81 353.28 672.73 342.31 672.73H85.74C74.77 672.73 65.84 663.81 65.84 652.84V278.83H64.72V652.84C64.72 664.43 74.15 673.85 85.74 673.85H342.31C353.91 673.85 363.33 664.43 363.33 652.84V278.83H362.21V652.84ZM301.03 19.26H127.03C92.67 19.26 64.72 47.22 64.72 81.57V169.19H65.84V81.57C65.84 47.84 93.29 20.38 127.03 20.38H301.03C334.76 20.38 362.21 47.84 362.21 81.57V169.19H363.33V81.57C363.33 47.22 335.38 19.26 301.03 19.26Z"
        fill="#231F20"
      />
      <path
        opacity="0.6"
        d="M342.75 52.04H81.52C92.65 36.76 110.68 26.82 131.04 26.82H292.54C313.1 26.82 331.34 36.74 342.75 52.04Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M160.89 11.26H116.74C118.62 4.44 121.67 0 125.11 0H152.41C155.89 0 158.97 4.43 160.9 11.26H160.89Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M306.93 11.26H262.78C264.65 4.44 267.7 0 271.14 0H298.44C301.92 0 305 4.43 306.93 11.26Z"
        fill="#999999"
      />
      <path
        d="M410.17 80.85H392.84C387.11 80.85 382.46 85.51 382.46 91.23V92.52H377.24C376.9 90.68 375.29 89.28 373.35 89.28C372.87 89.28 372.48 89.67 372.48 90.15V110.92C372.48 111.4 372.87 111.79 373.35 111.79C375.42 111.79 377.1 110.19 377.28 108.16L389.97 103.61H410.17C414.46 103.61 417.95 100.12 417.95 95.83V88.62C417.95 84.33 414.46 80.84 410.17 80.84V80.85ZM377.32 106.3V94.28H382.47V102.75C382.47 103.23 382.86 103.62 383.34 103.62H384.8L377.32 106.3ZM416.21 95.84C416.21 99.17 413.51 101.87 410.18 101.87H384.22V91.23C384.22 86.47 388.09 82.59 392.86 82.59H410.19C413.52 82.59 416.22 85.29 416.22 88.62V95.83L416.21 95.84Z"
        fill="#999999"
      />
      <path
        d="M410.25 84.61H392.74C389.22 84.61 386.36 87.47 386.36 90.99V98.98C386.36 99.46 386.75 99.85 387.23 99.85H410.25C412.35 99.85 414.06 98.14 414.06 96.04V88.42C414.06 86.32 412.35 84.61 410.25 84.61Z"
        fill="#999999"
      />
      <path
        d="M17.8801 80.85H35.2101C40.9401 80.85 45.5901 85.51 45.5901 91.23V92.52H50.8101C51.1501 90.68 52.7601 89.28 54.7001 89.28C55.1801 89.28 55.5701 89.67 55.5701 90.15V110.92C55.5701 111.4 55.1801 111.79 54.7001 111.79C52.6301 111.79 50.9501 110.19 50.7701 108.16L38.0801 103.61H17.8801C13.5901 103.61 10.1001 100.12 10.1001 95.83V88.62C10.1001 84.33 13.5901 80.84 17.8801 80.84V80.85ZM50.7401 106.3V94.28H45.5901V102.75C45.5901 103.23 45.2001 103.62 44.7201 103.62H43.2601L50.7401 106.3ZM11.8501 95.84C11.8501 99.17 14.5501 101.87 17.8801 101.87H43.8401V91.23C43.8401 86.47 39.9701 82.59 35.2001 82.59H17.8801C14.5501 82.59 11.8501 85.29 11.8501 88.62V95.83V95.84Z"
        fill="#999999"
      />
      <path
        d="M17.81 84.61H35.32C38.84 84.61 41.7 87.47 41.7 90.99V98.98C41.7 99.46 41.31 99.85 40.83 99.85H17.81C15.71 99.85 14 98.14 14 96.04V88.42C14 86.32 15.71 84.61 17.81 84.61Z"
        fill="#999999"
      />
      <path d="M64.7201 366.27H55.8901V425.05H64.7201V366.27Z" fill="#231F20" />
      <path d="M371.42 366.27H362.59V425.05H371.42V366.27Z" fill="#231F20" />
      <path d="M64.9899 529.72H56.1599V588.5H64.9899V529.72Z" fill="#231F20" />
      <path d="M371.69 529.72H362.86V588.5H371.69V529.72Z" fill="#231F20" />
      <rect
        x="307"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        x="372"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="65"
        y="495"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="307"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="372"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="339"
        y="159"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="33"
        y="159"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="65"
        y="330"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <path
        d="M365.89 236V215.29L361.178 216.544V212.44L368.094 209.4H371.21V236H365.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M390.9 406V402.238C392.521 400.946 394.092 399.654 395.612 398.362C397.157 397.07 398.538 395.791 399.754 394.524C400.97 393.232 401.933 391.978 402.642 390.762C403.351 389.546 403.706 388.368 403.706 387.228C403.706 386.519 403.579 385.873 403.326 385.29C403.073 384.682 402.667 384.201 402.11 383.846C401.578 383.466 400.869 383.276 399.982 383.276C399.095 383.276 398.348 383.479 397.74 383.884C397.132 384.289 396.676 384.834 396.372 385.518C396.068 386.177 395.916 386.924 395.916 387.76H390.938C391.014 385.809 391.457 384.175 392.268 382.858C393.079 381.541 394.168 380.565 395.536 379.932C396.904 379.273 398.437 378.944 400.134 378.944C402.009 378.944 403.592 379.299 404.884 380.008C406.176 380.692 407.151 381.629 407.81 382.82C408.494 384.011 408.836 385.379 408.836 386.924C408.836 388.089 408.621 389.229 408.19 390.344C407.785 391.459 407.202 392.548 406.442 393.612C405.707 394.651 404.871 395.651 403.934 396.614C402.997 397.577 402.021 398.501 401.008 399.388C399.995 400.249 399.007 401.06 398.044 401.82H409.482V406H390.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M402.782 572V567.174H389.71V563.108L402.098 545.4H407.912V562.728H411.37V567.174H407.912V572H402.782ZM395.182 562.728H403.124V551.062L395.182 562.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M335.122 572.456C333.197 572.456 331.525 572.114 330.106 571.43C328.713 570.746 327.623 569.809 326.838 568.618C326.053 567.427 325.597 566.072 325.47 564.552H330.486C330.663 565.54 331.17 566.376 332.006 567.06C332.842 567.744 333.893 568.086 335.16 568.086C336.072 568.086 336.87 567.858 337.554 567.402C338.238 566.946 338.77 566.338 339.15 565.578C339.53 564.793 339.72 563.906 339.72 562.918C339.72 561.905 339.517 561.031 339.112 560.296C338.732 559.561 338.2 558.991 337.516 558.586C336.857 558.181 336.097 557.978 335.236 557.978C334.147 557.978 333.209 558.244 332.424 558.776C331.664 559.283 331.119 559.903 330.79 560.638H325.812L328.016 545.4H342.95V549.884H331.816L330.714 555.812C331.271 555.229 332.019 554.761 332.956 554.406C333.893 554.026 334.945 553.836 336.11 553.836C337.554 553.836 338.808 554.089 339.872 554.596C340.936 555.077 341.823 555.749 342.532 556.61C343.241 557.446 343.773 558.409 344.128 559.498C344.483 560.562 344.66 561.689 344.66 562.88C344.66 564.273 344.419 565.553 343.938 566.718C343.482 567.883 342.823 568.897 341.962 569.758C341.126 570.619 340.125 571.291 338.96 571.772C337.82 572.228 336.541 572.456 335.122 572.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M334.4 407.456C332.677 407.456 331.094 407.139 329.65 406.506C328.206 405.873 327.053 404.91 326.192 403.618C325.331 402.326 324.875 400.692 324.824 398.716H329.84C329.865 399.552 330.055 400.312 330.41 400.996C330.765 401.655 331.284 402.187 331.968 402.592C332.652 402.972 333.463 403.162 334.4 403.162C335.287 403.162 336.047 402.985 336.68 402.63C337.313 402.275 337.795 401.807 338.124 401.224C338.453 400.641 338.618 399.97 338.618 399.21C338.618 398.323 338.39 397.589 337.934 397.006C337.503 396.398 336.895 395.942 336.11 395.638C335.35 395.334 334.476 395.182 333.488 395.182H331.512V390.964H333.488C334.729 390.964 335.768 390.673 336.604 390.09C337.465 389.507 337.896 388.633 337.896 387.468C337.896 386.505 337.579 385.733 336.946 385.15C336.338 384.567 335.477 384.276 334.362 384.276C333.146 384.276 332.196 384.631 331.512 385.34C330.828 386.049 330.448 386.923 330.372 387.962H325.356C325.432 386.29 325.85 384.859 326.61 383.668C327.395 382.452 328.447 381.527 329.764 380.894C331.081 380.261 332.614 379.944 334.362 379.944C336.211 379.944 337.769 380.273 339.036 380.932C340.328 381.565 341.303 382.427 341.962 383.516C342.621 384.605 342.95 385.783 342.95 387.05C342.95 388.089 342.747 389.013 342.342 389.824C341.962 390.635 341.443 391.306 340.784 391.838C340.125 392.37 339.403 392.75 338.618 392.978C339.606 393.181 340.467 393.573 341.202 394.156C341.962 394.713 342.545 395.435 342.95 396.322C343.381 397.209 343.596 398.235 343.596 399.4C343.596 400.844 343.241 402.187 342.532 403.428C341.848 404.644 340.809 405.619 339.416 406.354C338.048 407.089 336.376 407.456 334.4 407.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.616 571.456C25.6147 571.456 23.9173 571.089 22.524 570.354C21.156 569.619 20.054 568.631 19.218 567.39C18.4073 566.149 17.812 564.768 17.432 563.248C17.0773 561.703 16.9 560.145 16.9 558.574C16.9 555.585 17.318 553.001 18.154 550.822C18.99 548.643 20.1933 546.959 21.764 545.768C23.3347 544.552 25.2347 543.944 27.464 543.944C29.3387 543.944 30.922 544.311 32.214 545.046C33.506 545.755 34.5067 546.693 35.216 547.858C35.9253 549.023 36.3433 550.277 36.47 551.62H31.682C31.4793 550.505 31.0107 549.657 30.276 549.074C29.5413 548.466 28.5913 548.162 27.426 548.162C26.3367 548.162 25.3867 548.491 24.576 549.15C23.7653 549.809 23.132 550.797 22.676 552.114C22.2453 553.431 21.992 555.091 21.916 557.092C21.916 557.117 21.916 557.155 21.916 557.206C21.916 557.257 21.916 557.295 21.916 557.32C22.3213 556.636 22.8533 556.028 23.512 555.496C24.1707 554.964 24.9307 554.546 25.792 554.242C26.6533 553.938 27.5653 553.786 28.528 553.786C29.9973 553.786 31.3653 554.141 32.632 554.85C33.8987 555.559 34.9247 556.56 35.71 557.852C36.4953 559.144 36.888 560.677 36.888 562.45C36.888 564.046 36.4953 565.541 35.71 566.934C34.95 568.302 33.8733 569.404 32.48 570.24C31.0867 571.051 29.4653 571.456 27.616 571.456ZM27.312 567.048C28.224 567.048 29.022 566.858 29.706 566.478C30.4153 566.098 30.9727 565.579 31.378 564.92C31.7833 564.236 31.986 563.463 31.986 562.602C31.986 561.69 31.7833 560.905 31.378 560.246C30.9727 559.587 30.4153 559.068 29.706 558.688C28.9967 558.308 28.186 558.118 27.274 558.118C26.3873 558.118 25.5893 558.308 24.88 558.688C24.1707 559.068 23.6007 559.6 23.17 560.284C22.7647 560.943 22.562 561.703 22.562 562.564C22.562 563.451 22.7647 564.236 23.17 564.92C23.6007 565.579 24.1707 566.098 24.88 566.478C25.6147 566.858 26.4253 567.048 27.312 567.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M88.218 571L97.984 548.77H85.102V544.4H103.228V548.01L93.538 571H88.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.008 406.456C25.2093 406.456 23.5627 406.127 22.068 405.468C20.5987 404.809 19.4333 403.885 18.572 402.694C17.7107 401.503 17.28 400.123 17.28 398.552C17.28 397.463 17.4573 396.475 17.812 395.588C18.192 394.701 18.7113 393.916 19.37 393.232C20.0287 392.548 20.814 392.029 21.726 391.674C20.586 391.142 19.6613 390.382 18.952 389.394C18.268 388.406 17.926 387.291 17.926 386.05C17.926 384.809 18.268 383.643 18.952 382.554C19.636 381.465 20.6493 380.591 21.992 379.932C23.3347 379.273 25.0067 378.944 27.008 378.944C29.0093 378.944 30.6813 379.273 32.024 379.932C33.3667 380.591 34.38 381.465 35.064 382.554C35.748 383.643 36.09 384.809 36.09 386.05C36.09 387.266 35.7353 388.381 35.026 389.394C34.342 390.382 33.43 391.142 32.29 391.674C33.202 392.054 33.9873 392.586 34.646 393.27C35.33 393.929 35.8493 394.701 36.204 395.588C36.584 396.475 36.774 397.463 36.774 398.552C36.774 400.123 36.3307 401.503 35.444 402.694C34.5827 403.885 33.4173 404.809 31.948 405.468C30.4787 406.127 28.832 406.456 27.008 406.456ZM27.008 402.162C28.5787 402.162 29.7567 401.782 30.542 401.022C31.3273 400.262 31.72 399.299 31.72 398.134C31.72 396.842 31.302 395.829 30.466 395.094C29.6553 394.334 28.5027 393.954 27.008 393.954C25.5387 393.954 24.3733 394.334 23.512 395.094C22.676 395.829 22.258 396.842 22.258 398.134C22.258 399.299 22.6633 400.262 23.474 401.022C24.2847 401.782 25.4627 402.162 27.008 402.162ZM27.008 390.192C28.3 390.192 29.288 389.863 29.972 389.204C30.6813 388.545 31.036 387.697 31.036 386.658C31.036 385.543 30.6813 384.682 29.972 384.074C29.288 383.441 28.3 383.124 27.008 383.124C25.7413 383.124 24.7533 383.441 24.044 384.074C23.3347 384.682 22.98 385.556 22.98 386.696C22.98 387.709 23.3347 388.545 24.044 389.204C24.7533 389.863 25.7413 390.192 27.008 390.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M91.628 406.456C89.7787 406.456 88.208 406.101 86.916 405.392C85.624 404.657 84.6233 403.707 83.914 402.542C83.23 401.377 82.812 400.123 82.66 398.78H87.448C87.676 399.895 88.1447 400.756 88.854 401.364C89.5887 401.947 90.5387 402.238 91.704 402.238C92.7933 402.238 93.7307 401.921 94.516 401.288C95.3267 400.629 95.96 399.654 96.416 398.362C96.872 397.045 97.1253 395.423 97.176 393.498C97.176 393.422 97.176 393.346 97.176 393.27C97.176 393.194 97.176 393.131 97.176 393.08C96.8213 393.739 96.302 394.347 95.618 394.904C94.934 395.436 94.1613 395.854 93.3 396.158C92.464 396.462 91.5647 396.614 90.602 396.614C89.158 396.614 87.79 396.259 86.498 395.55C85.206 394.841 84.1673 393.84 83.382 392.548C82.5967 391.256 82.204 389.723 82.204 387.95C82.204 386.329 82.5967 384.834 83.382 383.466C84.1673 382.098 85.2567 381.009 86.65 380.198C88.0433 379.362 89.652 378.944 91.476 378.944C93.5027 378.944 95.2 379.311 96.568 380.046C97.936 380.781 99.0253 381.769 99.836 383.01C100.672 384.251 101.267 385.645 101.622 387.19C102.002 388.71 102.192 390.255 102.192 391.826C102.192 394.79 101.774 397.374 100.938 399.578C100.127 401.757 98.9367 403.454 97.366 404.67C95.7953 405.861 93.8827 406.456 91.628 406.456ZM91.818 392.282C92.73 392.282 93.528 392.092 94.212 391.712C94.9213 391.332 95.4787 390.813 95.884 390.154C96.3147 389.47 96.53 388.697 96.53 387.836C96.53 386.949 96.3147 386.164 95.884 385.48C95.4787 384.796 94.9213 384.277 94.212 383.922C93.5027 383.542 92.692 383.352 91.78 383.352C90.8933 383.352 90.0953 383.542 89.386 383.922C88.6767 384.302 88.1193 384.821 87.714 385.48C87.334 386.139 87.144 386.911 87.144 387.798C87.144 388.685 87.334 389.47 87.714 390.154C88.1193 390.813 88.6767 391.332 89.386 391.712C90.0953 392.092 90.906 392.282 91.818 392.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 234V213.29L41.178 214.544V210.44L48.094 207.4H51.21V234H45.89ZM67.2178 234.456C64.8111 234.456 62.7338 233.873 60.9858 232.708C59.2378 231.543 57.8951 229.934 56.9578 227.882C56.0458 225.805 55.5898 223.411 55.5898 220.7C55.5898 217.989 56.0458 215.608 56.9578 213.556C57.8951 211.479 59.2251 209.857 60.9478 208.692C62.6958 207.527 64.7858 206.944 67.2178 206.944C69.6498 206.944 71.7271 207.527 73.4498 208.692C75.1978 209.857 76.5278 211.479 77.4398 213.556C78.3771 215.608 78.8458 217.989 78.8458 220.7C78.8458 223.411 78.3771 225.805 77.4398 227.882C76.5278 229.934 75.1978 231.543 73.4498 232.708C71.7271 233.873 69.6498 234.456 67.2178 234.456ZM67.2178 229.858C68.4845 229.858 69.5991 229.491 70.5618 228.756C71.5245 227.996 72.2718 226.932 72.8038 225.564C73.3611 224.196 73.6398 222.575 73.6398 220.7C73.6398 218.8 73.3611 217.179 72.8038 215.836C72.2718 214.468 71.5245 213.417 70.5618 212.682C69.5991 211.947 68.4845 211.58 67.2178 211.58C65.9511 211.58 64.8365 211.947 63.8738 212.682C62.9111 213.417 62.1511 214.468 61.5938 215.836C61.0618 217.179 60.7958 218.8 60.7958 220.7C60.7958 222.575 61.0618 224.196 61.5938 225.564C62.1511 226.932 62.9111 227.996 63.8738 228.756C64.8365 229.491 65.9511 229.858 67.2178 229.858Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const trucNewk12 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="228"
      height="606"
      viewBox="0 0 428 806"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-80px" }}
    >
      <path
        d="M303.09 10.7H124.95C86.6998 10.7 55.5698 41.82 55.5698 80.08V169.2H56.6998V80.08C56.6998 42.44 87.3198 11.82 124.95 11.82H303.09C340.73 11.82 371.35 42.44 371.35 80.08V169.2H372.47V80.08C372.47 41.82 341.35 10.7 303.09 10.7ZM371.35 777.68C371.35 792.55 359.25 804.65 344.38 804.65H83.6598C68.7898 804.65 56.6998 792.55 56.6998 777.68V420.04H55.5698V777.68C55.5698 793.17 68.1698 805.77 83.6598 805.77H344.38C359.87 805.77 372.47 793.17 372.47 777.68V420.04H371.35V777.68ZM371.35 278.84V310.24H372.47V278.84H371.35ZM56.6998 278.84H55.5698V310.24H56.6998V278.84Z"
        fill="#231F20"
      />
      <path
        d="M301.02 19.27H127.03C92.66 19.27 64.71 47.23 64.71 81.58V169.2H65.84V81.58C65.84 47.85 93.28 20.39 127.03 20.39H301.02C334.76 20.39 362.2 47.85 362.2 81.58V169.2H363.33V81.58C363.33 47.23 335.38 19.27 301.02 19.27ZM362.2 776.18C362.2 787.15 353.28 796.07 342.3 796.07H85.74C74.76 796.07 65.84 787.15 65.84 776.18V420.04H64.71V776.18C64.71 787.77 74.15 797.19 85.74 797.19H342.3C353.91 797.19 363.33 787.77 363.33 776.18V420.04H362.2V776.18ZM362.2 278.84V310.24H363.33V278.84H362.2ZM65.84 278.84H64.71V310.24H65.84V278.84Z"
        fill="#231F20"
      />
      <path
        opacity="0.6"
        d="M342.75 52.04H81.52C92.65 36.76 110.68 26.82 131.04 26.82H292.54C313.1 26.82 331.34 36.74 342.75 52.04Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M160.89 11.26H116.74C118.62 4.44 121.67 0 125.11 0H152.41C155.89 0 158.97 4.43 160.9 11.26H160.89Z"
        fill="#999999"
      />
      <path
        opacity="0.6"
        d="M306.93 11.26H262.78C264.65 4.44 267.7 0 271.14 0H298.44C301.92 0 305 4.43 306.93 11.26Z"
        fill="#999999"
      />
      <path
        d="M410.17 80.85H392.84C387.11 80.85 382.46 85.51 382.46 91.23V92.52H377.24C376.9 90.68 375.29 89.28 373.35 89.28C372.87 89.28 372.48 89.67 372.48 90.15V110.92C372.48 111.4 372.87 111.79 373.35 111.79C375.42 111.79 377.1 110.19 377.28 108.16L389.97 103.61H410.17C414.46 103.61 417.95 100.12 417.95 95.83V88.62C417.95 84.33 414.46 80.84 410.17 80.84V80.85ZM377.32 106.3V94.28H382.47V102.75C382.47 103.23 382.86 103.62 383.34 103.62H384.8L377.32 106.3ZM416.21 95.84C416.21 99.17 413.51 101.87 410.18 101.87H384.22V91.23C384.22 86.47 388.09 82.59 392.86 82.59H410.19C413.52 82.59 416.22 85.29 416.22 88.62V95.83L416.21 95.84Z"
        fill="#999999"
      />
      <path
        d="M410.25 84.61H392.74C389.22 84.61 386.36 87.47 386.36 90.99V98.98C386.36 99.46 386.75 99.85 387.23 99.85H410.25C412.35 99.85 414.06 98.14 414.06 96.04V88.42C414.06 86.32 412.35 84.61 410.25 84.61Z"
        fill="#999999"
      />
      <path
        d="M17.8801 80.85H35.2101C40.9401 80.85 45.5901 85.51 45.5901 91.23V92.52H50.8101C51.1501 90.68 52.7601 89.28 54.7001 89.28C55.1801 89.28 55.5701 89.67 55.5701 90.15V110.92C55.5701 111.4 55.1801 111.79 54.7001 111.79C52.6301 111.79 50.9501 110.19 50.7701 108.16L38.0801 103.61H17.8801C13.5901 103.61 10.1001 100.12 10.1001 95.83V88.62C10.1001 84.33 13.5901 80.84 17.8801 80.84V80.85ZM50.7401 106.3V94.28H45.5901V102.75C45.5901 103.23 45.2001 103.62 44.7201 103.62H43.2601L50.7401 106.3ZM11.8501 95.84C11.8501 99.17 14.5501 101.87 17.8801 101.87H43.8401V91.23C43.8401 86.47 39.9701 82.59 35.2001 82.59H17.8801C14.5501 82.59 11.8501 85.29 11.8501 88.62V95.83V95.84Z"
        fill="#999999"
      />
      <path
        d="M17.81 84.61H35.32C38.84 84.61 41.7 87.47 41.7 90.99V98.98C41.7 99.46 41.31 99.85 40.83 99.85H17.81C15.71 99.85 14 98.14 14 96.04V88.42C14 86.32 15.71 84.61 17.81 84.61Z"
        fill="#999999"
      />
      <path d="M64.7201 507.27H55.8901V566.05H64.7201V507.27Z" fill="#231F20" />
      <path d="M371.42 507.27H362.59V566.05H371.42V507.27Z" fill="#231F20" />
      <path d="M64.9902 668.72H56.1602V727.5H64.9902V668.72Z" fill="#231F20" />
      <path d="M371.69 668.72H362.86V727.5H371.69V668.72Z" fill="#231F20" />
      <rect
        x="306"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="307"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="371"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="65"
        y="635"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="65"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="372"
        y="474"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="339"
        y="302"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="339"
        y="160"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="33"
        y="160"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="33"
        y="302"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <path
        d="M365.89 237V216.29L361.178 217.544V213.44L368.094 210.4H371.21V237H365.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M357.9 378V374.238C359.521 372.946 361.092 371.654 362.612 370.362C364.157 369.07 365.538 367.791 366.754 366.524C367.97 365.232 368.933 363.978 369.642 362.762C370.351 361.546 370.706 360.368 370.706 359.228C370.706 358.519 370.579 357.873 370.326 357.29C370.073 356.682 369.667 356.201 369.11 355.846C368.578 355.466 367.869 355.276 366.982 355.276C366.095 355.276 365.348 355.479 364.74 355.884C364.132 356.289 363.676 356.834 363.372 357.518C363.068 358.177 362.916 358.924 362.916 359.76H357.938C358.014 357.809 358.457 356.175 359.268 354.858C360.079 353.541 361.168 352.565 362.536 351.932C363.904 351.273 365.437 350.944 367.134 350.944C369.009 350.944 370.592 351.299 371.884 352.008C373.176 352.692 374.151 353.629 374.81 354.82C375.494 356.011 375.836 357.379 375.836 358.924C375.836 360.089 375.621 361.229 375.19 362.344C374.785 363.459 374.202 364.548 373.442 365.612C372.707 366.651 371.871 367.651 370.934 368.614C369.997 369.577 369.021 370.501 368.008 371.388C366.995 372.249 366.007 373.06 365.044 373.82H376.482V378H357.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M400.4 551.456C398.677 551.456 397.094 551.139 395.65 550.506C394.206 549.873 393.053 548.91 392.192 547.618C391.331 546.326 390.875 544.692 390.824 542.716H395.84C395.865 543.552 396.055 544.312 396.41 544.996C396.765 545.655 397.284 546.187 397.968 546.592C398.652 546.972 399.463 547.162 400.4 547.162C401.287 547.162 402.047 546.985 402.68 546.63C403.313 546.275 403.795 545.807 404.124 545.224C404.453 544.641 404.618 543.97 404.618 543.21C404.618 542.323 404.39 541.589 403.934 541.006C403.503 540.398 402.895 539.942 402.11 539.638C401.35 539.334 400.476 539.182 399.488 539.182H397.512V534.964H399.488C400.729 534.964 401.768 534.673 402.604 534.09C403.465 533.507 403.896 532.633 403.896 531.468C403.896 530.505 403.579 529.733 402.946 529.15C402.338 528.567 401.477 528.276 400.362 528.276C399.146 528.276 398.196 528.631 397.512 529.34C396.828 530.049 396.448 530.923 396.372 531.962H391.356C391.432 530.29 391.85 528.859 392.61 527.668C393.395 526.452 394.447 525.527 395.764 524.894C397.081 524.261 398.614 523.944 400.362 523.944C402.211 523.944 403.769 524.273 405.036 524.932C406.328 525.565 407.303 526.427 407.962 527.516C408.621 528.605 408.95 529.783 408.95 531.05C408.95 532.089 408.747 533.013 408.342 533.824C407.962 534.635 407.443 535.306 406.784 535.838C406.125 536.37 405.403 536.75 404.618 536.978C405.606 537.181 406.467 537.573 407.202 538.156C407.962 538.713 408.545 539.435 408.95 540.322C409.381 541.209 409.596 542.235 409.596 543.4C409.596 544.844 409.241 546.187 408.532 547.428C407.848 548.644 406.809 549.619 405.416 550.354C404.048 551.089 402.376 551.456 400.4 551.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M337.782 551V546.174H324.71V542.108L337.098 524.4H342.912V541.728H346.37V546.174H342.912V551H337.782ZM330.182 541.728H338.124V530.062L330.182 541.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M399.122 711.456C397.197 711.456 395.525 711.114 394.106 710.43C392.713 709.746 391.623 708.809 390.838 707.618C390.053 706.427 389.597 705.072 389.47 703.552H394.486C394.663 704.54 395.17 705.376 396.006 706.06C396.842 706.744 397.893 707.086 399.16 707.086C400.072 707.086 400.87 706.858 401.554 706.402C402.238 705.946 402.77 705.338 403.15 704.578C403.53 703.793 403.72 702.906 403.72 701.918C403.72 700.905 403.517 700.031 403.112 699.296C402.732 698.561 402.2 697.991 401.516 697.586C400.857 697.181 400.097 696.978 399.236 696.978C398.147 696.978 397.209 697.244 396.424 697.776C395.664 698.283 395.119 698.903 394.79 699.638H389.812L392.016 684.4H406.95V688.884H395.816L394.714 694.812C395.271 694.229 396.019 693.761 396.956 693.406C397.893 693.026 398.945 692.836 400.11 692.836C401.554 692.836 402.808 693.089 403.872 693.596C404.936 694.077 405.823 694.749 406.532 695.61C407.241 696.446 407.773 697.409 408.128 698.498C408.483 699.562 408.66 700.689 408.66 701.88C408.66 703.273 408.419 704.553 407.938 705.718C407.482 706.883 406.823 707.897 405.962 708.758C405.126 709.619 404.125 710.291 402.96 710.772C401.82 711.228 400.541 711.456 399.122 711.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M335.616 711.456C333.615 711.456 331.917 711.089 330.524 710.354C329.156 709.619 328.054 708.631 327.218 707.39C326.407 706.149 325.812 704.768 325.432 703.248C325.077 701.703 324.9 700.145 324.9 698.574C324.9 695.585 325.318 693.001 326.154 690.822C326.99 688.643 328.193 686.959 329.764 685.768C331.335 684.552 333.235 683.944 335.464 683.944C337.339 683.944 338.922 684.311 340.214 685.046C341.506 685.755 342.507 686.693 343.216 687.858C343.925 689.023 344.343 690.277 344.47 691.62H339.682C339.479 690.505 339.011 689.657 338.276 689.074C337.541 688.466 336.591 688.162 335.426 688.162C334.337 688.162 333.387 688.491 332.576 689.15C331.765 689.809 331.132 690.797 330.676 692.114C330.245 693.431 329.992 695.091 329.916 697.092C329.916 697.117 329.916 697.155 329.916 697.206C329.916 697.257 329.916 697.295 329.916 697.32C330.321 696.636 330.853 696.028 331.512 695.496C332.171 694.964 332.931 694.546 333.792 694.242C334.653 693.938 335.565 693.786 336.528 693.786C337.997 693.786 339.365 694.141 340.632 694.85C341.899 695.559 342.925 696.56 343.71 697.852C344.495 699.144 344.888 700.677 344.888 702.45C344.888 704.046 344.495 705.541 343.71 706.934C342.95 708.302 341.873 709.404 340.48 710.24C339.087 711.051 337.465 711.456 335.616 711.456ZM335.312 707.048C336.224 707.048 337.022 706.858 337.706 706.478C338.415 706.098 338.973 705.579 339.378 704.92C339.783 704.236 339.986 703.463 339.986 702.602C339.986 701.69 339.783 700.905 339.378 700.246C338.973 699.587 338.415 699.068 337.706 698.688C336.997 698.308 336.186 698.118 335.274 698.118C334.387 698.118 333.589 698.308 332.88 698.688C332.171 699.068 331.601 699.6 331.17 700.284C330.765 700.943 330.562 701.703 330.562 702.564C330.562 703.451 330.765 704.236 331.17 704.92C331.601 705.579 332.171 706.098 332.88 706.478C333.615 706.858 334.425 707.048 335.312 707.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M21.218 712L30.984 689.77H18.102V685.4H36.228V689.01L26.538 712H21.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M94.008 712.456C92.2093 712.456 90.5627 712.127 89.068 711.468C87.5987 710.809 86.4333 709.885 85.572 708.694C84.7107 707.503 84.28 706.123 84.28 704.552C84.28 703.463 84.4573 702.475 84.812 701.588C85.192 700.701 85.7113 699.916 86.37 699.232C87.0287 698.548 87.814 698.029 88.726 697.674C87.586 697.142 86.6613 696.382 85.952 695.394C85.268 694.406 84.926 693.291 84.926 692.05C84.926 690.809 85.268 689.643 85.952 688.554C86.636 687.465 87.6493 686.591 88.992 685.932C90.3347 685.273 92.0067 684.944 94.008 684.944C96.0093 684.944 97.6813 685.273 99.024 685.932C100.367 686.591 101.38 687.465 102.064 688.554C102.748 689.643 103.09 690.809 103.09 692.05C103.09 693.266 102.735 694.381 102.026 695.394C101.342 696.382 100.43 697.142 99.29 697.674C100.202 698.054 100.987 698.586 101.646 699.27C102.33 699.929 102.849 700.701 103.204 701.588C103.584 702.475 103.774 703.463 103.774 704.552C103.774 706.123 103.331 707.503 102.444 708.694C101.583 709.885 100.417 710.809 98.948 711.468C97.4787 712.127 95.832 712.456 94.008 712.456ZM94.008 708.162C95.5787 708.162 96.7567 707.782 97.542 707.022C98.3273 706.262 98.72 705.299 98.72 704.134C98.72 702.842 98.302 701.829 97.466 701.094C96.6553 700.334 95.5027 699.954 94.008 699.954C92.5387 699.954 91.3733 700.334 90.512 701.094C89.676 701.829 89.258 702.842 89.258 704.134C89.258 705.299 89.6633 706.262 90.474 707.022C91.2847 707.782 92.4627 708.162 94.008 708.162ZM94.008 696.192C95.3 696.192 96.288 695.863 96.972 695.204C97.6813 694.545 98.036 693.697 98.036 692.658C98.036 691.543 97.6813 690.682 96.972 690.074C96.288 689.441 95.3 689.124 94.008 689.124C92.7413 689.124 91.7533 689.441 91.044 690.074C90.3347 690.682 89.98 691.556 89.98 692.696C89.98 693.709 90.3347 694.545 91.044 695.204C91.7533 695.863 92.7413 696.192 94.008 696.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M28.628 551.456C26.7787 551.456 25.208 551.101 23.916 550.392C22.624 549.657 21.6233 548.707 20.914 547.542C20.23 546.377 19.812 545.123 19.66 543.78H24.448C24.676 544.895 25.1447 545.756 25.854 546.364C26.5887 546.947 27.5387 547.238 28.704 547.238C29.7933 547.238 30.7307 546.921 31.516 546.288C32.3267 545.629 32.96 544.654 33.416 543.362C33.872 542.045 34.1253 540.423 34.176 538.498C34.176 538.422 34.176 538.346 34.176 538.27C34.176 538.194 34.176 538.131 34.176 538.08C33.8213 538.739 33.302 539.347 32.618 539.904C31.934 540.436 31.1613 540.854 30.3 541.158C29.464 541.462 28.5647 541.614 27.602 541.614C26.158 541.614 24.79 541.259 23.498 540.55C22.206 539.841 21.1673 538.84 20.382 537.548C19.5967 536.256 19.204 534.723 19.204 532.95C19.204 531.329 19.5967 529.834 20.382 528.466C21.1673 527.098 22.2567 526.009 23.65 525.198C25.0433 524.362 26.652 523.944 28.476 523.944C30.5027 523.944 32.2 524.311 33.568 525.046C34.936 525.781 36.0253 526.769 36.836 528.01C37.672 529.251 38.2673 530.645 38.622 532.19C39.002 533.71 39.192 535.255 39.192 536.826C39.192 539.79 38.774 542.374 37.938 544.578C37.1273 546.757 35.9367 548.454 34.366 549.67C32.7953 550.861 30.8827 551.456 28.628 551.456ZM28.818 537.282C29.73 537.282 30.528 537.092 31.212 536.712C31.9213 536.332 32.4787 535.813 32.884 535.154C33.3147 534.47 33.53 533.697 33.53 532.836C33.53 531.949 33.3147 531.164 32.884 530.48C32.4787 529.796 31.9213 529.277 31.212 528.922C30.5027 528.542 29.692 528.352 28.78 528.352C27.8933 528.352 27.0953 528.542 26.386 528.922C25.6767 529.302 25.1193 529.821 24.714 530.48C24.334 531.139 24.144 531.911 24.144 532.798C24.144 533.685 24.334 534.47 24.714 535.154C25.1193 535.813 25.6767 536.332 26.386 536.712C27.0953 537.092 27.906 537.282 28.818 537.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M77.89 550V529.29L73.178 530.544V526.44L80.094 523.4H83.21V550H77.89ZM99.2178 550.456C96.8111 550.456 94.7338 549.873 92.9858 548.708C91.2378 547.543 89.8951 545.934 88.9578 543.882C88.0458 541.805 87.5898 539.411 87.5898 536.7C87.5898 533.989 88.0458 531.608 88.9578 529.556C89.8951 527.479 91.2251 525.857 92.9478 524.692C94.6958 523.527 96.7858 522.944 99.2178 522.944C101.65 522.944 103.727 523.527 105.45 524.692C107.198 525.857 108.528 527.479 109.44 529.556C110.377 531.608 110.846 533.989 110.846 536.7C110.846 539.411 110.377 541.805 109.44 543.882C108.528 545.934 107.198 547.543 105.45 548.708C103.727 549.873 101.65 550.456 99.2178 550.456ZM99.2178 545.858C100.484 545.858 101.599 545.491 102.562 544.756C103.524 543.996 104.272 542.932 104.804 541.564C105.361 540.196 105.64 538.575 105.64 536.7C105.64 534.8 105.361 533.179 104.804 531.836C104.272 530.468 103.524 529.417 102.562 528.682C101.599 527.947 100.484 527.58 99.2178 527.58C97.9511 527.58 96.8365 527.947 95.8738 528.682C94.9111 529.417 94.1511 530.468 93.5938 531.836C93.0618 533.179 92.7958 534.8 92.7958 536.7C92.7958 538.575 93.0618 540.196 93.5938 541.564C94.1511 542.932 94.9111 543.996 95.8738 544.756C96.8365 545.491 97.9511 545.858 99.2178 545.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M52.89 379V358.29L48.178 359.544V355.44L55.094 352.4H58.21V379H52.89ZM66.7318 379V358.29L62.0198 359.544V355.44L68.9358 352.4H72.0518V379H66.7318Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M48.89 237V216.29L44.178 217.544V213.44L51.094 210.4H54.21V237H48.89ZM58.7418 237V233.238C60.3631 231.946 61.9338 230.654 63.4538 229.362C64.9991 228.07 66.3798 226.791 67.5958 225.524C68.8118 224.232 69.7745 222.978 70.4838 221.762C71.1931 220.546 71.5478 219.368 71.5478 218.228C71.5478 217.519 71.4211 216.873 71.1678 216.29C70.9145 215.682 70.5091 215.201 69.9518 214.846C69.4198 214.466 68.7105 214.276 67.8238 214.276C66.9371 214.276 66.1898 214.479 65.5818 214.884C64.9738 215.289 64.5178 215.834 64.2138 216.518C63.9098 217.177 63.7578 217.924 63.7578 218.76H58.7798C58.8558 216.809 59.2991 215.175 60.1098 213.858C60.9205 212.541 62.0098 211.565 63.3778 210.932C64.7458 210.273 66.2785 209.944 67.9758 209.944C69.8505 209.944 71.4338 210.299 72.7258 211.008C74.0178 211.692 74.9931 212.629 75.6518 213.82C76.3358 215.011 76.6778 216.379 76.6778 217.924C76.6778 219.089 76.4625 220.229 76.0318 221.344C75.6265 222.459 75.0438 223.548 74.2838 224.612C73.5491 225.651 72.7131 226.651 71.7758 227.614C70.8385 228.577 69.8631 229.501 68.8498 230.388C67.8365 231.249 66.8485 232.06 65.8858 232.82H77.3238V237H58.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truckNew14 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-60px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <g opacity="0.6">
        <path
          d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M384.534 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.534C386.475 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.475 78.1924 384.534 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="262"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="320"
        y="403"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="264"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "new")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="31"
        y="405"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "new")}
        className="cursor-pointer"
        key={14}
      />
      <path
        d="M346.89 197V176.29L342.178 177.544V173.44L349.094 170.4H352.21V197H346.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M338.9 338V334.238C340.521 332.946 342.092 331.654 343.612 330.362C345.157 329.07 346.538 327.791 347.754 326.524C348.97 325.232 349.933 323.978 350.642 322.762C351.351 321.546 351.706 320.368 351.706 319.228C351.706 318.519 351.579 317.873 351.326 317.29C351.073 316.682 350.667 316.201 350.11 315.846C349.578 315.466 348.869 315.276 347.982 315.276C347.095 315.276 346.348 315.479 345.74 315.884C345.132 316.289 344.676 316.834 344.372 317.518C344.068 318.177 343.916 318.924 343.916 319.76H338.938C339.014 317.809 339.457 316.175 340.268 314.858C341.079 313.541 342.168 312.565 343.536 311.932C344.904 311.273 346.437 310.944 348.134 310.944C350.009 310.944 351.592 311.299 352.884 312.008C354.176 312.692 355.151 313.629 355.81 314.82C356.494 316.011 356.836 317.379 356.836 318.924C356.836 320.089 356.621 321.229 356.19 322.344C355.785 323.459 355.202 324.548 354.442 325.612C353.707 326.651 352.871 327.651 351.934 328.614C350.997 329.577 350.021 330.501 349.008 331.388C347.995 332.249 347.007 333.06 346.044 333.82H357.482V338H338.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M347.4 480.456C345.677 480.456 344.094 480.139 342.65 479.506C341.206 478.873 340.053 477.91 339.192 476.618C338.331 475.326 337.875 473.692 337.824 471.716H342.84C342.865 472.552 343.055 473.312 343.41 473.996C343.765 474.655 344.284 475.187 344.968 475.592C345.652 475.972 346.463 476.162 347.4 476.162C348.287 476.162 349.047 475.985 349.68 475.63C350.313 475.275 350.795 474.807 351.124 474.224C351.453 473.641 351.618 472.97 351.618 472.21C351.618 471.323 351.39 470.589 350.934 470.006C350.503 469.398 349.895 468.942 349.11 468.638C348.35 468.334 347.476 468.182 346.488 468.182H344.512V463.964H346.488C347.729 463.964 348.768 463.673 349.604 463.09C350.465 462.507 350.896 461.633 350.896 460.468C350.896 459.505 350.579 458.733 349.946 458.15C349.338 457.567 348.477 457.276 347.362 457.276C346.146 457.276 345.196 457.631 344.512 458.34C343.828 459.049 343.448 459.923 343.372 460.962H338.356C338.432 459.29 338.85 457.859 339.61 456.668C340.395 455.452 341.447 454.527 342.764 453.894C344.081 453.261 345.614 452.944 347.362 452.944C349.211 452.944 350.769 453.273 352.036 453.932C353.328 454.565 354.303 455.427 354.962 456.516C355.621 457.605 355.95 458.783 355.95 460.05C355.95 461.089 355.747 462.013 355.342 462.824C354.962 463.635 354.443 464.306 353.784 464.838C353.125 465.37 352.403 465.75 351.618 465.978C352.606 466.181 353.467 466.573 354.202 467.156C354.962 467.713 355.545 468.435 355.95 469.322C356.381 470.209 356.596 471.235 356.596 472.4C356.596 473.844 356.241 475.187 355.532 476.428C354.848 477.644 353.809 478.619 352.416 479.354C351.048 480.089 349.376 480.456 347.4 480.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M383.782 663V658.174H370.71V654.108L383.098 636.4H388.912V653.728H392.37V658.174H388.912V663H383.782ZM376.182 653.728H384.124V642.062L376.182 653.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.122 662.456C311.197 662.456 309.525 662.114 308.106 661.43C306.713 660.746 305.623 659.809 304.838 658.618C304.053 657.427 303.597 656.072 303.47 654.552H308.486C308.663 655.54 309.17 656.376 310.006 657.06C310.842 657.744 311.893 658.086 313.16 658.086C314.072 658.086 314.87 657.858 315.554 657.402C316.238 656.946 316.77 656.338 317.15 655.578C317.53 654.793 317.72 653.906 317.72 652.918C317.72 651.905 317.517 651.031 317.112 650.296C316.732 649.561 316.2 648.991 315.516 648.586C314.857 648.181 314.097 647.978 313.236 647.978C312.147 647.978 311.209 648.244 310.424 648.776C309.664 649.283 309.119 649.903 308.79 650.638H303.812L306.016 635.4H320.95V639.884H309.816L308.714 645.812C309.271 645.229 310.019 644.761 310.956 644.406C311.893 644.026 312.945 643.836 314.11 643.836C315.554 643.836 316.808 644.089 317.872 644.596C318.936 645.077 319.823 645.749 320.532 646.61C321.241 647.446 321.773 648.409 322.128 649.498C322.483 650.562 322.66 651.689 322.66 652.88C322.66 654.273 322.419 655.553 321.938 656.718C321.482 657.883 320.823 658.897 319.962 659.758C319.126 660.619 318.125 661.291 316.96 661.772C315.82 662.228 314.541 662.456 313.122 662.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M380.616 823.456C378.615 823.456 376.917 823.089 375.524 822.354C374.156 821.619 373.054 820.631 372.218 819.39C371.407 818.149 370.812 816.768 370.432 815.248C370.077 813.703 369.9 812.145 369.9 810.574C369.9 807.585 370.318 805.001 371.154 802.822C371.99 800.643 373.193 798.959 374.764 797.768C376.335 796.552 378.235 795.944 380.464 795.944C382.339 795.944 383.922 796.311 385.214 797.046C386.506 797.755 387.507 798.693 388.216 799.858C388.925 801.023 389.343 802.277 389.47 803.62H384.682C384.479 802.505 384.011 801.657 383.276 801.074C382.541 800.466 381.591 800.162 380.426 800.162C379.337 800.162 378.387 800.491 377.576 801.15C376.765 801.809 376.132 802.797 375.676 804.114C375.245 805.431 374.992 807.091 374.916 809.092C374.916 809.117 374.916 809.155 374.916 809.206C374.916 809.257 374.916 809.295 374.916 809.32C375.321 808.636 375.853 808.028 376.512 807.496C377.171 806.964 377.931 806.546 378.792 806.242C379.653 805.938 380.565 805.786 381.528 805.786C382.997 805.786 384.365 806.141 385.632 806.85C386.899 807.559 387.925 808.56 388.71 809.852C389.495 811.144 389.888 812.677 389.888 814.45C389.888 816.046 389.495 817.541 388.71 818.934C387.95 820.302 386.873 821.404 385.48 822.24C384.087 823.051 382.465 823.456 380.616 823.456ZM380.312 819.048C381.224 819.048 382.022 818.858 382.706 818.478C383.415 818.098 383.973 817.579 384.378 816.92C384.783 816.236 384.986 815.463 384.986 814.602C384.986 813.69 384.783 812.905 384.378 812.246C383.973 811.587 383.415 811.068 382.706 810.688C381.997 810.308 381.186 810.118 380.274 810.118C379.387 810.118 378.589 810.308 377.88 810.688C377.171 811.068 376.601 811.6 376.17 812.284C375.765 812.943 375.562 813.703 375.562 814.564C375.562 815.451 375.765 816.236 376.17 816.92C376.601 817.579 377.171 818.098 377.88 818.478C378.615 818.858 379.425 819.048 380.312 819.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M309.218 824L318.984 801.77H306.102V797.4H324.228V801.01L314.538 824H309.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M29.008 824.456C27.2093 824.456 25.5627 824.127 24.068 823.468C22.5987 822.809 21.4333 821.885 20.572 820.694C19.7107 819.503 19.28 818.123 19.28 816.552C19.28 815.463 19.4573 814.475 19.812 813.588C20.192 812.701 20.7113 811.916 21.37 811.232C22.0287 810.548 22.814 810.029 23.726 809.674C22.586 809.142 21.6613 808.382 20.952 807.394C20.268 806.406 19.926 805.291 19.926 804.05C19.926 802.809 20.268 801.643 20.952 800.554C21.636 799.465 22.6493 798.591 23.992 797.932C25.3347 797.273 27.0067 796.944 29.008 796.944C31.0093 796.944 32.6813 797.273 34.024 797.932C35.3667 798.591 36.38 799.465 37.064 800.554C37.748 801.643 38.09 802.809 38.09 804.05C38.09 805.266 37.7353 806.381 37.026 807.394C36.342 808.382 35.43 809.142 34.29 809.674C35.202 810.054 35.9873 810.586 36.646 811.27C37.33 811.929 37.8493 812.701 38.204 813.588C38.584 814.475 38.774 815.463 38.774 816.552C38.774 818.123 38.3307 819.503 37.444 820.694C36.5827 821.885 35.4173 822.809 33.948 823.468C32.4787 824.127 30.832 824.456 29.008 824.456ZM29.008 820.162C30.5787 820.162 31.7567 819.782 32.542 819.022C33.3273 818.262 33.72 817.299 33.72 816.134C33.72 814.842 33.302 813.829 32.466 813.094C31.6553 812.334 30.5027 811.954 29.008 811.954C27.5387 811.954 26.3733 812.334 25.512 813.094C24.676 813.829 24.258 814.842 24.258 816.134C24.258 817.299 24.6633 818.262 25.474 819.022C26.2847 819.782 27.4627 820.162 29.008 820.162ZM29.008 808.192C30.3 808.192 31.288 807.863 31.972 807.204C32.6813 806.545 33.036 805.697 33.036 804.658C33.036 803.543 32.6813 802.682 31.972 802.074C31.288 801.441 30.3 801.124 29.008 801.124C27.7413 801.124 26.7533 801.441 26.044 802.074C25.3347 802.682 24.98 803.556 24.98 804.696C24.98 805.709 25.3347 806.545 26.044 807.204C26.7533 807.863 27.7413 808.192 29.008 808.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M93.628 824.456C91.7787 824.456 90.208 824.101 88.916 823.392C87.624 822.657 86.6233 821.707 85.914 820.542C85.23 819.377 84.812 818.123 84.66 816.78H89.448C89.676 817.895 90.1447 818.756 90.854 819.364C91.5887 819.947 92.5387 820.238 93.704 820.238C94.7933 820.238 95.7307 819.921 96.516 819.288C97.3267 818.629 97.96 817.654 98.416 816.362C98.872 815.045 99.1253 813.423 99.176 811.498C99.176 811.422 99.176 811.346 99.176 811.27C99.176 811.194 99.176 811.131 99.176 811.08C98.8213 811.739 98.302 812.347 97.618 812.904C96.934 813.436 96.1613 813.854 95.3 814.158C94.464 814.462 93.5647 814.614 92.602 814.614C91.158 814.614 89.79 814.259 88.498 813.55C87.206 812.841 86.1673 811.84 85.382 810.548C84.5967 809.256 84.204 807.723 84.204 805.95C84.204 804.329 84.5967 802.834 85.382 801.466C86.1673 800.098 87.2567 799.009 88.65 798.198C90.0433 797.362 91.652 796.944 93.476 796.944C95.5027 796.944 97.2 797.311 98.568 798.046C99.936 798.781 101.025 799.769 101.836 801.01C102.672 802.251 103.267 803.645 103.622 805.19C104.002 806.71 104.192 808.255 104.192 809.826C104.192 812.79 103.774 815.374 102.938 817.578C102.127 819.757 100.937 821.454 99.366 822.67C97.7953 823.861 95.8827 824.456 93.628 824.456ZM93.818 810.282C94.73 810.282 95.528 810.092 96.212 809.712C96.9213 809.332 97.4787 808.813 97.884 808.154C98.3147 807.47 98.53 806.697 98.53 805.836C98.53 804.949 98.3147 804.164 97.884 803.48C97.4787 802.796 96.9213 802.277 96.212 801.922C95.5027 801.542 94.692 801.352 93.78 801.352C92.8933 801.352 92.0953 801.542 91.386 801.922C90.6767 802.302 90.1193 802.821 89.714 803.48C89.334 804.139 89.144 804.911 89.144 805.798C89.144 806.685 89.334 807.47 89.714 808.154C90.1193 808.813 90.6767 809.332 91.386 809.712C92.0953 810.092 92.906 810.282 93.818 810.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 662V641.29L8.178 642.544V638.44L15.094 635.4H18.21V662H12.89ZM34.2178 662.456C31.8111 662.456 29.7338 661.873 27.9858 660.708C26.2378 659.543 24.8951 657.934 23.9578 655.882C23.0458 653.805 22.5898 651.411 22.5898 648.7C22.5898 645.989 23.0458 643.608 23.9578 641.556C24.8951 639.479 26.2251 637.857 27.9478 636.692C29.6958 635.527 31.7858 634.944 34.2178 634.944C36.6498 634.944 38.7271 635.527 40.4498 636.692C42.1978 637.857 43.5278 639.479 44.4398 641.556C45.3771 643.608 45.8458 645.989 45.8458 648.7C45.8458 651.411 45.3771 653.805 44.4398 655.882C43.5278 657.934 42.1978 659.543 40.4498 660.708C38.7271 661.873 36.6498 662.456 34.2178 662.456ZM34.2178 657.858C35.4845 657.858 36.5991 657.491 37.5618 656.756C38.5245 655.996 39.2718 654.932 39.8038 653.564C40.3611 652.196 40.6398 650.575 40.6398 648.7C40.6398 646.8 40.3611 645.179 39.8038 643.836C39.2718 642.468 38.5245 641.417 37.5618 640.682C36.5991 639.947 35.4845 639.58 34.2178 639.58C32.9511 639.58 31.8365 639.947 30.8738 640.682C29.9111 641.417 29.1511 642.468 28.5938 643.836C28.0618 645.179 27.7958 646.8 27.7958 648.7C27.7958 650.575 28.0618 652.196 28.5938 653.564C29.1511 654.932 29.9111 655.996 30.8738 656.756C31.8365 657.491 32.9511 657.858 34.2178 657.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M86.89 663V642.29L82.178 643.544V639.44L89.094 636.4H92.21V663H86.89ZM100.732 663V642.29L96.0198 643.544V639.44L102.936 636.4H106.052V663H100.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 481V460.29L42.178 461.544V457.44L49.094 454.4H52.21V481H46.89ZM56.7418 481V477.238C58.3631 475.946 59.9338 474.654 61.4538 473.362C62.9991 472.07 64.3798 470.791 65.5958 469.524C66.8118 468.232 67.7745 466.978 68.4838 465.762C69.1931 464.546 69.5478 463.368 69.5478 462.228C69.5478 461.519 69.4211 460.873 69.1678 460.29C68.9145 459.682 68.5091 459.201 67.9518 458.846C67.4198 458.466 66.7105 458.276 65.8238 458.276C64.9371 458.276 64.1898 458.479 63.5818 458.884C62.9738 459.289 62.5178 459.834 62.2138 460.518C61.9098 461.177 61.7578 461.924 61.7578 462.76H56.7798C56.8558 460.809 57.2991 459.175 58.1098 457.858C58.9205 456.541 60.0098 455.565 61.3778 454.932C62.7458 454.273 64.2785 453.944 65.9758 453.944C67.8505 453.944 69.4338 454.299 70.7258 455.008C72.0178 455.692 72.9931 456.629 73.6518 457.82C74.3358 459.011 74.6778 460.379 74.6778 461.924C74.6778 463.089 74.4625 464.229 74.0318 465.344C73.6265 466.459 73.0438 467.548 72.2838 468.612C71.5491 469.651 70.7131 470.651 69.7758 471.614C68.8385 472.577 67.8631 473.501 66.8498 474.388C65.8365 475.249 64.8485 476.06 63.8858 476.82H75.3238V481H56.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 340V319.29L42.178 320.544V316.44L49.094 313.4H52.21V340H46.89ZM66.2418 340.456C64.5191 340.456 62.9358 340.139 61.4918 339.506C60.0478 338.873 58.8951 337.91 58.0338 336.618C57.1725 335.326 56.7165 333.692 56.6658 331.716H61.6818C61.7071 332.552 61.8971 333.312 62.2518 333.996C62.6065 334.655 63.1258 335.187 63.8098 335.592C64.4938 335.972 65.3045 336.162 66.2418 336.162C67.1285 336.162 67.8885 335.985 68.5218 335.63C69.1551 335.275 69.6365 334.807 69.9658 334.224C70.2951 333.641 70.4598 332.97 70.4598 332.21C70.4598 331.323 70.2318 330.589 69.7758 330.006C69.3451 329.398 68.7371 328.942 67.9518 328.638C67.1918 328.334 66.3178 328.182 65.3298 328.182H63.3538V323.964H65.3298C66.5711 323.964 67.6098 323.673 68.4458 323.09C69.3071 322.507 69.7378 321.633 69.7378 320.468C69.7378 319.505 69.4211 318.733 68.7878 318.15C68.1798 317.567 67.3185 317.276 66.2038 317.276C64.9878 317.276 64.0378 317.631 63.3538 318.34C62.6698 319.049 62.2898 319.923 62.2138 320.962H57.1978C57.2738 319.29 57.6918 317.859 58.4518 316.668C59.2371 315.452 60.2885 314.527 61.6058 313.894C62.9231 313.261 64.4558 312.944 66.2038 312.944C68.0531 312.944 69.6111 313.273 70.8778 313.932C72.1698 314.565 73.1451 315.427 73.8038 316.516C74.4625 317.605 74.7918 318.783 74.7918 320.05C74.7918 321.089 74.5891 322.013 74.1838 322.824C73.8038 323.635 73.2845 324.306 72.6258 324.838C71.9671 325.37 71.2451 325.75 70.4598 325.978C71.4478 326.181 72.3091 326.573 73.0438 327.156C73.8038 327.713 74.3865 328.435 74.7918 329.322C75.2225 330.209 75.4378 331.235 75.4378 332.4C75.4378 333.844 75.0831 335.187 74.3738 336.428C73.6898 337.644 72.6511 338.619 71.2578 339.354C69.8898 340.089 68.2178 340.456 66.2418 340.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 200V179.29L41.178 180.544V176.44L48.094 173.4H51.21V200H45.89ZM68.6238 200V195.174H55.5518V191.108L67.9398 173.4H73.7538V190.728H77.2118V195.174H73.7538V200H68.6238ZM61.0238 190.728H68.9658V179.062L61.0238 190.728Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truckNew16 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-40px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <g opacity="0.6">
        <path
          d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M384.535 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.535C386.476 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.476 78.1924 384.535 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
          fill="#BFBEBE"
        />
        <path
          d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
          fill="#BFBEBE"
        />
      </g>
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <path d="M352 461H343V515H352V461Z" fill="#231F20" />
      <rect
        x="286"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <rect
        x="353"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <path d="M66 461H57V515H66V461Z" fill="#231F20" />
      <rect
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "new")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="67"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "new")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="262"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="264"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(15)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "new")}
        className="cursor-pointer"
        key={15}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(16)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "new")}
        className="cursor-pointer"
        key={16}
      />
      <path
        d="M346.89 198V177.29L342.178 178.544V174.44L349.094 171.4H352.21V198H346.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M338.9 338V334.238C340.521 332.946 342.092 331.654 343.612 330.362C345.157 329.07 346.538 327.791 347.754 326.524C348.97 325.232 349.933 323.978 350.642 322.762C351.351 321.546 351.706 320.368 351.706 319.228C351.706 318.519 351.579 317.873 351.326 317.29C351.073 316.682 350.667 316.201 350.11 315.846C349.578 315.466 348.869 315.276 347.982 315.276C347.095 315.276 346.348 315.479 345.74 315.884C345.132 316.289 344.676 316.834 344.372 317.518C344.068 318.177 343.916 318.924 343.916 319.76H338.938C339.014 317.809 339.457 316.175 340.268 314.858C341.079 313.541 342.168 312.565 343.536 311.932C344.904 311.273 346.437 310.944 348.134 310.944C350.009 310.944 351.592 311.299 352.884 312.008C354.176 312.692 355.151 313.629 355.81 314.82C356.494 316.011 356.836 317.379 356.836 318.924C356.836 320.089 356.621 321.229 356.19 322.344C355.785 323.459 355.202 324.548 354.442 325.612C353.707 326.651 352.871 327.651 351.934 328.614C350.997 329.577 350.021 330.501 349.008 331.388C347.995 332.249 347.007 333.06 346.044 333.82H357.482V338H338.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.4 501.456C379.677 501.456 378.094 501.139 376.65 500.506C375.206 499.873 374.053 498.91 373.192 497.618C372.331 496.326 371.875 494.692 371.824 492.716H376.84C376.865 493.552 377.055 494.312 377.41 494.996C377.765 495.655 378.284 496.187 378.968 496.592C379.652 496.972 380.463 497.162 381.4 497.162C382.287 497.162 383.047 496.985 383.68 496.63C384.313 496.275 384.795 495.807 385.124 495.224C385.453 494.641 385.618 493.97 385.618 493.21C385.618 492.323 385.39 491.589 384.934 491.006C384.503 490.398 383.895 489.942 383.11 489.638C382.35 489.334 381.476 489.182 380.488 489.182H378.512V484.964H380.488C381.729 484.964 382.768 484.673 383.604 484.09C384.465 483.507 384.896 482.633 384.896 481.468C384.896 480.505 384.579 479.733 383.946 479.15C383.338 478.567 382.477 478.276 381.362 478.276C380.146 478.276 379.196 478.631 378.512 479.34C377.828 480.049 377.448 480.923 377.372 481.962H372.356C372.432 480.29 372.85 478.859 373.61 477.668C374.395 476.452 375.447 475.527 376.764 474.894C378.081 474.261 379.614 473.944 381.362 473.944C383.211 473.944 384.769 474.273 386.036 474.932C387.328 475.565 388.303 476.427 388.962 477.516C389.621 478.605 389.95 479.783 389.95 481.05C389.95 482.089 389.747 483.013 389.342 483.824C388.962 484.635 388.443 485.306 387.784 485.838C387.125 486.37 386.403 486.75 385.618 486.978C386.606 487.181 387.467 487.573 388.202 488.156C388.962 488.713 389.545 489.435 389.95 490.322C390.381 491.209 390.596 492.235 390.596 493.4C390.596 494.844 390.241 496.187 389.532 497.428C388.848 498.644 387.809 499.619 386.416 500.354C385.048 501.089 383.376 501.456 381.4 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M316.782 501V496.174H303.71V492.108L316.098 474.4H321.912V491.728H325.37V496.174H321.912V501H316.782ZM309.182 491.728H317.124V480.062L309.182 491.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.122 663.456C379.197 663.456 377.525 663.114 376.106 662.43C374.713 661.746 373.623 660.809 372.838 659.618C372.053 658.427 371.597 657.072 371.47 655.552H376.486C376.663 656.54 377.17 657.376 378.006 658.06C378.842 658.744 379.893 659.086 381.16 659.086C382.072 659.086 382.87 658.858 383.554 658.402C384.238 657.946 384.77 657.338 385.15 656.578C385.53 655.793 385.72 654.906 385.72 653.918C385.72 652.905 385.517 652.031 385.112 651.296C384.732 650.561 384.2 649.991 383.516 649.586C382.857 649.181 382.097 648.978 381.236 648.978C380.147 648.978 379.209 649.244 378.424 649.776C377.664 650.283 377.119 650.903 376.79 651.638H371.812L374.016 636.4H388.95V640.884H377.816L376.714 646.812C377.271 646.229 378.019 645.761 378.956 645.406C379.893 645.026 380.945 644.836 382.11 644.836C383.554 644.836 384.808 645.089 385.872 645.596C386.936 646.077 387.823 646.749 388.532 647.61C389.241 648.446 389.773 649.409 390.128 650.498C390.483 651.562 390.66 652.689 390.66 653.88C390.66 655.273 390.419 656.553 389.938 657.718C389.482 658.883 388.823 659.897 387.962 660.758C387.126 661.619 386.125 662.291 384.96 662.772C383.82 663.228 382.541 663.456 381.122 663.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M314.616 663.456C312.615 663.456 310.917 663.089 309.524 662.354C308.156 661.619 307.054 660.631 306.218 659.39C305.407 658.149 304.812 656.768 304.432 655.248C304.077 653.703 303.9 652.145 303.9 650.574C303.9 647.585 304.318 645.001 305.154 642.822C305.99 640.643 307.193 638.959 308.764 637.768C310.335 636.552 312.235 635.944 314.464 635.944C316.339 635.944 317.922 636.311 319.214 637.046C320.506 637.755 321.507 638.693 322.216 639.858C322.925 641.023 323.343 642.277 323.47 643.62H318.682C318.479 642.505 318.011 641.657 317.276 641.074C316.541 640.466 315.591 640.162 314.426 640.162C313.337 640.162 312.387 640.491 311.576 641.15C310.765 641.809 310.132 642.797 309.676 644.114C309.245 645.431 308.992 647.091 308.916 649.092C308.916 649.117 308.916 649.155 308.916 649.206C308.916 649.257 308.916 649.295 308.916 649.32C309.321 648.636 309.853 648.028 310.512 647.496C311.171 646.964 311.931 646.546 312.792 646.242C313.653 645.938 314.565 645.786 315.528 645.786C316.997 645.786 318.365 646.141 319.632 646.85C320.899 647.559 321.925 648.56 322.71 649.852C323.495 651.144 323.888 652.677 323.888 654.45C323.888 656.046 323.495 657.541 322.71 658.934C321.95 660.302 320.873 661.404 319.48 662.24C318.087 663.051 316.465 663.456 314.616 663.456ZM314.312 659.048C315.224 659.048 316.022 658.858 316.706 658.478C317.415 658.098 317.973 657.579 318.378 656.92C318.783 656.236 318.986 655.463 318.986 654.602C318.986 653.69 318.783 652.905 318.378 652.246C317.973 651.587 317.415 651.068 316.706 650.688C315.997 650.308 315.186 650.118 314.274 650.118C313.387 650.118 312.589 650.308 311.88 650.688C311.171 651.068 310.601 651.6 310.17 652.284C309.765 652.943 309.562 653.703 309.562 654.564C309.562 655.451 309.765 656.236 310.17 656.92C310.601 657.579 311.171 658.098 311.88 658.478C312.615 658.858 313.425 659.048 314.312 659.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M374.218 824L383.984 801.77H371.102V797.4H389.228V801.01L379.538 824H374.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M314.008 824.456C312.209 824.456 310.563 824.127 309.068 823.468C307.599 822.809 306.433 821.885 305.572 820.694C304.711 819.503 304.28 818.123 304.28 816.552C304.28 815.463 304.457 814.475 304.812 813.588C305.192 812.701 305.711 811.916 306.37 811.232C307.029 810.548 307.814 810.029 308.726 809.674C307.586 809.142 306.661 808.382 305.952 807.394C305.268 806.406 304.926 805.291 304.926 804.05C304.926 802.809 305.268 801.643 305.952 800.554C306.636 799.465 307.649 798.591 308.992 797.932C310.335 797.273 312.007 796.944 314.008 796.944C316.009 796.944 317.681 797.273 319.024 797.932C320.367 798.591 321.38 799.465 322.064 800.554C322.748 801.643 323.09 802.809 323.09 804.05C323.09 805.266 322.735 806.381 322.026 807.394C321.342 808.382 320.43 809.142 319.29 809.674C320.202 810.054 320.987 810.586 321.646 811.27C322.33 811.929 322.849 812.701 323.204 813.588C323.584 814.475 323.774 815.463 323.774 816.552C323.774 818.123 323.331 819.503 322.444 820.694C321.583 821.885 320.417 822.809 318.948 823.468C317.479 824.127 315.832 824.456 314.008 824.456ZM314.008 820.162C315.579 820.162 316.757 819.782 317.542 819.022C318.327 818.262 318.72 817.299 318.72 816.134C318.72 814.842 318.302 813.829 317.466 813.094C316.655 812.334 315.503 811.954 314.008 811.954C312.539 811.954 311.373 812.334 310.512 813.094C309.676 813.829 309.258 814.842 309.258 816.134C309.258 817.299 309.663 818.262 310.474 819.022C311.285 819.782 312.463 820.162 314.008 820.162ZM314.008 808.192C315.3 808.192 316.288 807.863 316.972 807.204C317.681 806.545 318.036 805.697 318.036 804.658C318.036 803.543 317.681 802.682 316.972 802.074C316.288 801.441 315.3 801.124 314.008 801.124C312.741 801.124 311.753 801.441 311.044 802.074C310.335 802.682 309.98 803.556 309.98 804.696C309.98 805.709 310.335 806.545 311.044 807.204C311.753 807.863 312.741 808.192 314.008 808.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M27.628 823.456C25.7787 823.456 24.208 823.101 22.916 822.392C21.624 821.657 20.6233 820.707 19.914 819.542C19.23 818.377 18.812 817.123 18.66 815.78H23.448C23.676 816.895 24.1447 817.756 24.854 818.364C25.5887 818.947 26.5387 819.238 27.704 819.238C28.7933 819.238 29.7307 818.921 30.516 818.288C31.3267 817.629 31.96 816.654 32.416 815.362C32.872 814.045 33.1253 812.423 33.176 810.498C33.176 810.422 33.176 810.346 33.176 810.27C33.176 810.194 33.176 810.131 33.176 810.08C32.8213 810.739 32.302 811.347 31.618 811.904C30.934 812.436 30.1613 812.854 29.3 813.158C28.464 813.462 27.5647 813.614 26.602 813.614C25.158 813.614 23.79 813.259 22.498 812.55C21.206 811.841 20.1673 810.84 19.382 809.548C18.5967 808.256 18.204 806.723 18.204 804.95C18.204 803.329 18.5967 801.834 19.382 800.466C20.1673 799.098 21.2567 798.009 22.65 797.198C24.0433 796.362 25.652 795.944 27.476 795.944C29.5027 795.944 31.2 796.311 32.568 797.046C33.936 797.781 35.0253 798.769 35.836 800.01C36.672 801.251 37.2673 802.645 37.622 804.19C38.002 805.71 38.192 807.255 38.192 808.826C38.192 811.79 37.774 814.374 36.938 816.578C36.1273 818.757 34.9367 820.454 33.366 821.67C31.7953 822.861 29.8827 823.456 27.628 823.456ZM27.818 809.282C28.73 809.282 29.528 809.092 30.212 808.712C30.9213 808.332 31.4787 807.813 31.884 807.154C32.3147 806.47 32.53 805.697 32.53 804.836C32.53 803.949 32.3147 803.164 31.884 802.48C31.4787 801.796 30.9213 801.277 30.212 800.922C29.5027 800.542 28.692 800.352 27.78 800.352C26.8933 800.352 26.0953 800.542 25.386 800.922C24.6767 801.302 24.1193 801.821 23.714 802.48C23.334 803.139 23.144 803.911 23.144 804.798C23.144 805.685 23.334 806.47 23.714 807.154C24.1193 807.813 24.6767 808.332 25.386 808.712C26.0953 809.092 26.906 809.282 27.818 809.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M79.89 824V803.29L75.178 804.544V800.44L82.094 797.4H85.21V824H79.89ZM101.218 824.456C98.8111 824.456 96.7338 823.873 94.9858 822.708C93.2378 821.543 91.8951 819.934 90.9578 817.882C90.0458 815.805 89.5898 813.411 89.5898 810.7C89.5898 807.989 90.0458 805.608 90.9578 803.556C91.8951 801.479 93.2251 799.857 94.9478 798.692C96.6958 797.527 98.7858 796.944 101.218 796.944C103.65 796.944 105.727 797.527 107.45 798.692C109.198 799.857 110.528 801.479 111.44 803.556C112.377 805.608 112.846 807.989 112.846 810.7C112.846 813.411 112.377 815.805 111.44 817.882C110.528 819.934 109.198 821.543 107.45 822.708C105.727 823.873 103.65 824.456 101.218 824.456ZM101.218 819.858C102.484 819.858 103.599 819.491 104.562 818.756C105.524 817.996 106.272 816.932 106.804 815.564C107.361 814.196 107.64 812.575 107.64 810.7C107.64 808.8 107.361 807.179 106.804 805.836C106.272 804.468 105.524 803.417 104.562 802.682C103.599 801.947 102.484 801.58 101.218 801.58C99.9511 801.58 98.8365 801.947 97.8738 802.682C96.9111 803.417 96.1511 804.468 95.5938 805.836C95.0618 807.179 94.7958 808.8 94.7958 810.7C94.7958 812.575 95.0618 814.196 95.5938 815.564C96.1511 816.932 96.9111 817.996 97.8738 818.756C98.8365 819.491 99.9511 819.858 101.218 819.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M19.89 662V641.29L15.178 642.544V638.44L22.094 635.4H25.21V662H19.89ZM33.7318 662V641.29L29.0198 642.544V638.44L35.9358 635.4H39.0518V662H33.7318Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 662V641.29L78.178 642.544V638.44L85.094 635.4H88.21V662H82.89ZM92.7418 662V658.238C94.3631 656.946 95.9338 655.654 97.4538 654.362C98.9991 653.07 100.38 651.791 101.596 650.524C102.812 649.232 103.774 647.978 104.484 646.762C105.193 645.546 105.548 644.368 105.548 643.228C105.548 642.519 105.421 641.873 105.168 641.29C104.914 640.682 104.509 640.201 103.952 639.846C103.42 639.466 102.71 639.276 101.824 639.276C100.937 639.276 100.19 639.479 99.5818 639.884C98.9738 640.289 98.5178 640.834 98.2138 641.518C97.9098 642.177 97.7578 642.924 97.7578 643.76H92.7798C92.8558 641.809 93.2991 640.175 94.1098 638.858C94.9205 637.541 96.0098 636.565 97.3778 635.932C98.7458 635.273 100.278 634.944 101.976 634.944C103.85 634.944 105.434 635.299 106.726 636.008C108.018 636.692 108.993 637.629 109.652 638.82C110.336 640.011 110.678 641.379 110.678 642.924C110.678 644.089 110.462 645.229 110.032 646.344C109.626 647.459 109.044 648.548 108.284 649.612C107.549 650.651 106.713 651.651 105.776 652.614C104.838 653.577 103.863 654.501 102.85 655.388C101.836 656.249 100.848 657.06 99.8858 657.82H111.324V662H92.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M15.89 502V481.29L11.178 482.544V478.44L18.094 475.4H21.21V502H15.89ZM35.2418 502.456C33.5191 502.456 31.9358 502.139 30.4918 501.506C29.0478 500.873 27.8951 499.91 27.0338 498.618C26.1725 497.326 25.7165 495.692 25.6658 493.716H30.6818C30.7071 494.552 30.8971 495.312 31.2518 495.996C31.6065 496.655 32.1258 497.187 32.8098 497.592C33.4938 497.972 34.3045 498.162 35.2418 498.162C36.1285 498.162 36.8885 497.985 37.5218 497.63C38.1551 497.275 38.6365 496.807 38.9658 496.224C39.2951 495.641 39.4598 494.97 39.4598 494.21C39.4598 493.323 39.2318 492.589 38.7758 492.006C38.3451 491.398 37.7371 490.942 36.9518 490.638C36.1918 490.334 35.3178 490.182 34.3298 490.182H32.3538V485.964H34.3298C35.5711 485.964 36.6098 485.673 37.4458 485.09C38.3071 484.507 38.7378 483.633 38.7378 482.468C38.7378 481.505 38.4211 480.733 37.7878 480.15C37.1798 479.567 36.3185 479.276 35.2038 479.276C33.9878 479.276 33.0378 479.631 32.3538 480.34C31.6698 481.049 31.2898 481.923 31.2138 482.962H26.1978C26.2738 481.29 26.6918 479.859 27.4518 478.668C28.2371 477.452 29.2885 476.527 30.6058 475.894C31.9231 475.261 33.4558 474.944 35.2038 474.944C37.0531 474.944 38.6111 475.273 39.8778 475.932C41.1698 476.565 42.1451 477.427 42.8038 478.516C43.4625 479.605 43.7918 480.783 43.7918 482.05C43.7918 483.089 43.5891 484.013 43.1838 484.824C42.8038 485.635 42.2845 486.306 41.6258 486.838C40.9671 487.37 40.2451 487.75 39.4598 487.978C40.4478 488.181 41.3091 488.573 42.0438 489.156C42.8038 489.713 43.3865 490.435 43.7918 491.322C44.2225 492.209 44.4378 493.235 44.4378 494.4C44.4378 495.844 44.0831 497.187 43.3738 498.428C42.6898 499.644 41.6511 500.619 40.2578 501.354C38.8898 502.089 37.2178 502.456 35.2418 502.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M81.89 502V481.29L77.178 482.544V478.44L84.094 475.4H87.21V502H81.89ZM104.624 502V497.174H91.5518V493.108L103.94 475.4H109.754V492.728H113.212V497.174H109.754V502H104.624ZM97.0238 492.728H104.966V481.062L97.0238 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 340V319.29L42.178 320.544V316.44L49.094 313.4H52.21V340H46.89ZM66.9638 340.456C65.0385 340.456 63.3665 340.114 61.9478 339.43C60.5545 338.746 59.4651 337.809 58.6798 336.618C57.8945 335.427 57.4385 334.072 57.3118 332.552H62.3278C62.5051 333.54 63.0118 334.376 63.8478 335.06C64.6838 335.744 65.7351 336.086 67.0018 336.086C67.9138 336.086 68.7118 335.858 69.3958 335.402C70.0798 334.946 70.6118 334.338 70.9918 333.578C71.3718 332.793 71.5618 331.906 71.5618 330.918C71.5618 329.905 71.3591 329.031 70.9538 328.296C70.5738 327.561 70.0418 326.991 69.3578 326.586C68.6991 326.181 67.9391 325.978 67.0778 325.978C65.9885 325.978 65.0511 326.244 64.2658 326.776C63.5058 327.283 62.9611 327.903 62.6318 328.638H57.6538L59.8578 313.4H74.7918V317.884H63.6578L62.5558 323.812C63.1131 323.229 63.8605 322.761 64.7978 322.406C65.7351 322.026 66.7865 321.836 67.9518 321.836C69.3958 321.836 70.6498 322.089 71.7138 322.596C72.7778 323.077 73.6645 323.749 74.3738 324.61C75.0831 325.446 75.6151 326.409 75.9698 327.498C76.3245 328.562 76.5018 329.689 76.5018 330.88C76.5018 332.273 76.2611 333.553 75.7798 334.718C75.3238 335.883 74.6651 336.897 73.8038 337.758C72.9678 338.619 71.9671 339.291 70.8018 339.772C69.6618 340.228 68.3825 340.456 66.9638 340.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M45.89 203V182.29L41.178 183.544V179.44L48.094 176.4H51.21V203H45.89ZM66.4578 203.456C64.4565 203.456 62.7591 203.089 61.3658 202.354C59.9978 201.619 58.8958 200.631 58.0598 199.39C57.2491 198.149 56.6538 196.768 56.2738 195.248C55.9191 193.703 55.7418 192.145 55.7418 190.574C55.7418 187.585 56.1598 185.001 56.9958 182.822C57.8318 180.643 59.0351 178.959 60.6058 177.768C62.1765 176.552 64.0765 175.944 66.3058 175.944C68.1805 175.944 69.7638 176.311 71.0558 177.046C72.3478 177.755 73.3485 178.693 74.0578 179.858C74.7671 181.023 75.1851 182.277 75.3118 183.62H70.5238C70.3211 182.505 69.8525 181.657 69.1178 181.074C68.3831 180.466 67.4331 180.162 66.2678 180.162C65.1785 180.162 64.2285 180.491 63.4178 181.15C62.6071 181.809 61.9738 182.797 61.5178 184.114C61.0871 185.431 60.8338 187.091 60.7578 189.092C60.7578 189.117 60.7578 189.155 60.7578 189.206C60.7578 189.257 60.7578 189.295 60.7578 189.32C61.1631 188.636 61.6951 188.028 62.3538 187.496C63.0125 186.964 63.7725 186.546 64.6338 186.242C65.4951 185.938 66.4071 185.786 67.3698 185.786C68.8391 185.786 70.2071 186.141 71.4738 186.85C72.7405 187.559 73.7665 188.56 74.5518 189.852C75.3371 191.144 75.7298 192.677 75.7298 194.45C75.7298 196.046 75.3371 197.541 74.5518 198.934C73.7918 200.302 72.7151 201.404 71.3218 202.24C69.9285 203.051 68.3071 203.456 66.4578 203.456ZM66.1538 199.048C67.0658 199.048 67.8638 198.858 68.5478 198.478C69.2571 198.098 69.8145 197.579 70.2198 196.92C70.6251 196.236 70.8278 195.463 70.8278 194.602C70.8278 193.69 70.6251 192.905 70.2198 192.246C69.8145 191.587 69.2571 191.068 68.5478 190.688C67.8385 190.308 67.0278 190.118 66.1158 190.118C65.2291 190.118 64.4311 190.308 63.7218 190.688C63.0125 191.068 62.4425 191.6 62.0118 192.284C61.6065 192.943 61.4038 193.703 61.4038 194.564C61.4038 195.451 61.6065 196.236 62.0118 196.92C62.4425 197.579 63.0125 198.098 63.7218 198.478C64.4565 198.858 65.2671 199.048 66.1538 199.048Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truckNew18 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="209"
      height="611"
      viewBox="0 0 409 911"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-40px" }}
    >
      <path d="M66 783H57V837H66V783Z" fill="#231F20" />
      <path d="M352 783H343V837H352V783Z" fill="#231F20" />
      <path
        opacity="0.6"
        d="M325.416 48.3071H84C94.2858 34.1861 110.948 25 129.764 25H279.014C298.015 25 314.871 34.1676 325.416 48.3071Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M154.088 10.4059H113.287C115.025 4.10323 117.843 0 121.022 0H146.252C149.468 0 152.314 4.09399 154.098 10.4059H154.088Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M289.051 10.4059H248.25C249.987 4.10323 252.797 0 255.985 0H281.214C284.43 0 287.277 4.09399 289.06 10.4059H289.051Z"
        fill="#BFBEBE"
      />
      <path
        d="M384.47 74.7176H368.454C363.159 74.7176 358.862 79.0241 358.862 84.3103V85.5024H354.038C353.723 83.802 352.236 82.5082 350.443 82.5082C349.999 82.5082 349.639 82.8686 349.639 83.3122V102.507C349.639 102.95 349.999 103.311 350.443 103.311C352.356 103.311 353.908 101.832 354.075 99.9561L365.802 95.7513H384.47C388.435 95.7513 391.66 92.526 391.66 88.5614V81.8982C391.66 77.9336 388.435 74.7083 384.47 74.7083V74.7176ZM354.102 98.2372V87.1289H358.862V94.9565C358.862 95.4001 359.222 95.7605 359.666 95.7605H361.015L354.102 98.2372ZM390.043 88.5706C390.043 91.648 387.547 94.1432 384.47 94.1432H360.479V84.3103C360.479 79.9113 364.055 76.3256 368.464 76.3256H384.479C387.557 76.3256 390.052 78.8208 390.052 81.8982V88.5614L390.043 88.5706Z"
        fill="#BFBEBE"
      />
      <path
        d="M384.535 78.1924H368.353C365.1 78.1924 362.457 80.8355 362.457 84.0885V91.4724C362.457 91.916 362.817 92.2765 363.261 92.2765H384.535C386.476 92.2765 388.056 90.6962 388.056 88.7554V81.7134C388.056 79.7727 386.476 78.1924 384.535 78.1924Z"
        fill="#BFBEBE"
      />
      <path
        d="M21.935 74.7176H37.9505C43.2459 74.7176 47.5432 79.0241 47.5432 84.3103V85.5024H52.3673C52.6815 83.802 54.1694 82.5082 55.9622 82.5082C56.4058 82.5082 56.7662 82.8686 56.7662 83.3122V102.507C56.7662 102.95 56.4058 103.311 55.9622 103.311C54.0492 103.311 52.4967 101.832 52.3303 99.9561L40.6029 95.7513H21.935C17.9704 95.7513 14.7451 92.526 14.7451 88.5614V81.8982C14.7451 77.9336 17.9704 74.7083 21.935 74.7083V74.7176ZM52.2934 98.2372V87.1289H47.534V94.9565C47.534 95.4001 47.1736 95.7605 46.73 95.7605H45.3807L52.2934 98.2372ZM16.3531 88.5706C16.3531 91.648 18.8483 94.1432 21.9258 94.1432H45.9167V84.3103C45.9167 79.9113 42.3403 76.3256 37.9321 76.3256H21.935C18.8576 76.3256 16.3624 78.8208 16.3624 81.8982V88.5614L16.3531 88.5706Z"
        fill="#BFBEBE"
      />
      <path
        d="M21.8609 78.1924H38.0427C41.2957 78.1924 43.9388 80.8355 43.9388 84.0885V91.4724C43.9388 91.916 43.5784 92.2765 43.1348 92.2765H21.8609C19.9201 92.2765 18.3398 90.6962 18.3398 88.7554V81.7134C18.3398 79.7727 19.9201 78.1924 21.8609 78.1924Z"
        fill="#BFBEBE"
      />
      <rect
        x="287"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(9)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="352"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(8)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <path d="M352 622H343V676H352V622Z" fill="#231F20" />
      <rect
        x="286"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(7)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="353"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(6)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <path d="M352 461H343V515H352V461Z" fill="#231F20" />
      <rect
        x="286"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(5)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="353"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(4)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <path d="M352 294H343V348H352V294Z" fill="#231F20" />
      <rect
        x="286"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(3)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="353"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(2)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <path d="M66 622H57V676H66V622Z" fill="#231F20" />
      <rect
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(12)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="67"
        y="586"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(13)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "new")}
        className="cursor-pointer"
        key={13}
      />
      <path d="M66 461H57V515H66V461Z" fill="#231F20" />
      <rect
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(14)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "new")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="67"
        y="425"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(15)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "new")}
        className="cursor-pointer"
        key={15}
      />
      <path d="M66 294H57V348H66V294Z" fill="#231F20" />
      <rect
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(16)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "new")}
        className="cursor-pointer"
        key={16}
      />
      <rect
        x="67"
        y="258"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(17)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(17)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(17, "new")}
        className="cursor-pointer"
        key={17}
      />
      <rect
        x="1"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          addedTyre?.includes(10) && selectedTyre?.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : addedTyre?.includes(10)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="66"
        y="747"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(11)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <path
        d="M56.5 75C56.5 39.3776 85.3776 10.5 121 10.5H288C323.622 10.5 352.5 39.3776 352.5 75V893C352.5 902.665 344.665 910.5 335 910.5H74C64.335 910.5 56.5 902.665 56.5 893V75Z"
        stroke="black"
      />
      <path
        d="M66.5 80C66.5 47.139 93.1391 20.5 126 20.5H283C315.861 20.5 342.5 47.1391 342.5 80V884C342.5 893.665 334.665 901.5 325 901.5H84C74.335 901.5 66.5 893.665 66.5 884V80Z"
        stroke="black"
      />
      <rect
        x="320"
        y="121"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(1)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="31"
        y="123"
        width="56"
        height="126"
        rx="18"
        fill={
          selectedNewTyre?.includes(18)
            ? "rgba(58, 165, 86, 1)"
            : newAddedTyre?.includes(18)
            ? "rgb(77, 120, 137)"
            : "#999999"
        }
        onClick={() => handleSelection(18, "new")}
        className="cursor-pointer"
        key={18}
      />
      <path
        d="M345.89 197V176.29L341.178 177.544V173.44L348.094 170.4H351.21V197H345.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M372.9 334V330.238C374.521 328.946 376.092 327.654 377.612 326.362C379.157 325.07 380.538 323.791 381.754 322.524C382.97 321.232 383.933 319.978 384.642 318.762C385.351 317.546 385.706 316.368 385.706 315.228C385.706 314.519 385.579 313.873 385.326 313.29C385.073 312.682 384.667 312.201 384.11 311.846C383.578 311.466 382.869 311.276 381.982 311.276C381.095 311.276 380.348 311.479 379.74 311.884C379.132 312.289 378.676 312.834 378.372 313.518C378.068 314.177 377.916 314.924 377.916 315.76H372.938C373.014 313.809 373.457 312.175 374.268 310.858C375.079 309.541 376.168 308.565 377.536 307.932C378.904 307.273 380.437 306.944 382.134 306.944C384.009 306.944 385.592 307.299 386.884 308.008C388.176 308.692 389.151 309.629 389.81 310.82C390.494 312.011 390.836 313.379 390.836 314.924C390.836 316.089 390.621 317.229 390.19 318.344C389.785 319.459 389.202 320.548 388.442 321.612C387.707 322.651 386.871 323.651 385.934 324.614C384.997 325.577 384.021 326.501 383.008 327.388C381.995 328.249 381.007 329.06 380.044 329.82H391.482V334H372.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.4 334.456C311.677 334.456 310.094 334.139 308.65 333.506C307.206 332.873 306.053 331.91 305.192 330.618C304.331 329.326 303.875 327.692 303.824 325.716H308.84C308.865 326.552 309.055 327.312 309.41 327.996C309.765 328.655 310.284 329.187 310.968 329.592C311.652 329.972 312.463 330.162 313.4 330.162C314.287 330.162 315.047 329.985 315.68 329.63C316.313 329.275 316.795 328.807 317.124 328.224C317.453 327.641 317.618 326.97 317.618 326.21C317.618 325.323 317.39 324.589 316.934 324.006C316.503 323.398 315.895 322.942 315.11 322.638C314.35 322.334 313.476 322.182 312.488 322.182H310.512V317.964H312.488C313.729 317.964 314.768 317.673 315.604 317.09C316.465 316.507 316.896 315.633 316.896 314.468C316.896 313.505 316.579 312.733 315.946 312.15C315.338 311.567 314.477 311.276 313.362 311.276C312.146 311.276 311.196 311.631 310.512 312.34C309.828 313.049 309.448 313.923 309.372 314.962H304.356C304.432 313.29 304.85 311.859 305.61 310.668C306.395 309.452 307.447 308.527 308.764 307.894C310.081 307.261 311.614 306.944 313.362 306.944C315.211 306.944 316.769 307.273 318.036 307.932C319.328 308.565 320.303 309.427 320.962 310.516C321.621 311.605 321.95 312.783 321.95 314.05C321.95 315.089 321.747 316.013 321.342 316.824C320.962 317.635 320.443 318.306 319.784 318.838C319.125 319.37 318.403 319.75 317.618 319.978C318.606 320.181 319.467 320.573 320.202 321.156C320.962 321.713 321.545 322.435 321.95 323.322C322.381 324.209 322.596 325.235 322.596 326.4C322.596 327.844 322.241 329.187 321.532 330.428C320.848 331.644 319.809 332.619 318.416 333.354C317.048 334.089 315.376 334.456 313.4 334.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M383.782 502V497.174H370.71V493.108L383.098 475.4H388.912V492.728H392.37V497.174H388.912V502H383.782ZM376.182 492.728H384.124V481.062L376.182 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.122 501.456C311.197 501.456 309.525 501.114 308.106 500.43C306.713 499.746 305.623 498.809 304.838 497.618C304.053 496.427 303.597 495.072 303.47 493.552H308.486C308.663 494.54 309.17 495.376 310.006 496.06C310.842 496.744 311.893 497.086 313.16 497.086C314.072 497.086 314.87 496.858 315.554 496.402C316.238 495.946 316.77 495.338 317.15 494.578C317.53 493.793 317.72 492.906 317.72 491.918C317.72 490.905 317.517 490.031 317.112 489.296C316.732 488.561 316.2 487.991 315.516 487.586C314.857 487.181 314.097 486.978 313.236 486.978C312.147 486.978 311.209 487.244 310.424 487.776C309.664 488.283 309.119 488.903 308.79 489.638H303.812L306.016 474.4H320.95V478.884H309.816L308.714 484.812C309.271 484.229 310.019 483.761 310.956 483.406C311.893 483.026 312.945 482.836 314.11 482.836C315.554 482.836 316.808 483.089 317.872 483.596C318.936 484.077 319.823 484.749 320.532 485.61C321.241 486.446 321.773 487.409 322.128 488.498C322.483 489.562 322.66 490.689 322.66 491.88C322.66 493.273 322.419 494.553 321.938 495.718C321.482 496.883 320.823 497.897 319.962 498.758C319.126 499.619 318.125 500.291 316.96 500.772C315.82 501.228 314.541 501.456 313.122 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M382.616 662.456C380.615 662.456 378.917 662.089 377.524 661.354C376.156 660.619 375.054 659.631 374.218 658.39C373.407 657.149 372.812 655.768 372.432 654.248C372.077 652.703 371.9 651.145 371.9 649.574C371.9 646.585 372.318 644.001 373.154 641.822C373.99 639.643 375.193 637.959 376.764 636.768C378.335 635.552 380.235 634.944 382.464 634.944C384.339 634.944 385.922 635.311 387.214 636.046C388.506 636.755 389.507 637.693 390.216 638.858C390.925 640.023 391.343 641.277 391.47 642.62H386.682C386.479 641.505 386.011 640.657 385.276 640.074C384.541 639.466 383.591 639.162 382.426 639.162C381.337 639.162 380.387 639.491 379.576 640.15C378.765 640.809 378.132 641.797 377.676 643.114C377.245 644.431 376.992 646.091 376.916 648.092C376.916 648.117 376.916 648.155 376.916 648.206C376.916 648.257 376.916 648.295 376.916 648.32C377.321 647.636 377.853 647.028 378.512 646.496C379.171 645.964 379.931 645.546 380.792 645.242C381.653 644.938 382.565 644.786 383.528 644.786C384.997 644.786 386.365 645.141 387.632 645.85C388.899 646.559 389.925 647.56 390.71 648.852C391.495 650.144 391.888 651.677 391.888 653.45C391.888 655.046 391.495 656.541 390.71 657.934C389.95 659.302 388.873 660.404 387.48 661.24C386.087 662.051 384.465 662.456 382.616 662.456ZM382.312 658.048C383.224 658.048 384.022 657.858 384.706 657.478C385.415 657.098 385.973 656.579 386.378 655.92C386.783 655.236 386.986 654.463 386.986 653.602C386.986 652.69 386.783 651.905 386.378 651.246C385.973 650.587 385.415 650.068 384.706 649.688C383.997 649.308 383.186 649.118 382.274 649.118C381.387 649.118 380.589 649.308 379.88 649.688C379.171 650.068 378.601 650.6 378.17 651.284C377.765 651.943 377.562 652.703 377.562 653.564C377.562 654.451 377.765 655.236 378.17 655.92C378.601 656.579 379.171 657.098 379.88 657.478C380.615 657.858 381.425 658.048 382.312 658.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M307.218 662L316.984 639.77H304.102V635.4H322.228V639.01L312.538 662H307.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M381.008 823.456C379.209 823.456 377.563 823.127 376.068 822.468C374.599 821.809 373.433 820.885 372.572 819.694C371.711 818.503 371.28 817.123 371.28 815.552C371.28 814.463 371.457 813.475 371.812 812.588C372.192 811.701 372.711 810.916 373.37 810.232C374.029 809.548 374.814 809.029 375.726 808.674C374.586 808.142 373.661 807.382 372.952 806.394C372.268 805.406 371.926 804.291 371.926 803.05C371.926 801.809 372.268 800.643 372.952 799.554C373.636 798.465 374.649 797.591 375.992 796.932C377.335 796.273 379.007 795.944 381.008 795.944C383.009 795.944 384.681 796.273 386.024 796.932C387.367 797.591 388.38 798.465 389.064 799.554C389.748 800.643 390.09 801.809 390.09 803.05C390.09 804.266 389.735 805.381 389.026 806.394C388.342 807.382 387.43 808.142 386.29 808.674C387.202 809.054 387.987 809.586 388.646 810.27C389.33 810.929 389.849 811.701 390.204 812.588C390.584 813.475 390.774 814.463 390.774 815.552C390.774 817.123 390.331 818.503 389.444 819.694C388.583 820.885 387.417 821.809 385.948 822.468C384.479 823.127 382.832 823.456 381.008 823.456ZM381.008 819.162C382.579 819.162 383.757 818.782 384.542 818.022C385.327 817.262 385.72 816.299 385.72 815.134C385.72 813.842 385.302 812.829 384.466 812.094C383.655 811.334 382.503 810.954 381.008 810.954C379.539 810.954 378.373 811.334 377.512 812.094C376.676 812.829 376.258 813.842 376.258 815.134C376.258 816.299 376.663 817.262 377.474 818.022C378.285 818.782 379.463 819.162 381.008 819.162ZM381.008 807.192C382.3 807.192 383.288 806.863 383.972 806.204C384.681 805.545 385.036 804.697 385.036 803.658C385.036 802.543 384.681 801.682 383.972 801.074C383.288 800.441 382.3 800.124 381.008 800.124C379.741 800.124 378.753 800.441 378.044 801.074C377.335 801.682 376.98 802.556 376.98 803.696C376.98 804.709 377.335 805.545 378.044 806.204C378.753 806.863 379.741 807.192 381.008 807.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M313.628 823.456C311.779 823.456 310.208 823.101 308.916 822.392C307.624 821.657 306.623 820.707 305.914 819.542C305.23 818.377 304.812 817.123 304.66 815.78H309.448C309.676 816.895 310.145 817.756 310.854 818.364C311.589 818.947 312.539 819.238 313.704 819.238C314.793 819.238 315.731 818.921 316.516 818.288C317.327 817.629 317.96 816.654 318.416 815.362C318.872 814.045 319.125 812.423 319.176 810.498C319.176 810.422 319.176 810.346 319.176 810.27C319.176 810.194 319.176 810.131 319.176 810.08C318.821 810.739 318.302 811.347 317.618 811.904C316.934 812.436 316.161 812.854 315.3 813.158C314.464 813.462 313.565 813.614 312.602 813.614C311.158 813.614 309.79 813.259 308.498 812.55C307.206 811.841 306.167 810.84 305.382 809.548C304.597 808.256 304.204 806.723 304.204 804.95C304.204 803.329 304.597 801.834 305.382 800.466C306.167 799.098 307.257 798.009 308.65 797.198C310.043 796.362 311.652 795.944 313.476 795.944C315.503 795.944 317.2 796.311 318.568 797.046C319.936 797.781 321.025 798.769 321.836 800.01C322.672 801.251 323.267 802.645 323.622 804.19C324.002 805.71 324.192 807.255 324.192 808.826C324.192 811.79 323.774 814.374 322.938 816.578C322.127 818.757 320.937 820.454 319.366 821.67C317.795 822.861 315.883 823.456 313.628 823.456ZM313.818 809.282C314.73 809.282 315.528 809.092 316.212 808.712C316.921 808.332 317.479 807.813 317.884 807.154C318.315 806.47 318.53 805.697 318.53 804.836C318.53 803.949 318.315 803.164 317.884 802.48C317.479 801.796 316.921 801.277 316.212 800.922C315.503 800.542 314.692 800.352 313.78 800.352C312.893 800.352 312.095 800.542 311.386 800.922C310.677 801.302 310.119 801.821 309.714 802.48C309.334 803.139 309.144 803.911 309.144 804.798C309.144 805.685 309.334 806.47 309.714 807.154C310.119 807.813 310.677 808.332 311.386 808.712C312.095 809.092 312.906 809.282 313.818 809.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 823V802.29L9.178 803.544V799.44L16.094 796.4H19.21V823H13.89ZM35.2178 823.456C32.8111 823.456 30.7338 822.873 28.9858 821.708C27.2378 820.543 25.8951 818.934 24.9578 816.882C24.0458 814.805 23.5898 812.411 23.5898 809.7C23.5898 806.989 24.0458 804.608 24.9578 802.556C25.8951 800.479 27.2251 798.857 28.9478 797.692C30.6958 796.527 32.7858 795.944 35.2178 795.944C37.6498 795.944 39.7271 796.527 41.4498 797.692C43.1978 798.857 44.5278 800.479 45.4398 802.556C46.3771 804.608 46.8458 806.989 46.8458 809.7C46.8458 812.411 46.3771 814.805 45.4398 816.882C44.5278 818.934 43.1978 820.543 41.4498 821.708C39.7271 822.873 37.6498 823.456 35.2178 823.456ZM35.2178 818.858C36.4845 818.858 37.5991 818.491 38.5618 817.756C39.5245 816.996 40.2718 815.932 40.8038 814.564C41.3611 813.196 41.6398 811.575 41.6398 809.7C41.6398 807.8 41.3611 806.179 40.8038 804.836C40.2718 803.468 39.5245 802.417 38.5618 801.682C37.5991 800.947 36.4845 800.58 35.2178 800.58C33.9511 800.58 32.8365 800.947 31.8738 801.682C30.9111 802.417 30.1511 803.468 29.5938 804.836C29.0618 806.179 28.7958 807.8 28.7958 809.7C28.7958 811.575 29.0618 813.196 29.5938 814.564C30.1511 815.932 30.9111 816.996 31.8738 817.756C32.8365 818.491 33.9511 818.858 35.2178 818.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M86.89 823V802.29L82.178 803.544V799.44L89.094 796.4H92.21V823H86.89ZM100.732 823V802.29L96.0198 803.544V799.44L102.936 796.4H106.052V823H100.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 661V640.29L9.178 641.544V637.44L16.094 634.4H19.21V661H13.89ZM23.7418 661V657.238C25.3631 655.946 26.9338 654.654 28.4538 653.362C29.9991 652.07 31.3798 650.791 32.5958 649.524C33.8118 648.232 34.7745 646.978 35.4838 645.762C36.1931 644.546 36.5478 643.368 36.5478 642.228C36.5478 641.519 36.4211 640.873 36.1678 640.29C35.9145 639.682 35.5091 639.201 34.9518 638.846C34.4198 638.466 33.7105 638.276 32.8238 638.276C31.9371 638.276 31.1898 638.479 30.5818 638.884C29.9738 639.289 29.5178 639.834 29.2138 640.518C28.9098 641.177 28.7578 641.924 28.7578 642.76H23.7798C23.8558 640.809 24.2991 639.175 25.1098 637.858C25.9205 636.541 27.0098 635.565 28.3778 634.932C29.7458 634.273 31.2785 633.944 32.9758 633.944C34.8505 633.944 36.4338 634.299 37.7258 635.008C39.0178 635.692 39.9931 636.629 40.6518 637.82C41.3358 639.011 41.6778 640.379 41.6778 641.924C41.6778 643.089 41.4625 644.229 41.0318 645.344C40.6265 646.459 40.0438 647.548 39.2838 648.612C38.5491 649.651 37.7131 650.651 36.7758 651.614C35.8385 652.577 34.8631 653.501 33.8498 654.388C32.8365 655.249 31.8485 656.06 30.8858 656.82H42.3238V661H23.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 662V641.29L78.178 642.544V638.44L85.094 635.4H88.21V662H82.89ZM102.242 662.456C100.519 662.456 98.9358 662.139 97.4918 661.506C96.0478 660.873 94.8951 659.91 94.0338 658.618C93.1725 657.326 92.7165 655.692 92.6658 653.716H97.6818C97.7071 654.552 97.8971 655.312 98.2518 655.996C98.6065 656.655 99.1258 657.187 99.8098 657.592C100.494 657.972 101.304 658.162 102.242 658.162C103.128 658.162 103.888 657.985 104.522 657.63C105.155 657.275 105.636 656.807 105.966 656.224C106.295 655.641 106.46 654.97 106.46 654.21C106.46 653.323 106.232 652.589 105.776 652.006C105.345 651.398 104.737 650.942 103.952 650.638C103.192 650.334 102.318 650.182 101.33 650.182H99.3538V645.964H101.33C102.571 645.964 103.61 645.673 104.446 645.09C105.307 644.507 105.738 643.633 105.738 642.468C105.738 641.505 105.421 640.733 104.788 640.15C104.18 639.567 103.318 639.276 102.204 639.276C100.988 639.276 100.038 639.631 99.3538 640.34C98.6698 641.049 98.2898 641.923 98.2138 642.962H93.1978C93.2738 641.29 93.6918 639.859 94.4518 638.668C95.2371 637.452 96.2885 636.527 97.6058 635.894C98.9231 635.261 100.456 634.944 102.204 634.944C104.053 634.944 105.611 635.273 106.878 635.932C108.17 636.565 109.145 637.427 109.804 638.516C110.462 639.605 110.792 640.783 110.792 642.05C110.792 643.089 110.589 644.013 110.184 644.824C109.804 645.635 109.284 646.306 108.626 646.838C107.967 647.37 107.245 647.75 106.46 647.978C107.448 648.181 108.309 648.573 109.044 649.156C109.804 649.713 110.386 650.435 110.792 651.322C111.222 652.209 111.438 653.235 111.438 654.4C111.438 655.844 111.083 657.187 110.374 658.428C109.69 659.644 108.651 660.619 107.258 661.354C105.89 662.089 104.218 662.456 102.242 662.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 502V481.29L9.178 482.544V478.44L16.094 475.4H19.21V502H13.89ZM36.6238 502V497.174H23.5518V493.108L35.9398 475.4H41.7538V492.728H45.2118V497.174H41.7538V502H36.6238ZM29.0238 492.728H36.9658V481.062L29.0238 492.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M80.89 501V480.29L76.178 481.544V477.44L83.094 474.4H86.21V501H80.89ZM100.964 501.456C99.0385 501.456 97.3665 501.114 95.9478 500.43C94.5545 499.746 93.4651 498.809 92.6798 497.618C91.8945 496.427 91.4385 495.072 91.3118 493.552H96.3278C96.5051 494.54 97.0118 495.376 97.8478 496.06C98.6838 496.744 99.7351 497.086 101.002 497.086C101.914 497.086 102.712 496.858 103.396 496.402C104.08 495.946 104.612 495.338 104.992 494.578C105.372 493.793 105.562 492.906 105.562 491.918C105.562 490.905 105.359 490.031 104.954 489.296C104.574 488.561 104.042 487.991 103.358 487.586C102.699 487.181 101.939 486.978 101.078 486.978C99.9885 486.978 99.0511 487.244 98.2658 487.776C97.5058 488.283 96.9611 488.903 96.6318 489.638H91.6538L93.8578 474.4H108.792V478.884H97.6578L96.5558 484.812C97.1131 484.229 97.8605 483.761 98.7978 483.406C99.7351 483.026 100.786 482.836 101.952 482.836C103.396 482.836 104.65 483.089 105.714 483.596C106.778 484.077 107.664 484.749 108.374 485.61C109.083 486.446 109.615 487.409 109.97 488.498C110.324 489.562 110.502 490.689 110.502 491.88C110.502 493.273 110.261 494.553 109.78 495.718C109.324 496.883 108.665 497.897 107.804 498.758C106.968 499.619 105.967 500.291 104.802 500.772C103.662 501.228 102.382 501.456 100.964 501.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 334V313.29L9.178 314.544V310.44L16.094 307.4H19.21V334H13.89ZM34.4578 334.456C32.4565 334.456 30.7591 334.089 29.3658 333.354C27.9978 332.619 26.8958 331.631 26.0598 330.39C25.2491 329.149 24.6538 327.768 24.2738 326.248C23.9191 324.703 23.7418 323.145 23.7418 321.574C23.7418 318.585 24.1598 316.001 24.9958 313.822C25.8318 311.643 27.0351 309.959 28.6058 308.768C30.1765 307.552 32.0765 306.944 34.3058 306.944C36.1805 306.944 37.7638 307.311 39.0558 308.046C40.3478 308.755 41.3485 309.693 42.0578 310.858C42.7671 312.023 43.1851 313.277 43.3118 314.62H38.5238C38.3211 313.505 37.8525 312.657 37.1178 312.074C36.3831 311.466 35.4331 311.162 34.2678 311.162C33.1785 311.162 32.2285 311.491 31.4178 312.15C30.6071 312.809 29.9738 313.797 29.5178 315.114C29.0871 316.431 28.8338 318.091 28.7578 320.092C28.7578 320.117 28.7578 320.155 28.7578 320.206C28.7578 320.257 28.7578 320.295 28.7578 320.32C29.1631 319.636 29.6951 319.028 30.3538 318.496C31.0125 317.964 31.7725 317.546 32.6338 317.242C33.4951 316.938 34.4071 316.786 35.3698 316.786C36.8391 316.786 38.2071 317.141 39.4738 317.85C40.7405 318.559 41.7665 319.56 42.5518 320.852C43.3371 322.144 43.7298 323.677 43.7298 325.45C43.7298 327.046 43.3371 328.541 42.5518 329.934C41.7918 331.302 40.7151 332.404 39.3218 333.24C37.9285 334.051 36.3071 334.456 34.4578 334.456ZM34.1538 330.048C35.0658 330.048 35.8638 329.858 36.5478 329.478C37.2571 329.098 37.8145 328.579 38.2198 327.92C38.6251 327.236 38.8278 326.463 38.8278 325.602C38.8278 324.69 38.6251 323.905 38.2198 323.246C37.8145 322.587 37.2571 322.068 36.5478 321.688C35.8385 321.308 35.0278 321.118 34.1158 321.118C33.2291 321.118 32.4311 321.308 31.7218 321.688C31.0125 322.068 30.4425 322.6 30.0118 323.284C29.6065 323.943 29.4038 324.703 29.4038 325.564C29.4038 326.451 29.6065 327.236 30.0118 327.92C30.4425 328.579 31.0125 329.098 31.7218 329.478C32.4565 329.858 33.2671 330.048 34.1538 330.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M82.89 334V313.29L78.178 314.544V310.44L85.094 307.4H88.21V334H82.89ZM95.0598 334L104.826 311.77H91.9438V307.4H110.07V311.01L100.38 334H95.0598Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M46.89 197V176.29L42.178 177.544V173.44L49.094 170.4H52.21V197H46.89ZM66.8498 197.456C65.0511 197.456 63.4045 197.127 61.9098 196.468C60.4405 195.809 59.2751 194.885 58.4138 193.694C57.5525 192.503 57.1218 191.123 57.1218 189.552C57.1218 188.463 57.2991 187.475 57.6538 186.588C58.0338 185.701 58.5531 184.916 59.2118 184.232C59.8705 183.548 60.6558 183.029 61.5678 182.674C60.4278 182.142 59.5031 181.382 58.7938 180.394C58.1098 179.406 57.7678 178.291 57.7678 177.05C57.7678 175.809 58.1098 174.643 58.7938 173.554C59.4778 172.465 60.4911 171.591 61.8338 170.932C63.1765 170.273 64.8485 169.944 66.8498 169.944C68.8511 169.944 70.5231 170.273 71.8658 170.932C73.2085 171.591 74.2218 172.465 74.9058 173.554C75.5898 174.643 75.9318 175.809 75.9318 177.05C75.9318 178.266 75.5771 179.381 74.8678 180.394C74.1838 181.382 73.2718 182.142 72.1318 182.674C73.0438 183.054 73.8291 183.586 74.4878 184.27C75.1718 184.929 75.6911 185.701 76.0458 186.588C76.4258 187.475 76.6158 188.463 76.6158 189.552C76.6158 191.123 76.1725 192.503 75.2858 193.694C74.4245 194.885 73.2591 195.809 71.7898 196.468C70.3205 197.127 68.6738 197.456 66.8498 197.456ZM66.8498 193.162C68.4205 193.162 69.5985 192.782 70.3838 192.022C71.1691 191.262 71.5618 190.299 71.5618 189.134C71.5618 187.842 71.1438 186.829 70.3078 186.094C69.4971 185.334 68.3445 184.954 66.8498 184.954C65.3805 184.954 64.2151 185.334 63.3538 186.094C62.5178 186.829 62.0998 187.842 62.0998 189.134C62.0998 190.299 62.5051 191.262 63.3158 192.022C64.1265 192.782 65.3045 193.162 66.8498 193.162ZM66.8498 181.192C68.1418 181.192 69.1298 180.863 69.8138 180.204C70.5231 179.545 70.8778 178.697 70.8778 177.658C70.8778 176.543 70.5231 175.682 69.8138 175.074C69.1298 174.441 68.1418 174.124 66.8498 174.124C65.5831 174.124 64.5951 174.441 63.8858 175.074C63.1765 175.682 62.8218 176.556 62.8218 177.696C62.8218 178.709 63.1765 179.545 63.8858 180.204C64.5951 180.863 65.5831 181.192 66.8498 181.192Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
  const truckNew22 = ({ selectedNewTyre, newAddedTyre, handleSelection }) => (
    <svg
      width="179"
      height="760"
      viewBox="0 0 379 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: "-85px" }}
    >
      <path
        d="M52.4633 69.4987C52.4633 36.4893 79.2228 9.72983 112.232 9.72983H266.768C299.777 9.72983 326.537 36.4893 326.537 69.4988V942.587C326.537 951.543 319.276 958.803 310.32 958.803H68.6797C59.7236 958.803 52.4633 951.543 52.4633 942.587V69.4987Z"
        stroke="black"
        strokeWidth="0.92665"
      />
      <path
        d="M61.4633 75.8655C61.4633 45.4149 86.1484 20.7298 116.599 20.7298H262.401C292.852 20.7298 317.537 45.4149 317.537 75.8655V933.587C317.537 942.543 310.276 949.803 301.32 949.803H77.6797C68.7237 949.803 61.4633 942.543 61.4633 933.587V75.8655Z"
        stroke="black"
        strokeWidth="0.92665"
      />
      <path
        opacity="0.6"
        d="M301.546 44.7638H77.8379C87.3692 31.6785 102.809 23.1663 120.245 23.1663H258.548C276.155 23.1663 291.775 31.6614 301.546 44.7638Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M142.786 9.64266H104.978C106.588 3.80226 109.199 0 112.145 0H135.524C138.504 0 141.142 3.79369 142.795 9.64266H142.786Z"
        fill="#BFBEBE"
      />
      <path
        opacity="0.6"
        d="M267.849 9.64266H230.04C231.65 3.80226 234.253 0 237.208 0H260.587C263.567 0 266.204 3.79369 267.857 9.64266H267.849Z"
        fill="#BFBEBE"
      />
      <path
        d="M356.27 69.2371H341.429C336.522 69.2371 332.54 73.2277 332.54 78.1261V79.2308H328.069C327.778 77.6551 326.4 76.4562 324.738 76.4562C324.327 76.4562 323.993 76.7902 323.993 77.2012V94.9879C323.993 95.399 324.327 95.733 324.738 95.733C326.511 95.733 327.95 94.3628 328.104 92.6244L338.971 88.7279H356.27C359.943 88.7279 362.932 85.7392 362.932 82.0654V75.891C362.932 72.2172 359.943 69.2285 356.27 69.2285V69.2371ZM328.129 91.0315V80.738H332.54V87.9914C332.54 88.4025 332.874 88.7365 333.285 88.7365H334.535L328.129 91.0315ZM361.433 82.0739C361.433 84.9256 359.121 87.2378 356.27 87.2378H334.038V78.1261C334.038 74.0498 337.352 70.7271 341.437 70.7271H356.278C359.13 70.7271 361.442 73.0393 361.442 75.891V82.0654L361.433 82.0739Z"
        fill="#BFBEBE"
      />
      <path
        d="M356.33 72.457H341.335C338.32 72.457 335.871 74.9062 335.871 77.9206V84.7629C335.871 85.174 336.205 85.508 336.616 85.508H356.33C358.128 85.508 359.592 84.0436 359.592 82.2452V75.7197C359.592 73.9214 358.128 72.457 356.33 72.457Z"
        fill="#BFBEBE"
      />
      <path
        d="M20.3266 69.2371H35.1674C40.0743 69.2371 44.0564 73.2277 44.0564 78.1261V79.2308H48.5266C48.8178 77.6551 50.1966 76.4562 51.8579 76.4562C52.269 76.4562 52.6029 76.7902 52.6029 77.2012V94.9879C52.6029 95.399 52.269 95.733 51.8579 95.733C50.0852 95.733 48.6465 94.3628 48.4924 92.6244L37.6251 88.7279H20.3266C16.6528 88.7279 13.6641 85.7392 13.6641 82.0654V75.891C13.6641 72.2172 16.6528 69.2285 20.3266 69.2285V69.2371ZM48.4581 91.0315V80.738H44.0479V87.9914C44.0479 88.4025 43.7139 88.7365 43.3028 88.7365H42.0525L48.4581 91.0315ZM15.1541 82.0739C15.1541 84.9256 17.4663 87.2378 20.318 87.2378H42.5492V78.1261C42.5492 74.0498 39.2351 70.7271 35.1502 70.7271H20.3266C17.4749 70.7271 15.1627 73.0393 15.1627 75.891V82.0654L15.1541 82.0739Z"
        fill="#BFBEBE"
      />
      <path
        d="M20.2579 72.457H35.2528C38.2672 72.457 40.7164 74.9062 40.7164 77.9206V84.7629C40.7164 85.174 40.3824 85.508 39.9714 85.508H20.2579C18.4595 85.508 16.9951 84.0436 16.9951 82.2452V75.7197C16.9951 73.9214 18.4595 72.457 20.2579 72.457Z"
        fill="#BFBEBE"
      />
      <path
        d="M326.181 272.435H317.841V322.474H326.181V272.435Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(3)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(3)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(3, "new")}
        className="cursor-pointer"
        key={3}
      />
      <rect
        x="327.107"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(2)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(2)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(2, "new")}
        className="cursor-pointer"
        key={2}
      />
      <path
        d="M326.181 400.359H317.841V450.399H326.181V400.359Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(5)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(5)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(5, "new")}
        className="cursor-pointer"
        key={5}
      />
      <rect
        x="327.107"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(4)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(4)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(4, "new")}
        className="cursor-pointer"
        key={4}
      />
      <path
        d="M326.181 687.508H317.841V737.548H326.181V687.508Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(9)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(9)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(9, "new")}
        className="cursor-pointer"
        key={9}
      />
      <rect
        x="327.107"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(8)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(8)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(8, "new")}
        className="cursor-pointer"
        key={8}
      />
      <path
        d="M61.1592 687.508H52.8193V737.548H61.1592V687.508Z"
        fill="#231F20"
      />
      <rect
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(14)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(14)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(14, "new")}
        className="cursor-pointer"
        key={14}
      />
      <rect
        x="62.0859"
        y="654.149"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(15)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(15)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(15, "new")}
        className="cursor-pointer"
        key={15}
      />
      <path
        d="M326.181 535.318H317.841V585.357H326.181V535.318Z"
        fill="#231F20"
      />
      <rect
        x="265.021"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(7)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(7)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(7, "new")}
        className="cursor-pointer"
        key={7}
      />
      <rect
        x="327.107"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(6)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(6)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(6, "new")}
        className="cursor-pointer"
        key={6}
      />
      <path
        d="M61.1592 535.318H52.8193V585.357H61.1592V535.318Z"
        fill="#231F20"
      />
      <rect
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(16)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(16)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(16, "new")}
        className="cursor-pointer"
        key={16}
      />
      <rect
        x="62.0859"
        y="501.958"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(17)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(17)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(17, "new")}
        className="cursor-pointer"
        key={17}
      />
      <path
        d="M61.1592 272.435H52.8193V322.474H61.1592V272.435Z"
        fill="#231F20"
      />
      <rect
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(20)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(20)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(20, "new")}
        className="cursor-pointer"
        key={20}
      />
      <rect
        x="62.0859"
        y="239.076"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(21)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(21)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(21, "new")}
        className="cursor-pointer"
        key={21}
      />
      <path
        d="M61.1592 400.359H52.8193V450.399H61.1592V400.359Z"
        fill="#231F20"
      />
      <rect
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(18)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(18)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(18, "new")}
        className="cursor-pointer"
        key={18}
      />
      <rect
        x="62.0859"
        y="367"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(19)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(19)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(19, "new")}
        className="cursor-pointer"
        key={19}
      />
      <path
        d="M61.1582 839.699H52.8184V889.738H61.1582V839.699Z"
        fill="#231F20"
      />
      <path
        d="M326.181 839.699H317.841V889.738H326.181V839.699Z"
        fill="#231F20"
      />
      <rect
        x="265.948"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(11)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(11)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(11, "new")}
        className="cursor-pointer"
        key={11}
      />
      <rect
        x="326.181"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(10)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(10)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(10, "new")}
        className="cursor-pointer"
        key={10}
      />
      <rect
        x="0.925781"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(12)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(12)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(12, "new")}
        className="cursor-pointer"
        key={12}
      />
      <rect
        x="61.1582"
        y="806.34"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(13)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(13)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(13, "new")}
        className="cursor-pointer"
        key={13}
      />
      <rect
        x="296.528"
        y="112.125"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(1)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(1)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(1, "new")}
        className="cursor-pointer"
        key={1}
      />
      <rect
        x="28.7256"
        y="113.978"
        width="51.8924"
        height="116.758"
        rx="16.6797"
        fill={
          newAddedTyre.includes(22)
            ? "rgb(77, 120, 137)"
            : selectedNewTyre.includes(22)
            ? "rgba(58, 165, 86, 1)"
            : "#999999"
        }
        onClick={() => handleSelection(22, "new")}
        className="cursor-pointer"
        key={22}
      />
      <path
        d="M317.89 181V160.29L313.178 161.544V157.44L320.094 154.4H323.21V181H317.89Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M343.9 310V306.238C345.521 304.946 347.092 303.654 348.612 302.362C350.157 301.07 351.538 299.791 352.754 298.524C353.97 297.232 354.933 295.978 355.642 294.762C356.351 293.546 356.706 292.368 356.706 291.228C356.706 290.519 356.579 289.873 356.326 289.29C356.073 288.682 355.667 288.201 355.11 287.846C354.578 287.466 353.869 287.276 352.982 287.276C352.095 287.276 351.348 287.479 350.74 287.884C350.132 288.289 349.676 288.834 349.372 289.518C349.068 290.177 348.916 290.924 348.916 291.76H343.938C344.014 289.809 344.457 288.175 345.268 286.858C346.079 285.541 347.168 284.565 348.536 283.932C349.904 283.273 351.437 282.944 353.134 282.944C355.009 282.944 356.592 283.299 357.884 284.008C359.176 284.692 360.151 285.629 360.81 286.82C361.494 288.011 361.836 289.379 361.836 290.924C361.836 292.089 361.621 293.229 361.19 294.344C360.785 295.459 360.202 296.548 359.442 297.612C358.707 298.651 357.871 299.651 356.934 300.614C355.997 301.577 355.021 302.501 354.008 303.388C352.995 304.249 352.007 305.06 351.044 305.82H362.482V310H343.9Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M291.4 310.456C289.677 310.456 288.094 310.139 286.65 309.506C285.206 308.873 284.053 307.91 283.192 306.618C282.331 305.326 281.875 303.692 281.824 301.716H286.84C286.865 302.552 287.055 303.312 287.41 303.996C287.765 304.655 288.284 305.187 288.968 305.592C289.652 305.972 290.463 306.162 291.4 306.162C292.287 306.162 293.047 305.985 293.68 305.63C294.313 305.275 294.795 304.807 295.124 304.224C295.453 303.641 295.618 302.97 295.618 302.21C295.618 301.323 295.39 300.589 294.934 300.006C294.503 299.398 293.895 298.942 293.11 298.638C292.35 298.334 291.476 298.182 290.488 298.182H288.512V293.964H290.488C291.729 293.964 292.768 293.673 293.604 293.09C294.465 292.507 294.896 291.633 294.896 290.468C294.896 289.505 294.579 288.733 293.946 288.15C293.338 287.567 292.477 287.276 291.362 287.276C290.146 287.276 289.196 287.631 288.512 288.34C287.828 289.049 287.448 289.923 287.372 290.962H282.356C282.432 289.29 282.85 287.859 283.61 286.668C284.395 285.452 285.447 284.527 286.764 283.894C288.081 283.261 289.614 282.944 291.362 282.944C293.211 282.944 294.769 283.273 296.036 283.932C297.328 284.565 298.303 285.427 298.962 286.516C299.621 287.605 299.95 288.783 299.95 290.05C299.95 291.089 299.747 292.013 299.342 292.824C298.962 293.635 298.443 294.306 297.784 294.838C297.125 295.37 296.403 295.75 295.618 295.978C296.606 296.181 297.467 296.573 298.202 297.156C298.962 297.713 299.545 298.435 299.95 299.322C300.381 300.209 300.596 301.235 300.596 302.4C300.596 303.844 300.241 305.187 299.532 306.428C298.848 307.644 297.809 308.619 296.416 309.354C295.048 310.089 293.376 310.456 291.4 310.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M355.782 437V432.174H342.71V428.108L355.098 410.4H360.912V427.728H364.37V432.174H360.912V437H355.782ZM348.182 427.728H356.124V416.062L348.182 427.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M290.122 437.456C288.197 437.456 286.525 437.114 285.106 436.43C283.713 435.746 282.623 434.809 281.838 433.618C281.053 432.427 280.597 431.072 280.47 429.552H285.486C285.663 430.54 286.17 431.376 287.006 432.06C287.842 432.744 288.893 433.086 290.16 433.086C291.072 433.086 291.87 432.858 292.554 432.402C293.238 431.946 293.77 431.338 294.15 430.578C294.53 429.793 294.72 428.906 294.72 427.918C294.72 426.905 294.517 426.031 294.112 425.296C293.732 424.561 293.2 423.991 292.516 423.586C291.857 423.181 291.097 422.978 290.236 422.978C289.147 422.978 288.209 423.244 287.424 423.776C286.664 424.283 286.119 424.903 285.79 425.638H280.812L283.016 410.4H297.95V414.884H286.816L285.714 420.812C286.271 420.229 287.019 419.761 287.956 419.406C288.893 419.026 289.945 418.836 291.11 418.836C292.554 418.836 293.808 419.089 294.872 419.596C295.936 420.077 296.823 420.749 297.532 421.61C298.241 422.446 298.773 423.409 299.128 424.498C299.483 425.562 299.66 426.689 299.66 427.88C299.66 429.273 299.419 430.553 298.938 431.718C298.482 432.883 297.823 433.897 296.962 434.758C296.126 435.619 295.125 436.291 293.96 436.772C292.82 437.228 291.541 437.456 290.122 437.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M352.616 575.456C350.615 575.456 348.917 575.089 347.524 574.354C346.156 573.619 345.054 572.631 344.218 571.39C343.407 570.149 342.812 568.768 342.432 567.248C342.077 565.703 341.9 564.145 341.9 562.574C341.9 559.585 342.318 557.001 343.154 554.822C343.99 552.643 345.193 550.959 346.764 549.768C348.335 548.552 350.235 547.944 352.464 547.944C354.339 547.944 355.922 548.311 357.214 549.046C358.506 549.755 359.507 550.693 360.216 551.858C360.925 553.023 361.343 554.277 361.47 555.62H356.682C356.479 554.505 356.011 553.657 355.276 553.074C354.541 552.466 353.591 552.162 352.426 552.162C351.337 552.162 350.387 552.491 349.576 553.15C348.765 553.809 348.132 554.797 347.676 556.114C347.245 557.431 346.992 559.091 346.916 561.092C346.916 561.117 346.916 561.155 346.916 561.206C346.916 561.257 346.916 561.295 346.916 561.32C347.321 560.636 347.853 560.028 348.512 559.496C349.171 558.964 349.931 558.546 350.792 558.242C351.653 557.938 352.565 557.786 353.528 557.786C354.997 557.786 356.365 558.141 357.632 558.85C358.899 559.559 359.925 560.56 360.71 561.852C361.495 563.144 361.888 564.677 361.888 566.45C361.888 568.046 361.495 569.541 360.71 570.934C359.95 572.302 358.873 573.404 357.48 574.24C356.087 575.051 354.465 575.456 352.616 575.456ZM352.312 571.048C353.224 571.048 354.022 570.858 354.706 570.478C355.415 570.098 355.973 569.579 356.378 568.92C356.783 568.236 356.986 567.463 356.986 566.602C356.986 565.69 356.783 564.905 356.378 564.246C355.973 563.587 355.415 563.068 354.706 562.688C353.997 562.308 353.186 562.118 352.274 562.118C351.387 562.118 350.589 562.308 349.88 562.688C349.171 563.068 348.601 563.6 348.17 564.284C347.765 564.943 347.562 565.703 347.562 566.564C347.562 567.451 347.765 568.236 348.17 568.92C348.601 569.579 349.171 570.098 349.88 570.478C350.615 570.858 351.425 571.048 352.312 571.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M282.218 573L291.984 550.77H279.102V546.4H297.228V550.01L287.538 573H282.218Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M352.008 728.456C350.209 728.456 348.563 728.127 347.068 727.468C345.599 726.809 344.433 725.885 343.572 724.694C342.711 723.503 342.28 722.123 342.28 720.552C342.28 719.463 342.457 718.475 342.812 717.588C343.192 716.701 343.711 715.916 344.37 715.232C345.029 714.548 345.814 714.029 346.726 713.674C345.586 713.142 344.661 712.382 343.952 711.394C343.268 710.406 342.926 709.291 342.926 708.05C342.926 706.809 343.268 705.643 343.952 704.554C344.636 703.465 345.649 702.591 346.992 701.932C348.335 701.273 350.007 700.944 352.008 700.944C354.009 700.944 355.681 701.273 357.024 701.932C358.367 702.591 359.38 703.465 360.064 704.554C360.748 705.643 361.09 706.809 361.09 708.05C361.09 709.266 360.735 710.381 360.026 711.394C359.342 712.382 358.43 713.142 357.29 713.674C358.202 714.054 358.987 714.586 359.646 715.27C360.33 715.929 360.849 716.701 361.204 717.588C361.584 718.475 361.774 719.463 361.774 720.552C361.774 722.123 361.331 723.503 360.444 724.694C359.583 725.885 358.417 726.809 356.948 727.468C355.479 728.127 353.832 728.456 352.008 728.456ZM352.008 724.162C353.579 724.162 354.757 723.782 355.542 723.022C356.327 722.262 356.72 721.299 356.72 720.134C356.72 718.842 356.302 717.829 355.466 717.094C354.655 716.334 353.503 715.954 352.008 715.954C350.539 715.954 349.373 716.334 348.512 717.094C347.676 717.829 347.258 718.842 347.258 720.134C347.258 721.299 347.663 722.262 348.474 723.022C349.285 723.782 350.463 724.162 352.008 724.162ZM352.008 712.192C353.3 712.192 354.288 711.863 354.972 711.204C355.681 710.545 356.036 709.697 356.036 708.658C356.036 707.543 355.681 706.682 354.972 706.074C354.288 705.441 353.3 705.124 352.008 705.124C350.741 705.124 349.753 705.441 349.044 706.074C348.335 706.682 347.98 707.556 347.98 708.696C347.98 709.709 348.335 710.545 349.044 711.204C349.753 711.863 350.741 712.192 352.008 712.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M290.628 728.456C288.779 728.456 287.208 728.101 285.916 727.392C284.624 726.657 283.623 725.707 282.914 724.542C282.23 723.377 281.812 722.123 281.66 720.78H286.448C286.676 721.895 287.145 722.756 287.854 723.364C288.589 723.947 289.539 724.238 290.704 724.238C291.793 724.238 292.731 723.921 293.516 723.288C294.327 722.629 294.96 721.654 295.416 720.362C295.872 719.045 296.125 717.423 296.176 715.498C296.176 715.422 296.176 715.346 296.176 715.27C296.176 715.194 296.176 715.131 296.176 715.08C295.821 715.739 295.302 716.347 294.618 716.904C293.934 717.436 293.161 717.854 292.3 718.158C291.464 718.462 290.565 718.614 289.602 718.614C288.158 718.614 286.79 718.259 285.498 717.55C284.206 716.841 283.167 715.84 282.382 714.548C281.597 713.256 281.204 711.723 281.204 709.95C281.204 708.329 281.597 706.834 282.382 705.466C283.167 704.098 284.257 703.009 285.65 702.198C287.043 701.362 288.652 700.944 290.476 700.944C292.503 700.944 294.2 701.311 295.568 702.046C296.936 702.781 298.025 703.769 298.836 705.01C299.672 706.251 300.267 707.645 300.622 709.19C301.002 710.71 301.192 712.255 301.192 713.826C301.192 716.79 300.774 719.374 299.938 721.578C299.127 723.757 297.937 725.454 296.366 726.67C294.795 727.861 292.883 728.456 290.628 728.456ZM290.818 714.282C291.73 714.282 292.528 714.092 293.212 713.712C293.921 713.332 294.479 712.813 294.884 712.154C295.315 711.47 295.53 710.697 295.53 709.836C295.53 708.949 295.315 708.164 294.884 707.48C294.479 706.796 293.921 706.277 293.212 705.922C292.503 705.542 291.692 705.352 290.78 705.352C289.893 705.352 289.095 705.542 288.386 705.922C287.677 706.302 287.119 706.821 286.714 707.48C286.334 708.139 286.144 708.911 286.144 709.798C286.144 710.685 286.334 711.47 286.714 712.154C287.119 712.813 287.677 713.332 288.386 713.712C289.095 714.092 289.906 714.282 290.818 714.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M337.89 878V857.29L333.178 858.544V854.44L340.094 851.4H343.21V878H337.89ZM359.218 878.456C356.811 878.456 354.734 877.873 352.986 876.708C351.238 875.543 349.895 873.934 348.958 871.882C348.046 869.805 347.59 867.411 347.59 864.7C347.59 861.989 348.046 859.608 348.958 857.556C349.895 855.479 351.225 853.857 352.948 852.692C354.696 851.527 356.786 850.944 359.218 850.944C361.65 850.944 363.727 851.527 365.45 852.692C367.198 853.857 368.528 855.479 369.44 857.556C370.377 859.608 370.846 861.989 370.846 864.7C370.846 867.411 370.377 869.805 369.44 871.882C368.528 873.934 367.198 875.543 365.45 876.708C363.727 877.873 361.65 878.456 359.218 878.456ZM359.218 873.858C360.484 873.858 361.599 873.491 362.562 872.756C363.524 871.996 364.272 870.932 364.804 869.564C365.361 868.196 365.64 866.575 365.64 864.7C365.64 862.8 365.361 861.179 364.804 859.836C364.272 858.468 363.524 857.417 362.562 856.682C361.599 855.947 360.484 855.58 359.218 855.58C357.951 855.58 356.836 855.947 355.874 856.682C354.911 857.417 354.151 858.468 353.594 859.836C353.062 861.179 352.796 862.8 352.796 864.7C352.796 866.575 353.062 868.196 353.594 869.564C354.151 870.932 354.911 871.996 355.874 872.756C356.836 873.491 357.951 873.858 359.218 873.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M283.89 880V859.29L279.178 860.544V856.44L286.094 853.4H289.21V880H283.89ZM297.732 880V859.29L293.02 860.544V856.44L299.936 853.4H303.052V880H297.732Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M14.89 880V859.29L10.178 860.544V856.44L17.094 853.4H20.21V880H14.89ZM24.7418 880V876.238C26.3631 874.946 27.9338 873.654 29.4538 872.362C30.9991 871.07 32.3798 869.791 33.5958 868.524C34.8118 867.232 35.7745 865.978 36.4838 864.762C37.1931 863.546 37.5478 862.368 37.5478 861.228C37.5478 860.519 37.4211 859.873 37.1678 859.29C36.9145 858.682 36.5091 858.201 35.9518 857.846C35.4198 857.466 34.7105 857.276 33.8238 857.276C32.9371 857.276 32.1898 857.479 31.5818 857.884C30.9738 858.289 30.5178 858.834 30.2138 859.518C29.9098 860.177 29.7578 860.924 29.7578 861.76H24.7798C24.8558 859.809 25.2991 858.175 26.1098 856.858C26.9205 855.541 28.0098 854.565 29.3778 853.932C30.7458 853.273 32.2785 852.944 33.9758 852.944C35.8505 852.944 37.4338 853.299 38.7258 854.008C40.0178 854.692 40.9931 855.629 41.6518 856.82C42.3358 858.011 42.6778 859.379 42.6778 860.924C42.6778 862.089 42.4625 863.229 42.0318 864.344C41.6265 865.459 41.0438 866.548 40.2838 867.612C39.5491 868.651 38.7131 869.651 37.7758 870.614C36.8385 871.577 35.8631 872.501 34.8498 873.388C33.8365 874.249 32.8485 875.06 31.8858 875.82H43.3238V880H24.7418Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 880V859.29L70.178 860.544V856.44L77.094 853.4H80.21V880H74.89ZM94.2418 880.456C92.5191 880.456 90.9358 880.139 89.4918 879.506C88.0478 878.873 86.8951 877.91 86.0338 876.618C85.1725 875.326 84.7165 873.692 84.6658 871.716H89.6818C89.7071 872.552 89.8971 873.312 90.2518 873.996C90.6065 874.655 91.1258 875.187 91.8098 875.592C92.4938 875.972 93.3045 876.162 94.2418 876.162C95.1285 876.162 95.8885 875.985 96.5218 875.63C97.1551 875.275 97.6365 874.807 97.9658 874.224C98.2951 873.641 98.4598 872.97 98.4598 872.21C98.4598 871.323 98.2318 870.589 97.7758 870.006C97.3451 869.398 96.7371 868.942 95.9518 868.638C95.1918 868.334 94.3178 868.182 93.3298 868.182H91.3538V863.964H93.3298C94.5711 863.964 95.6098 863.673 96.4458 863.09C97.3071 862.507 97.7378 861.633 97.7378 860.468C97.7378 859.505 97.4211 858.733 96.7878 858.15C96.1798 857.567 95.3185 857.276 94.2038 857.276C92.9878 857.276 92.0378 857.631 91.3538 858.34C90.6698 859.049 90.2898 859.923 90.2138 860.962H85.1978C85.2738 859.29 85.6918 857.859 86.4518 856.668C87.2371 855.452 88.2885 854.527 89.6058 853.894C90.9231 853.261 92.4558 852.944 94.2038 852.944C96.0531 852.944 97.6111 853.273 98.8778 853.932C100.17 854.565 101.145 855.427 101.804 856.516C102.462 857.605 102.792 858.783 102.792 860.05C102.792 861.089 102.589 862.013 102.184 862.824C101.804 863.635 101.284 864.306 100.626 864.838C99.9671 865.37 99.2451 865.75 98.4598 865.978C99.4478 866.181 100.309 866.573 101.044 867.156C101.804 867.713 102.386 868.435 102.792 869.322C103.222 870.209 103.438 871.235 103.438 872.4C103.438 873.844 103.083 875.187 102.374 876.428C101.69 877.644 100.651 878.619 99.2578 879.354C97.8898 880.089 96.2178 880.456 94.2418 880.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 726V705.29L8.178 706.544V702.44L15.094 699.4H18.21V726H12.89ZM35.6238 726V721.174H22.5518V717.108L34.9398 699.4H40.7538V716.728H44.2118V721.174H40.7538V726H35.6238ZM28.0238 716.728H35.9658V705.062L28.0238 716.728Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 726V705.29L70.178 706.544V702.44L77.094 699.4H80.21V726H74.89ZM94.9638 726.456C93.0385 726.456 91.3665 726.114 89.9478 725.43C88.5545 724.746 87.4651 723.809 86.6798 722.618C85.8945 721.427 85.4385 720.072 85.3118 718.552H90.3278C90.5051 719.54 91.0118 720.376 91.8478 721.06C92.6838 721.744 93.7351 722.086 95.0018 722.086C95.9138 722.086 96.7118 721.858 97.3958 721.402C98.0798 720.946 98.6118 720.338 98.9918 719.578C99.3718 718.793 99.5618 717.906 99.5618 716.918C99.5618 715.905 99.3591 715.031 98.9538 714.296C98.5738 713.561 98.0418 712.991 97.3578 712.586C96.6991 712.181 95.9391 711.978 95.0778 711.978C93.9885 711.978 93.0511 712.244 92.2658 712.776C91.5058 713.283 90.9611 713.903 90.6318 714.638H85.6538L87.8578 699.4H102.792V703.884H91.6578L90.5558 709.812C91.1131 709.229 91.8605 708.761 92.7978 708.406C93.7351 708.026 94.7865 707.836 95.9518 707.836C97.3958 707.836 98.6498 708.089 99.7138 708.596C100.778 709.077 101.664 709.749 102.374 710.61C103.083 711.446 103.615 712.409 103.97 713.498C104.324 714.562 104.502 715.689 104.502 716.88C104.502 718.273 104.261 719.553 103.78 720.718C103.324 721.883 102.665 722.897 101.804 723.758C100.968 724.619 99.9671 725.291 98.8018 725.772C97.6618 726.228 96.3825 726.456 94.9638 726.456Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M13.89 570V549.29L9.178 550.544V546.44L16.094 543.4H19.21V570H13.89ZM34.4578 570.456C32.4565 570.456 30.7591 570.089 29.3658 569.354C27.9978 568.619 26.8958 567.631 26.0598 566.39C25.2491 565.149 24.6538 563.768 24.2738 562.248C23.9191 560.703 23.7418 559.145 23.7418 557.574C23.7418 554.585 24.1598 552.001 24.9958 549.822C25.8318 547.643 27.0351 545.959 28.6058 544.768C30.1765 543.552 32.0765 542.944 34.3058 542.944C36.1805 542.944 37.7638 543.311 39.0558 544.046C40.3478 544.755 41.3485 545.693 42.0578 546.858C42.7671 548.023 43.1851 549.277 43.3118 550.62H38.5238C38.3211 549.505 37.8525 548.657 37.1178 548.074C36.3831 547.466 35.4331 547.162 34.2678 547.162C33.1785 547.162 32.2285 547.491 31.4178 548.15C30.6071 548.809 29.9738 549.797 29.5178 551.114C29.0871 552.431 28.8338 554.091 28.7578 556.092C28.7578 556.117 28.7578 556.155 28.7578 556.206C28.7578 556.257 28.7578 556.295 28.7578 556.32C29.1631 555.636 29.6951 555.028 30.3538 554.496C31.0125 553.964 31.7725 553.546 32.6338 553.242C33.4951 552.938 34.4071 552.786 35.3698 552.786C36.8391 552.786 38.2071 553.141 39.4738 553.85C40.7405 554.559 41.7665 555.56 42.5518 556.852C43.3371 558.144 43.7298 559.677 43.7298 561.45C43.7298 563.046 43.3371 564.541 42.5518 565.934C41.7918 567.302 40.7151 568.404 39.3218 569.24C37.9285 570.051 36.3071 570.456 34.4578 570.456ZM34.1538 566.048C35.0658 566.048 35.8638 565.858 36.5478 565.478C37.2571 565.098 37.8145 564.579 38.2198 563.92C38.6251 563.236 38.8278 562.463 38.8278 561.602C38.8278 560.69 38.6251 559.905 38.2198 559.246C37.8145 558.587 37.2571 558.068 36.5478 557.688C35.8385 557.308 35.0278 557.118 34.1158 557.118C33.2291 557.118 32.4311 557.308 31.7218 557.688C31.0125 558.068 30.4425 558.6 30.0118 559.284C29.6065 559.943 29.4038 560.703 29.4038 561.564C29.4038 562.451 29.6065 563.236 30.0118 563.92C30.4425 564.579 31.0125 565.098 31.7218 565.478C32.4565 565.858 33.2671 566.048 34.1538 566.048Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M76.89 570V549.29L72.178 550.544V546.44L79.094 543.4H82.21V570H76.89ZM89.0598 570L98.8258 547.77H85.9438V543.4H104.07V547.01L94.3798 570H89.0598Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M12.89 438V417.29L8.178 418.544V414.44L15.094 411.4H18.21V438H12.89ZM32.8498 438.456C31.0511 438.456 29.4045 438.127 27.9098 437.468C26.4405 436.809 25.2751 435.885 24.4138 434.694C23.5525 433.503 23.1218 432.123 23.1218 430.552C23.1218 429.463 23.2991 428.475 23.6538 427.588C24.0338 426.701 24.5531 425.916 25.2118 425.232C25.8705 424.548 26.6558 424.029 27.5678 423.674C26.4278 423.142 25.5031 422.382 24.7938 421.394C24.1098 420.406 23.7678 419.291 23.7678 418.05C23.7678 416.809 24.1098 415.643 24.7938 414.554C25.4778 413.465 26.4911 412.591 27.8338 411.932C29.1765 411.273 30.8485 410.944 32.8498 410.944C34.8511 410.944 36.5231 411.273 37.8658 411.932C39.2085 412.591 40.2218 413.465 40.9058 414.554C41.5898 415.643 41.9318 416.809 41.9318 418.05C41.9318 419.266 41.5771 420.381 40.8678 421.394C40.1838 422.382 39.2718 423.142 38.1318 423.674C39.0438 424.054 39.8291 424.586 40.4878 425.27C41.1718 425.929 41.6911 426.701 42.0458 427.588C42.4258 428.475 42.6158 429.463 42.6158 430.552C42.6158 432.123 42.1725 433.503 41.2858 434.694C40.4245 435.885 39.2591 436.809 37.7898 437.468C36.3205 438.127 34.6738 438.456 32.8498 438.456ZM32.8498 434.162C34.4205 434.162 35.5985 433.782 36.3838 433.022C37.1691 432.262 37.5618 431.299 37.5618 430.134C37.5618 428.842 37.1438 427.829 36.3078 427.094C35.4971 426.334 34.3445 425.954 32.8498 425.954C31.3805 425.954 30.2151 426.334 29.3538 427.094C28.5178 427.829 28.0998 428.842 28.0998 430.134C28.0998 431.299 28.5051 432.262 29.3158 433.022C30.1265 433.782 31.3045 434.162 32.8498 434.162ZM32.8498 422.192C34.1418 422.192 35.1298 421.863 35.8138 421.204C36.5231 420.545 36.8778 419.697 36.8778 418.658C36.8778 417.543 36.5231 416.682 35.8138 416.074C35.1298 415.441 34.1418 415.124 32.8498 415.124C31.5831 415.124 30.5951 415.441 29.8858 416.074C29.1765 416.682 28.8218 417.556 28.8218 418.696C28.8218 419.709 29.1765 420.545 29.8858 421.204C30.5951 421.863 31.5831 422.192 32.8498 422.192Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M74.89 438V417.29L70.178 418.544V414.44L77.094 411.4H80.21V438H74.89ZM94.4698 438.456C92.6205 438.456 91.0498 438.101 89.7578 437.392C88.4658 436.657 87.4651 435.707 86.7558 434.542C86.0718 433.377 85.6538 432.123 85.5018 430.78H90.2898C90.5178 431.895 90.9865 432.756 91.6958 433.364C92.4305 433.947 93.3805 434.238 94.5458 434.238C95.6351 434.238 96.5725 433.921 97.3578 433.288C98.1685 432.629 98.8018 431.654 99.2578 430.362C99.7138 429.045 99.9671 427.423 100.018 425.498C100.018 425.422 100.018 425.346 100.018 425.27C100.018 425.194 100.018 425.131 100.018 425.08C99.6631 425.739 99.1438 426.347 98.4598 426.904C97.7758 427.436 97.0031 427.854 96.1418 428.158C95.3058 428.462 94.4065 428.614 93.4438 428.614C91.9998 428.614 90.6318 428.259 89.3398 427.55C88.0478 426.841 87.0091 425.84 86.2238 424.548C85.4385 423.256 85.0458 421.723 85.0458 419.95C85.0458 418.329 85.4385 416.834 86.2238 415.466C87.0091 414.098 88.0985 413.009 89.4918 412.198C90.8851 411.362 92.4938 410.944 94.3178 410.944C96.3445 410.944 98.0418 411.311 99.4098 412.046C100.778 412.781 101.867 413.769 102.678 415.01C103.514 416.251 104.109 417.645 104.464 419.19C104.844 420.71 105.034 422.255 105.034 423.826C105.034 426.79 104.616 429.374 103.78 431.578C102.969 433.757 101.778 435.454 100.208 436.67C98.6371 437.861 96.7245 438.456 94.4698 438.456ZM94.6598 424.282C95.5718 424.282 96.3698 424.092 97.0538 423.712C97.7631 423.332 98.3205 422.813 98.7258 422.154C99.1565 421.47 99.3718 420.697 99.3718 419.836C99.3718 418.949 99.1565 418.164 98.7258 417.48C98.3205 416.796 97.7631 416.277 97.0538 415.922C96.3445 415.542 95.5338 415.352 94.6218 415.352C93.7351 415.352 92.9371 415.542 92.2278 415.922C91.5185 416.302 90.9611 416.821 90.5558 417.48C90.1758 418.139 89.9858 418.911 89.9858 419.798C89.9858 420.685 90.1758 421.47 90.5558 422.154C90.9611 422.813 91.5185 423.332 92.2278 423.712C92.9371 424.092 93.7478 424.282 94.6598 424.282Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M3.9 314V310.238C5.52133 308.946 7.092 307.654 8.612 306.362C10.1573 305.07 11.538 303.791 12.754 302.524C13.97 301.232 14.9327 299.978 15.642 298.762C16.3513 297.546 16.706 296.368 16.706 295.228C16.706 294.519 16.5793 293.873 16.326 293.29C16.0727 292.682 15.6673 292.201 15.11 291.846C14.578 291.466 13.8687 291.276 12.982 291.276C12.0953 291.276 11.348 291.479 10.74 291.884C10.132 292.289 9.676 292.834 9.372 293.518C9.068 294.177 8.916 294.924 8.916 295.76H3.938C4.014 293.809 4.45733 292.175 5.268 290.858C6.07867 289.541 7.168 288.565 8.536 287.932C9.904 287.273 11.4367 286.944 13.134 286.944C15.0087 286.944 16.592 287.299 17.884 288.008C19.176 288.692 20.1513 289.629 20.81 290.82C21.494 292.011 21.836 293.379 21.836 294.924C21.836 296.089 21.6207 297.229 21.19 298.344C20.7847 299.459 20.202 300.548 19.442 301.612C18.7073 302.651 17.8713 303.651 16.934 304.614C15.9967 305.577 15.0213 306.501 14.008 307.388C12.9947 308.249 12.0067 309.06 11.044 309.82H22.482V314H3.9ZM37.1592 314.456C34.7525 314.456 32.6752 313.873 30.9272 312.708C29.1792 311.543 27.8365 309.934 26.8992 307.882C25.9872 305.805 25.5312 303.411 25.5312 300.7C25.5312 297.989 25.9872 295.608 26.8992 293.556C27.8365 291.479 29.1665 289.857 30.8892 288.692C32.6372 287.527 34.7272 286.944 37.1592 286.944C39.5912 286.944 41.6685 287.527 43.3912 288.692C45.1392 289.857 46.4692 291.479 47.3812 293.556C48.3185 295.608 48.7872 297.989 48.7872 300.7C48.7872 303.411 48.3185 305.805 47.3812 307.882C46.4692 309.934 45.1392 311.543 43.3912 312.708C41.6685 313.873 39.5912 314.456 37.1592 314.456ZM37.1592 309.858C38.4259 309.858 39.5405 309.491 40.5032 308.756C41.4659 307.996 42.2132 306.932 42.7452 305.564C43.3025 304.196 43.5812 302.575 43.5812 300.7C43.5812 298.8 43.3025 297.179 42.7452 295.836C42.2132 294.468 41.4659 293.417 40.5032 292.682C39.5405 291.947 38.4259 291.58 37.1592 291.58C35.8925 291.58 34.7779 291.947 33.8152 292.682C32.8525 293.417 32.0925 294.468 31.5352 295.836C31.0032 297.179 30.7372 298.8 30.7372 300.7C30.7372 302.575 31.0032 304.196 31.5352 305.564C32.0925 306.932 32.8525 307.996 33.8152 308.756C34.7779 309.491 35.8925 309.858 37.1592 309.858Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M71.9 314V310.238C73.5213 308.946 75.092 307.654 76.612 306.362C78.1573 305.07 79.538 303.791 80.754 302.524C81.97 301.232 82.9327 299.978 83.642 298.762C84.3513 297.546 84.706 296.368 84.706 295.228C84.706 294.519 84.5793 293.873 84.326 293.29C84.0727 292.682 83.6673 292.201 83.11 291.846C82.578 291.466 81.8687 291.276 80.982 291.276C80.0953 291.276 79.348 291.479 78.74 291.884C78.132 292.289 77.676 292.834 77.372 293.518C77.068 294.177 76.916 294.924 76.916 295.76H71.938C72.014 293.809 72.4573 292.175 73.268 290.858C74.0787 289.541 75.168 288.565 76.536 287.932C77.904 287.273 79.4367 286.944 81.134 286.944C83.0087 286.944 84.592 287.299 85.884 288.008C87.176 288.692 88.1513 289.629 88.81 290.82C89.494 292.011 89.836 293.379 89.836 294.924C89.836 296.089 89.6207 297.229 89.19 298.344C88.7847 299.459 88.202 300.548 87.442 301.612C86.7073 302.651 85.8713 303.651 84.934 304.614C83.9967 305.577 83.0213 306.501 82.008 307.388C80.9947 308.249 80.0067 309.06 79.044 309.82H90.482V314H71.9ZM97.8216 314V293.29L93.1096 294.544V290.44L100.026 287.4H103.142V314H97.8216Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M32.9 187V183.238C34.5213 181.946 36.092 180.654 37.612 179.362C39.1573 178.07 40.538 176.791 41.754 175.524C42.97 174.232 43.9327 172.978 44.642 171.762C45.3513 170.546 45.706 169.368 45.706 168.228C45.706 167.519 45.5793 166.873 45.326 166.29C45.0727 165.682 44.6673 165.201 44.11 164.846C43.578 164.466 42.8687 164.276 41.982 164.276C41.0953 164.276 40.348 164.479 39.74 164.884C39.132 165.289 38.676 165.834 38.372 166.518C38.068 167.177 37.916 167.924 37.916 168.76H32.938C33.014 166.809 33.4573 165.175 34.268 163.858C35.0787 162.541 36.168 161.565 37.536 160.932C38.904 160.273 40.4367 159.944 42.134 159.944C44.0087 159.944 45.592 160.299 46.884 161.008C48.176 161.692 49.1513 162.629 49.81 163.82C50.494 165.011 50.836 166.379 50.836 167.924C50.836 169.089 50.6207 170.229 50.19 171.344C49.7847 172.459 49.202 173.548 48.442 174.612C47.7073 175.651 46.8713 176.651 45.934 177.614C44.9967 178.577 44.0213 179.501 43.008 180.388C41.9947 181.249 41.0067 182.06 40.044 182.82H51.482V187H32.9ZM54.8316 187V183.238C56.453 181.946 58.0236 180.654 59.5436 179.362C61.089 178.07 62.4696 176.791 63.6856 175.524C64.9016 174.232 65.8643 172.978 66.5736 171.762C67.283 170.546 67.6376 169.368 67.6376 168.228C67.6376 167.519 67.511 166.873 67.2576 166.29C67.0043 165.682 66.599 165.201 66.0416 164.846C65.5096 164.466 64.8003 164.276 63.9136 164.276C63.027 164.276 62.2796 164.479 61.6716 164.884C61.0636 165.289 60.6076 165.834 60.3036 166.518C59.9996 167.177 59.8476 167.924 59.8476 168.76H54.8696C54.9456 166.809 55.389 165.175 56.1996 163.858C57.0103 162.541 58.0996 161.565 59.4676 160.932C60.8356 160.273 62.3683 159.944 64.0656 159.944C65.9403 159.944 67.5236 160.299 68.8156 161.008C70.1076 161.692 71.083 162.629 71.7416 163.82C72.4256 165.011 72.7676 166.379 72.7676 167.924C72.7676 169.089 72.5523 170.229 72.1216 171.344C71.7163 172.459 71.1336 173.548 70.3736 174.612C69.639 175.651 68.803 176.651 67.8656 177.614C66.9283 178.577 65.953 179.501 64.9396 180.388C63.9263 181.249 62.9383 182.06 61.9756 182.82H73.4136V187H54.8316Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );

  const tyreNewSvgs = {
    6: truckNew6,
    10: truckNew10,
    12: trucNewk12,
    14: truckNew14,
    16: truckNew16,
    18: truckNew18,
    22: truckNew22,
  };

  const handleSvg = (vehicleId) => {
    const tyreData = vehicleList.find((data) => data.value == vehicleId);
    const tyreModel = tyreData?.tyreModel || 22;
    return tyreSvgs[tyreModel] || null;
  };

  useEffect(() => {
    let SvgComponent = handleSvg(currentVehicle.value);
    setCurrentSvg(() => SvgComponent);
  }, [currentVehicle]);

  const handleNewSvg = (vehicleId) => {
    const tyreData = vehicleList.find((data) => data.value == vehicleId);
    const tyreModel = tyreData?.tyreModel || 22;
    return tyreNewSvgs[tyreModel] || null;
  };

  useEffect(() => {
    let SvgComponent = handleNewSvg(newVehicle.value);
    setCurrentNewSvg(() => SvgComponent);
  }, [newVehicle]);

  return (
    <div className={styles.TyreChange}>
      <Modal show={show} onHide={() => setShow(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Select New Installation Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DatePicker
            selected={date}
            onChange={(date) => setDate(date)}
            maxDate={Date.now()}
            dateFormat={"dd/MM/yyyy"}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#2A7C76", color: "white" }}
            onClick={handleSubmit}
          >
            submit
          </Button>
        </Modal.Footer>
      </Modal>

      <div className={styles.vehicleList}>
        <div className={styles.card}>
          <div className="row">
            <div className="col-md-5 col-lg-5 col-xs-12 text-left">
              <label className="">Select vehicle</label>
              <Select
                options={vehicleList}
                value={currentVehicle}
                onChange={(selectedOption) => setCurrentVehicle(selectedOption)}
              />
            </div>
            <div
              className="col-md-2 col-lg-2 col-xs-12 text-left"
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "center",
              }}
            >
              <svg
                width="22"
                height="29"
                viewBox="0 0 22 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.21134 0.20391C9.36956 -0.0158965 9.67603 -0.0657861 9.89584 0.0924335L13.5624 2.7317C13.6906 2.82399 13.7665 2.97242 13.7663 3.13037C13.766 3.28837 13.6897 3.43658 13.5613 3.52852L9.89473 6.15201C9.67444 6.30961 9.36814 6.25879 9.21054 6.03854C9.05294 5.81829 9.10372 5.51195 9.32397 5.35435L11.945 3.47894C10.4028 3.25691 7.47828 3.20149 4.79759 5.19822L4.79657 5.19897C1.09079 7.94458 0.980775 12.235 0.980775 12.707C0.980775 12.9778 0.761235 13.1974 0.490388 13.1974C0.21954 13.1974 0 12.9778 0 12.707C0 12.1675 0.111255 7.45002 4.2122 4.41128C6.84713 2.44889 9.68051 2.27787 11.4751 2.43764L9.32286 0.888405C9.10306 0.730185 9.05312 0.42376 9.21134 0.20391Z"
                  fill="#999999"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.5412 15.5681C21.8115 15.5857 22.0163 15.8191 21.9986 16.0893C21.9491 16.85 21.6052 20.7844 18.2409 23.668L18.2405 23.6683C15.4577 26.0488 12.2531 26.3136 10.3648 26.2142L12.6294 27.8443C12.8492 28.0026 12.8992 28.309 12.741 28.5288C12.5827 28.7486 12.2763 28.7986 12.0565 28.6404L8.38993 26.001C8.26171 25.9088 8.18581 25.7603 8.18604 25.6024C8.18626 25.4444 8.26255 25.2962 8.39104 25.2042L12.0576 22.5808C12.2779 22.4232 12.5842 22.474 12.7418 22.6943C12.8993 22.9145 12.8486 23.2208 12.6283 23.3784L10.0672 25.211C11.7216 25.3501 14.8926 25.2412 17.6027 22.9234C20.6548 20.3072 20.9748 16.7188 21.0199 16.0255C21.0376 15.7553 21.2709 15.5504 21.5412 15.5681Z"
                  fill="#999999"
                />
              </svg>
            </div>
            <div className="col-md-5 col-lg-5 col-xs-12 text-left">
              <label className="">Select vehicle</label>
              <Select
                options={vehicleList}
                value={newVehicle}
                onChange={(selectedOption) => setNewVehicle(selectedOption)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.Trucks}>
        <div>
          {currentSvg &&
            React.createElement(currentSvg, {
              selectedTyre,
              addedTyre,
              handleSelection,
            })}
        </div>
        <div>
          <svg
            width="144"
            height="152"
            viewBox="0 0 144 152"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M60.729 1.0787C61.566 -0.0840942 63.1873 -0.348016 64.3501 0.488984L83.7464 14.451C84.4247 14.9392 84.8262 15.7244 84.825 16.56C84.8239 17.3959 84.42 18.1799 83.7405 18.6662L64.3442 32.5448C63.1788 33.3785 61.5585 33.1097 60.7248 31.9446C59.8911 30.7794 60.1597 29.1589 61.3248 28.3251L75.1905 18.404C67.0322 17.2294 51.5609 16.9362 37.3798 27.4992L37.3744 27.5031C17.7704 42.0277 17.1884 64.7246 17.1884 67.2214C17.1884 68.6539 16.027 69.8156 14.5942 69.8156C13.1614 69.8156 12 68.6539 12 67.2214C12 64.3674 12.5885 39.4115 34.283 23.3362C48.2221 12.9549 63.211 12.0502 72.7044 12.8954L61.319 4.69976C60.1562 3.86276 59.892 2.24174 60.729 1.0787Z"
              fill="#999999"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M125.957 82.3573C127.387 82.4506 128.47 83.6851 128.377 85.1149C128.115 89.1391 126.296 109.952 108.498 125.207L108.496 125.209C93.7744 137.801 76.8218 139.202 66.8327 138.676L78.8127 147.3C79.9755 148.137 80.2397 149.758 79.4027 150.921C78.5657 152.084 76.9444 152.348 75.7816 151.511L56.3853 137.549C55.707 137.061 55.3055 136.275 55.3066 135.44C55.3078 134.604 55.7114 133.82 56.3912 133.334L75.7875 119.455C76.9528 118.622 78.5732 118.89 79.4069 120.056C80.2406 121.221 79.972 122.841 78.8066 123.675L65.258 133.369C74.0103 134.105 90.785 133.529 105.122 121.268C121.268 107.428 122.96 88.4448 123.199 84.7773C123.293 83.3476 124.527 82.264 125.957 82.3573Z"
              fill="#999999"
            />
            <path
              d="M118 15C103.664 15 92 26.6637 92 41C92 55.3363 103.664 67 118 67C132.336 67 144 55.3363 144 41C144 26.6637 132.336 15 118 15ZM118 65.3693C104.563 65.3693 93.6307 54.4373 93.6307 41C93.6307 27.5627 104.563 16.6307 118 16.6307C131.437 16.6307 142.369 27.5627 142.369 41C142.369 54.4373 131.437 65.3693 118 65.3693Z"
              fill="#999999"
            />
            <path
              d="M117.999 24.4426C108.87 24.4426 101.442 31.8703 101.442 40.9999C101.442 50.1295 108.87 57.5573 117.999 57.5573C127.129 57.5573 134.557 50.1295 134.557 40.9999C134.557 31.8703 127.129 24.4426 117.999 24.4426ZM118.815 26.0967C122.317 26.2864 125.501 27.6893 127.955 29.8907L123.062 34.7833C121.878 33.8174 120.416 33.1809 118.815 33.0183V26.0967ZM117.184 26.0967V33.0189C115.582 33.1814 114.119 33.8179 112.935 34.7844L108.043 29.8912C110.497 27.6893 113.682 26.2858 117.184 26.0967ZM106.891 31.0441L111.783 35.9372C110.817 37.1211 110.18 38.5838 110.018 40.1851L103.096 40.1846C103.286 36.6825 104.689 33.4978 106.891 31.0441ZM103.096 41.8153L110.018 41.8158C110.18 43.4171 110.817 44.8799 111.783 46.0632L106.89 50.9557C104.689 48.5021 103.286 45.318 103.096 41.8153ZM117.184 55.9032C113.682 55.7135 110.497 54.3106 108.043 52.1092L112.937 47.2166C114.12 48.1825 115.583 48.8196 117.184 48.9815V55.9032ZM111.607 40.9999C111.607 37.4755 114.474 34.6077 117.999 34.6077C121.524 34.6077 124.391 37.4755 124.391 40.9999C124.391 44.5244 121.524 47.3922 117.999 47.3922C114.475 47.3922 111.607 44.5244 111.607 40.9999ZM118.815 55.9032V48.9815C120.416 48.819 121.879 48.1825 123.063 47.2161L127.955 52.1092C125.501 54.3106 122.317 55.7141 118.815 55.9032ZM129.108 50.9557L124.216 46.0626C125.182 44.8788 125.818 43.4166 125.981 41.8153H132.902C132.713 45.3174 131.31 48.5021 129.108 50.9557ZM125.981 40.1846C125.818 38.5827 125.181 37.12 124.215 35.9362L129.108 31.0436C131.31 33.4978 132.713 36.6825 132.902 40.1846H125.981Z"
              fill="#999999"
            />
            <path
              d="M118 36.38C115.452 36.38 113.379 38.4526 113.379 41.0002C113.379 43.5479 115.452 45.6205 118 45.6205C120.547 45.6205 122.62 43.5479 122.62 41.0002C122.62 38.4526 120.547 36.38 118 36.38ZM118 43.9898C116.352 43.9898 115.01 42.6489 115.01 41.0002C115.01 39.3516 116.352 38.0107 118 38.0107C119.648 38.0107 120.989 39.3516 120.989 41.0002C120.989 42.6489 119.648 43.9898 118 43.9898Z"
              fill="#999999"
            />
            <path
              d="M26 79C11.6637 79 0 90.6637 0 105C0 119.336 11.6637 131 26 131C40.3363 131 52 119.336 52 105C52 90.6637 40.3363 79 26 79ZM26 129.369C12.5627 129.369 1.63067 118.437 1.63067 105C1.63067 91.5627 12.5627 80.6307 26 80.6307C39.4373 80.6307 50.3693 91.5627 50.3693 105C50.3693 118.437 39.4373 129.369 26 129.369Z"
              fill="#999999"
            />
            <path
              d="M25.9992 88.4426C16.8696 88.4426 9.44189 95.8703 9.44189 105C9.44189 114.13 16.8696 121.557 25.9992 121.557C35.1288 121.557 42.5565 114.13 42.5565 105C42.5565 95.8703 35.1288 88.4426 25.9992 88.4426ZM26.8145 90.0967C30.3167 90.2864 33.5014 91.6893 35.955 93.8907L31.0619 98.7833C29.878 97.8174 28.4159 97.1809 26.8145 97.0183V90.0967ZM25.1839 90.0967V97.0189C23.582 97.1814 22.1193 97.8179 20.9354 98.7844L16.0434 93.8912C18.497 91.6893 21.6817 90.2858 25.1839 90.0967ZM14.8905 95.0441L19.7825 99.9372C18.8172 101.121 18.1801 102.584 18.0181 104.185L11.0959 104.185C11.2856 100.682 12.6886 97.4978 14.8905 95.0441ZM11.0959 105.815L18.0176 105.816C18.1801 107.417 18.8172 108.88 19.7831 110.063L14.89 114.956C12.6886 112.502 11.2856 109.318 11.0959 105.815ZM25.1839 119.903C21.6817 119.714 18.497 118.311 16.0434 116.109L20.9365 111.217C22.1204 112.183 23.5826 112.82 25.1839 112.982V119.903ZM19.607 105C19.607 101.476 22.4742 98.6077 25.9992 98.6077C29.5242 98.6077 32.3914 101.476 32.3914 105C32.3914 108.524 29.5236 111.392 25.9992 111.392C22.4748 111.392 19.607 108.524 19.607 105ZM26.8145 119.903V112.982C28.4164 112.819 29.8791 112.183 31.063 111.216L35.955 116.109C33.5014 118.311 30.3167 119.714 26.8145 119.903ZM37.1084 114.956L32.2164 110.063C33.1818 108.879 33.8183 107.417 33.9808 105.815H40.9025C40.7128 109.317 39.3099 112.502 37.1084 114.956ZM33.9808 104.185C33.8183 102.583 33.1812 101.12 32.2153 99.9362L37.1084 95.0436C39.3104 97.4978 40.7133 100.682 40.9025 104.185H33.9808Z"
              fill="#999999"
            />
            <path
              d="M25.9996 100.38C23.452 100.38 21.3794 102.453 21.3794 105C21.3794 107.548 23.452 109.62 25.9996 109.62C28.5473 109.62 30.6199 107.548 30.6199 105C30.6199 102.453 28.5473 100.38 25.9996 100.38ZM25.9996 107.99C24.3516 107.99 23.0101 106.649 23.0101 105C23.0101 103.352 24.3516 102.011 25.9996 102.011C27.6477 102.011 28.9892 103.352 28.9892 105C28.9892 106.649 27.6477 107.99 25.9996 107.99Z"
              fill="#999999"
            />
          </svg>
        </div>
        <div>
          <div>
            {CurrentNewSvg &&
              React.createElement(CurrentNewSvg, {
                selectedNewTyre,
                newAddedTyre,
                handleSelection,
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TyreChange;
